//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param id (optional) 
     * @return OK
     */
    academicYearGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearGetById(_response);
        });
    }

    protected processAcademicYearGetById(response: AxiosResponse): Promise<ApiResponse_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAcademicYear(body: AcademicYearEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAcademicYear(_response);
        });
    }

    protected processSaveAcademicYear(response: AxiosResponse): Promise<ApiResponse_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @return OK
     */
    academicYearGetList( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfAcademicYearEntity> {
        let url_ = this.baseUrl + "/api/v1/academic-year/get-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearGetList(_response);
        });
    }

    protected processAcademicYearGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfAcademicYearEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfAcademicYearEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfAcademicYearEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfAcademicYearEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    academicYearDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/academic-year/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcademicYearDelete(_response);
        });
    }

    protected processAcademicYearDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    register(body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param password (optional) 
     * @param rememberMe (optional) 
     * @param captchaText (optional) 
     * @param captchaToken (optional) 
     * @param captchaInputText (optional) 
     * @return OK
     */
    login(userName: string | undefined, password: string | undefined, rememberMe: boolean | undefined, captchaText: string | undefined, captchaToken: string | undefined, captchaInputText: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName === null || userName === undefined)
            throw new Error("The parameter 'userName' cannot be null.");
        else
            content_.append("UserName", userName.toString());
        if (password === null || password === undefined)
            throw new Error("The parameter 'password' cannot be null.");
        else
            content_.append("Password", password.toString());
        if (rememberMe === null || rememberMe === undefined)
            throw new Error("The parameter 'rememberMe' cannot be null.");
        else
            content_.append("RememberMe", rememberMe.toString());
        if (captchaText === null || captchaText === undefined)
            throw new Error("The parameter 'captchaText' cannot be null.");
        else
            content_.append("CaptchaText", captchaText.toString());
        if (captchaToken === null || captchaToken === undefined)
            throw new Error("The parameter 'captchaToken' cannot be null.");
        else
            content_.append("CaptchaToken", captchaToken.toString());
        if (captchaInputText === null || captchaInputText === undefined)
            throw new Error("The parameter 'captchaInputText' cannot be null.");
        else
            content_.append("CaptchaInputText", captchaInputText.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    captcha( cancelToken?: CancelToken): Promise<DNTCaptchaApiResponse> {
        let url_ = this.baseUrl + "/api/v1/account/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCaptcha(_response);
        });
    }

    protected processCaptcha(response: AxiosResponse): Promise<DNTCaptchaApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DNTCaptchaApiResponse.fromJS(resultData200);
            return Promise.resolve<DNTCaptchaApiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DNTCaptchaApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    refreshToken( cancelToken?: CancelToken): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_1OfRefreshTokenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRefreshTokenResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRefreshTokenResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    loginWith2fa(body: LoginWith2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfLoginResponseDto> {
        let url_ = this.baseUrl + "/api/v1/account/login-with-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginWith2fa(_response);
        });
    }

    protected processLoginWith2fa(response: AxiosResponse): Promise<ApiResponse_1OfLoginResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfLoginResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfLoginResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfLoginResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    userInfo( cancelToken?: CancelToken): Promise<UserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserInfo(_response);
        });
    }

    protected processUserInfo(response: AxiosResponse): Promise<UserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfoDto.fromJS(resultData200);
            return Promise.resolve<UserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changePassword(body: ChangePasswordDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    firstTimeChangePassword(body: FirstTimeChangePasswordDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/first-time-change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFirstTimeChangePassword(_response);
        });
    }

    protected processFirstTimeChangePassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    setup2fa( cancelToken?: CancelToken): Promise<Setup2FADto> {
        let url_ = this.baseUrl + "/api/v1/account/setup-2fa";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetup2fa(_response);
        });
    }

    protected processSetup2fa(response: AxiosResponse): Promise<Setup2FADto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Setup2FADto.fromJS(resultData200);
            return Promise.resolve<Setup2FADto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Setup2FADto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    enable2fa(body: Enable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/enable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnable2fa(_response);
        });
    }

    protected processEnable2fa(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    get2faStatus( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/get-2fa-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet2faStatus(_response);
        });
    }

    protected processGet2faStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    disable2fa(body: Disable2FADto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/disable-2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisable2fa(_response);
        });
    }

    protected processDisable2fa(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateAvatar(body: UpdateAvatarDto | undefined, cancelToken?: CancelToken): Promise<UpdateAvatarDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAvatar(_response);
        });
    }

    protected processUpdateAvatar(response: AxiosResponse): Promise<UpdateAvatarDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateAvatarDto.fromJS(resultData200);
            return Promise.resolve<UpdateAvatarDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateAvatarDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateInfo(body: UpdateInfoDto | undefined, cancelToken?: CancelToken): Promise<UpdateInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/update-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<UpdateInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateInfoDto.fromJS(resultData200);
            return Promise.resolve<UpdateInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param token (optional) 
     * @return OK
     */
    validate(token: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/token/validate?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    checkSession( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckSession(_response);
        });
    }

    protected processCheckSession(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param userName (optional) 
     * @return OK
     */
    checkUsername(userName: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCurrentObjectDto> {
        let url_ = this.baseUrl + "/api/v1/account/check-username?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUsername(_response);
        });
    }

    protected processCheckUsername(response: AxiosResponse): Promise<ApiResponse_1OfCurrentObjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCurrentObjectDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    checkFogotPasswordOtp(body: ForgotPasswordCheckOTPResource | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfObject> {
        let url_ = this.baseUrl + "/api/v1/account/check-fogot-password-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckFogotPasswordOtp(_response);
        });
    }

    protected processCheckFogotPasswordOtp(response: AxiosResponse): Promise<ApiResponse_1OfObject> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfObject.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfObject>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfObject>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param captcha (optional) 
     * @return OK
     */
    resendOtp(userName: string | undefined, captcha: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCurrentObjectDto> {
        let url_ = this.baseUrl + "/api/v1/account/resend-otp?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (captcha === null)
            throw new Error("The parameter 'captcha' cannot be null.");
        else if (captcha !== undefined)
            url_ += "captcha=" + encodeURIComponent("" + captcha) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendOtp(_response);
        });
    }

    protected processResendOtp(response: AxiosResponse): Promise<ApiResponse_1OfCurrentObjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCurrentObjectDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCurrentObjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    forgotPassword(body: ResetPasswordByUserNameResource | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userGetList(body: UserGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetList(_response);
        });
    }

    protected processUserGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    userGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfRegisterDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetById(_response);
        });
    }

    protected processUserGetById(response: AxiosResponse): Promise<ApiResponse_1OfRegisterDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRegisterDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRegisterDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRegisterDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    userGetPermission(userId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfObjectPermissionDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-permission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetPermission(_response);
        });
    }

    protected processUserGetPermission(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfObjectPermissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfObjectPermissionDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfObjectPermissionDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfObjectPermissionDto>(null as any);
    }

    /**
     * @param isRessPass (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdate(isRessPass: boolean | undefined, body: RegisterDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update?";
        if (isRessPass === null)
            throw new Error("The parameter 'isRessPass' cannot be null.");
        else if (isRessPass !== undefined)
            url_ += "isRessPass=" + encodeURIComponent("" + isRessPass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdate(_response);
        });
    }

    protected processUserUpdate(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    userUpdatePermisson(userId: number | undefined, body: ObjectPermissionDto[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-permission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdatePermisson(_response);
        });
    }

    protected processUserUpdatePermisson(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userUpdateEmail(body: ChangeEmailDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/update-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserUpdateEmail(_response);
        });
    }

    protected processUserUpdateEmail(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    accountDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/account/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAccountDelete(_response);
        });
    }

    protected processAccountDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    userGetListByType(type: UserTypeEnum | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        let url_ = this.baseUrl + "/api/v1/account/get-list-by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserGetListByType(_response);
        });
    }

    protected processUserGetListByType(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfUserWithSimpleInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfUserWithSimpleInfoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfUserWithSimpleInfoDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addActivityLog(body: ActivityLogEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfActivityLogEntity> {
        let url_ = this.baseUrl + "/api/v1/activity-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddActivityLog(_response);
        });
    }

    protected processAddActivityLog(response: AxiosResponse): Promise<ApiResponse_1OfActivityLogEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfActivityLogEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfActivityLogEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfActivityLogEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    activityLogGetList(body: GetListLogQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        let url_ = this.baseUrl + "/api/v1/activity-log/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivityLogGetList(_response);
        });
    }

    protected processActivityLogGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListActivityLogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListActivityLogDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListActivityLogDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bankAccountGetList(body: BankAccountGetListQuery | undefined, cancelToken?: CancelToken): Promise<BankAccountEntity[]> {
        let url_ = this.baseUrl + "/api/v1/bank-account/get_list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankAccountGetList(_response);
        });
    }

    protected processBankAccountGetList(response: AxiosResponse): Promise<BankAccountEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<BankAccountEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankAccountEntity[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    bankAccountGetById(id: number | undefined, cancelToken?: CancelToken): Promise<BankAccountEntity> {
        let url_ = this.baseUrl + "/api/v1/bank-account/get_by_id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankAccountGetById(_response);
        });
    }

    protected processBankAccountGetById(response: AxiosResponse): Promise<BankAccountEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BankAccountEntity.fromJS(resultData200);
            return Promise.resolve<BankAccountEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankAccountEntity>(null as any);
    }

    /**
     * @return OK
     */
    bankAccountGetDefault( cancelToken?: CancelToken): Promise<BankAccountEntity> {
        let url_ = this.baseUrl + "/api/v1/bank-account/get_default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankAccountGetDefault(_response);
        });
    }

    protected processBankAccountGetDefault(response: AxiosResponse): Promise<BankAccountEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BankAccountEntity.fromJS(resultData200);
            return Promise.resolve<BankAccountEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankAccountEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bankAccountSave(body: BankAccountEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/bank-account/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankAccountSave(_response);
        });
    }

    protected processBankAccountSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    bankAccountDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/bank-account/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBankAccountDelete(_response);
        });
    }

    protected processBankAccountDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    generateQr(body: QrGenerateQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfQrGenerateResponseDto> {
        let url_ = this.baseUrl + "/api/v1/bank-account/generate_qr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateQr(_response);
        });
    }

    protected processGenerateQr(response: AxiosResponse): Promise<ApiResponse_1OfQrGenerateResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfQrGenerateResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfQrGenerateResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfQrGenerateResponseDto>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh/refresh?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshGET(_response);
        });
    }

    protected processRefreshGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    refreshPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/refresh/refresh?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshPOST(_response);
        });
    }

    protected processRefreshPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showGET(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show/show?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowGET(_response);
        });
    }

    protected processShowGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param data (optional) 
     * @return OK
     */
    showPOST(data: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha/show/show?";
        if (data === null)
            throw new Error("The parameter 'data' cannot be null.");
        else if (data !== undefined)
            url_ += "data=" + encodeURIComponent("" + data) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShowPOST(_response);
        });
    }

    protected processShowPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    categoryGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetById(_response);
        });
    }

    protected processCategoryGetById(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveCategory(body: CategoryEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfCategoryEntity> {
        let url_ = this.baseUrl + "/api/v1/category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCategory(_response);
        });
    }

    protected processSaveCategory(response: AxiosResponse): Promise<ApiResponse_1OfCategoryEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfCategoryEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfCategoryEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfCategoryEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    categoryGetList(body: CategoryGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        let url_ = this.baseUrl + "/api/v1/category/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryGetList(_response);
        });
    }

    protected processCategoryGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfCategoryListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfCategoryListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfCategoryListDto>(null as any);
    }

    /**
     * @return OK
     */
    categoryDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/category/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCategoryDelete(_response);
        });
    }

    protected processCategoryDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    listChatGroupOfUser(keyword: string | undefined, pageIndex: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/list-chat-group-of-user?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListChatGroupOfUser(_response);
        });
    }

    protected processListChatGroupOfUser(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createChatGroup(body: CreateChatGroupDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroup(_response);
        });
    }

    protected processCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @return OK
     */
    getDetailChatGroup(chatGroupId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupDetailDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-detail-chat-group?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetailChatGroup(_response);
        });
    }

    protected processGetDetailChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupDetailDto>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param skipSize (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getListMessageByChatGroupId(chatGroupId: number | undefined, skipSize: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-message-by-groupid?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        if (skipSize === null)
            throw new Error("The parameter 'skipSize' cannot be null.");
        else if (skipSize !== undefined)
            url_ += "skipSize=" + encodeURIComponent("" + skipSize) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListMessageByChatGroupId(_response);
        });
    }

    protected processGetListMessageByChatGroupId(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getListUserForCreateChatGroup(body: GetListUserForCreateChatGroupQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        let url_ = this.baseUrl + "/api/v1/chat/get-list-user-for-create-chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListUserForCreateChatGroup(_response);
        });
    }

    protected processGetListUserForCreateChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfUserListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfUserListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfUserListDto>(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return OK
     */
    createChatGroupOfDocument(documentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfChatGroupEntity> {
        let url_ = this.baseUrl + "/api/v1/chat/create-chat-group-of-document?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateChatGroupOfDocument(_response);
        });
    }

    protected processCreateChatGroupOfDocument(response: AxiosResponse): Promise<ApiResponse_1OfChatGroupEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfChatGroupEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfChatGroupEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfChatGroupEntity>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @param body (optional) 
     * @return OK
     */
    addUserToChatGroup(chatGroupId: number | undefined, body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/chat/add-user-to-chat-group?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToChatGroup(_response);
        });
    }

    protected processAddUserToChatGroup(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param chatGroupId (optional) 
     * @return OK
     */
    updateMessageUnRead(chatGroupId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/chat/update-message-un-read?";
        if (chatGroupId === null)
            throw new Error("The parameter 'chatGroupId' cannot be null.");
        else if (chatGroupId !== undefined)
            url_ += "chatGroupId=" + encodeURIComponent("" + chatGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMessageUnRead(_response);
        });
    }

    protected processUpdateMessageUnRead(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classGetList(body: ClassGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfClassListDto> {
        let url_ = this.baseUrl + "/api/v1/class/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetList(_response);
        });
    }

    protected processClassGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfClassListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfClassListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfClassListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfClassListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    classGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfClassDetailDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetById(_response);
        });
    }

    protected processClassGetById(response: AxiosResponse): Promise<ApiResponse_1OfClassDetailDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfClassDetailDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfClassDetailDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfClassDetailDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classSave(body: ClassEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/class/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassSave(_response);
        });
    }

    protected processClassSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    classDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassDelete(_response);
        });
    }

    protected processClassDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classChangeClass(body: ClassChangeClassCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/change-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassChangeClass(_response);
        });
    }

    protected processClassChangeClass(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classAddListUser(body: ClassAddListUserCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/add-list-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAddListUser(_response);
        });
    }

    protected processClassAddListUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classAddTeacher(body: ClassUserEntity[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/add-teacher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassAddTeacher(_response);
        });
    }

    protected processClassAddTeacher(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classRemoveUser(body: ClassRemoveUserCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/remove-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassRemoveUser(_response);
        });
    }

    protected processClassRemoveUser(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    classUpdateStatusUser(body: ClassUpdateStatusUserCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/class/update-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassUpdateStatusUser(_response);
        });
    }

    protected processClassUpdateStatusUser(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getStudentInClass(body: StudentFilterDto | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfStudentListDto> {
        let url_ = this.baseUrl + "/api/v1/class/get-student-in-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentInClass(_response);
        });
    }

    protected processGetStudentInClass(response: AxiosResponse): Promise<FilterResult_1OfStudentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfStudentListDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfStudentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfStudentListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @return OK
     */
    studentExport(classId: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/student-export?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentExport(_response);
        });
    }

    protected processStudentExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    dowloadTempTeacher( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/template-import-teacher";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDowloadTempTeacher(_response);
        });
    }

    protected processDowloadTempTeacher(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    dowloadTempStudent( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/template-import-student";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDowloadTempStudent(_response);
        });
    }

    protected processDowloadTempStudent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param file (optional) 
     * @return OK
     */
    importStudent(classId: number | undefined, file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/import-student?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportStudent(_response);
        });
    }

    protected processImportStudent(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentChangePassword(body: StudentChangePasswordCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/student-change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentChangePassword(_response);
        });
    }

    protected processStudentChangePassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentAddMulti(body: StudentAddMultiCommand | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/class/student-add-multi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentAddMulti(_response);
        });
    }

    protected processStudentAddMulti(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @return OK
     */
    getClassOfStudent(studentId: number | undefined, cancelToken?: CancelToken): Promise<ClassEntity[]> {
        let url_ = this.baseUrl + "/api/v1/class/class-of-student?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClassOfStudent(_response);
        });
    }

    protected processGetClassOfStudent(response: AxiosResponse): Promise<ClassEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClassEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassEntity[]>(null as any);
    }

    /**
     * @param schoolId (optional) 
     * @param userId (optional) 
     * @return OK
     */
    classGetByUser(schoolId: number | undefined, userId: number | undefined, cancelToken?: CancelToken): Promise<ClassByUserDto[]> {
        let url_ = this.baseUrl + "/api/v1/class/class-get-by-user?";
        if (schoolId === null)
            throw new Error("The parameter 'schoolId' cannot be null.");
        else if (schoolId !== undefined)
            url_ += "schoolId=" + encodeURIComponent("" + schoolId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClassGetByUser(_response);
        });
    }

    protected processClassGetByUser(response: AxiosResponse): Promise<ClassByUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClassByUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ClassByUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClassByUserDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentCopyFromClass(body: StudentCopyFromClassCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/class/student-copy-from-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentCopyFromClass(_response);
        });
    }

    protected processStudentCopyFromClass(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentScoreGetList(body: ComponentScoreGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfComponentScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/component-score/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentScoreGetList(_response);
        });
    }

    protected processComponentScoreGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfComponentScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfComponentScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfComponentScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfComponentScoreListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param subjectId (optional) 
     * @param academicYearId (optional) 
     * @param semester (optional) 
     * @return OK
     */
    componentScoreGetByClassSubject(classId: number | undefined, subjectId: number | undefined, academicYearId: number | undefined, semester: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfComponentScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/component-score/get-by-class-subject?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (academicYearId === null)
            throw new Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        if (semester === null)
            throw new Error("The parameter 'semester' cannot be null.");
        else if (semester !== undefined)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentScoreGetByClassSubject(_response);
        });
    }

    protected processComponentScoreGetByClassSubject(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfComponentScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfComponentScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfComponentScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfComponentScoreListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentScoreSave(body: ComponentScoreEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/component-score/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentScoreSave(_response);
        });
    }

    protected processComponentScoreSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    componentScoreBatchSave(body: ComponentScoreBatchSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/component-score/batch-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentScoreBatchSave(_response);
        });
    }

    protected processComponentScoreBatchSave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    componentScoreDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/component-score/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processComponentScoreDelete(_response);
        });
    }

    protected processComponentScoreDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    conductScoreGetList(body: ConductScoreGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfConductScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/conduct-score/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConductScoreGetList(_response);
        });
    }

    protected processConductScoreGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfConductScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfConductScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfConductScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfConductScoreListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param academicYearId (optional) 
     * @param semester (optional) 
     * @return OK
     */
    conductScoreGetByClass(classId: number | undefined, academicYearId: number | undefined, semester: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfConductScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/conduct-score/get-by-class?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (academicYearId === null)
            throw new Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        if (semester === null)
            throw new Error("The parameter 'semester' cannot be null.");
        else if (semester !== undefined)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConductScoreGetByClass(_response);
        });
    }

    protected processConductScoreGetByClass(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfConductScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfConductScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfConductScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfConductScoreListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    conductScoreBatchSave(body: ConductScoreBatchSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/conduct-score/batch-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConductScoreBatchSave(_response);
        });
    }

    protected processConductScoreBatchSave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    conductScoreDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/conduct-score/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConductScoreDelete(_response);
        });
    }

    protected processConductScoreDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param searchTerm (optional) 
     * @param groupType (optional) 
     * @return OK
     */
    configGetList(pageIndex: number | undefined, pageSize: number | undefined, searchTerm: string | undefined, groupType: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfConfigEntity> {
        let url_ = this.baseUrl + "/api/v1/config/list?";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (groupType === null)
            throw new Error("The parameter 'groupType' cannot be null.");
        else if (groupType !== undefined)
            url_ += "GroupType=" + encodeURIComponent("" + groupType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigGetList(_response);
        });
    }

    protected processConfigGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfConfigEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfConfigEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfConfigEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfConfigEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    configGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfConfigEntity> {
        let url_ = this.baseUrl + "/api/v1/config/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigGetById(_response);
        });
    }

    protected processConfigGetById(response: AxiosResponse): Promise<ApiResponse_1OfConfigEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfConfigEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfConfigEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfConfigEntity>(null as any);
    }

    /**
     * @return OK
     */
    configGetGroupTypes( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfString> {
        let url_ = this.baseUrl + "/api/v1/config/group-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigGetGroupTypes(_response);
        });
    }

    protected processConfigGetGroupTypes(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfString.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfString>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    configCreate(body: CreateConfigDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfConfigEntity> {
        let url_ = this.baseUrl + "/api/v1/config/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigCreate(_response);
        });
    }

    protected processConfigCreate(response: AxiosResponse): Promise<ApiResponse_1OfConfigEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfConfigEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfConfigEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfConfigEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return OK
     */
    configUpdate(id: number | undefined, body: UpdateConfigDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfConfigEntity> {
        let url_ = this.baseUrl + "/api/v1/config/update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigUpdate(_response);
        });
    }

    protected processConfigUpdate(response: AxiosResponse): Promise<ApiResponse_1OfConfigEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfConfigEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfConfigEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfConfigEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    configDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/config/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfigDelete(_response);
        });
    }

    protected processConfigDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param academicYearId (optional) 
     * @return OK
     */
    dashboardStudentStatus(academicYearId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfDashboardStudentStatusDto> {
        let url_ = this.baseUrl + "/api/v1/dashboard/student-status?";
        if (academicYearId === null)
            throw new Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDashboardStudentStatus(_response);
        });
    }

    protected processDashboardStudentStatus(response: AxiosResponse): Promise<ApiResponse_1OfDashboardStudentStatusDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfDashboardStudentStatusDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfDashboardStudentStatusDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfDashboardStudentStatusDto>(null as any);
    }

    /**
     * @return OK
     */
    feeScheduleGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfFeeScheduleEntity> {
        let url_ = this.baseUrl + "/api/v1/fee-schedule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeeScheduleGetById(_response);
        });
    }

    protected processFeeScheduleGetById(response: AxiosResponse): Promise<ApiResponse_1OfFeeScheduleEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFeeScheduleEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFeeScheduleEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFeeScheduleEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveFeeSchedule(body: FeeScheduleEntity[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFeeScheduleEntity> {
        let url_ = this.baseUrl + "/api/v1/fee-schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveFeeSchedule(_response);
        });
    }

    protected processSaveFeeSchedule(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFeeScheduleEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFeeScheduleEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFeeScheduleEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFeeScheduleEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    feeScheduleGetList(body: FeeScheduleGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFeeScheduleEntity> {
        let url_ = this.baseUrl + "/api/v1/fee-schedule/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeeScheduleGetList(_response);
        });
    }

    protected processFeeScheduleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFeeScheduleEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFeeScheduleEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFeeScheduleEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFeeScheduleEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    feeScheduleGetCurrent(body: FeeScheduleCurrentQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFeeScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/fee-schedule/list-current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeeScheduleGetCurrent(_response);
        });
    }

    protected processFeeScheduleGetCurrent(response: AxiosResponse): Promise<ApiResponse_1OfFeeScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFeeScheduleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFeeScheduleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFeeScheduleDto>(null as any);
    }

    /**
     * @return OK
     */
    feeScheduleDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/fee-schedule/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeeScheduleDelete(_response);
        });
    }

    protected processFeeScheduleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    fileGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetById(_response);
        });
    }

    protected processFileGetById(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    fileGetMetaById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        let url_ = this.baseUrl + "/api/v1/file/get-meta?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetMetaById(_response);
        });
    }

    protected processFileGetMetaById(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFileMetaDataEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFileMetaDataEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFileMetaDataEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdate(body: FileUpdateCommand | undefined, cancelToken?: CancelToken): Promise<FileEntity> {
        let url_ = this.baseUrl + "/api/v1/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdate(_response);
        });
    }

    protected processFileUpdate(response: AxiosResponse): Promise<FileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileEntity.fromJS(resultData200);
            return Promise.resolve<FileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateAvatar(body: FileUpdateAvatarCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateAvatar(_response);
        });
    }

    protected processFileUpdateAvatar(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateName(body: FileUpdateNameCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateName(_response);
        });
    }

    protected processFileUpdateName(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileUpdateStatus(body: FileUpdateStatusCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/file/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileUpdateStatus(_response);
        });
    }

    protected processFileUpdateStatus(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileGetList(body: FileGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        let url_ = this.baseUrl + "/api/v1/file/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFileGetList(_response);
        });
    }

    protected processFileGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfFileEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfFileEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfFileEntity>(null as any);
    }

    /**
     * @param request (optional) 
     * @return OK
     */
    folderGetAll(request: FolderGetAllQuery | undefined, cancelToken?: CancelToken): Promise<FolderEntity[]> {
        let url_ = this.baseUrl + "/api/v1/file/folder-all?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetAll(_response);
        });
    }

    protected processFolderGetAll(response: AxiosResponse): Promise<FolderEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FolderEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FolderEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity[]>(null as any);
    }

    /**
     * @param idQuery (optional) 
     * @return OK
     */
    folderGetById(idQuery: number | undefined, idPath: string, cancelToken?: CancelToken): Promise<FolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder/{id}?";
        if (idPath === undefined || idPath === null)
            throw new Error("The parameter 'idPath' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + idPath));
        if (idQuery === null)
            throw new Error("The parameter 'idQuery' cannot be null.");
        else if (idQuery !== undefined)
            url_ += "Id=" + encodeURIComponent("" + idQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetById(_response);
        });
    }

    protected processFolderGetById(response: AxiosResponse): Promise<FolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FolderEntity.fromJS(resultData200);
            return Promise.resolve<FolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderUpdate(body: FolderUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFolderEntity> {
        let url_ = this.baseUrl + "/api/v1/file/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderUpdate(_response);
        });
    }

    protected processFolderUpdate(response: AxiosResponse): Promise<ApiResponse_1OfFolderEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFolderEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFolderEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFolderEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderGetList(body: FolderGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        let url_ = this.baseUrl + "/api/v1/file/folder/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderGetList(_response);
        });
    }

    protected processFolderGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfFolderNodeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfFolderNodeDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfFolderNodeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    folderDelete(body: FolderDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/file/folder/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFolderDelete(_response);
        });
    }

    protected processFolderDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param url (optional) 
     * @return OK
     */
    uploadByUrl(url: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        let url_ = this.baseUrl + "/api/v1/file/file/upload-by-url?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadByUrl(_response);
        });
    }

    protected processUploadByUrl(response: AxiosResponse): Promise<ApiResponse_1OfFileUploadByUrlResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFileUploadByUrlResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFileUploadByUrlResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localityGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetByIds(_response);
        });
    }

    protected processLocalityGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfLocalityEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    localityGetList(body: LocalityGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        let url_ = this.baseUrl + "/api/v1/locality/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocalityGetList(_response);
        });
    }

    protected processLocalityGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfLocalityEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfLocalityEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfLocalityEntity>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getNotifications(page: number | undefined, pageSize: number | undefined, cancelToken?: CancelToken): Promise<FilterResult_1OfNotificationDto> {
        let url_ = this.baseUrl + "/api/v1/notification/list?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: AxiosResponse): Promise<FilterResult_1OfNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResult_1OfNotificationDto.fromJS(resultData200);
            return Promise.resolve<FilterResult_1OfNotificationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResult_1OfNotificationDto>(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAsRead(notificationId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/notification/{notificationId}/mark-as-read";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationMarkAsRead(_response);
        });
    }

    protected processNotificationMarkAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    notificationMarkAllAsRead( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/notification/mark-all-as-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationMarkAllAsRead(_response);
        });
    }

    protected processNotificationMarkAllAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    notificationCountUnRead( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/notification/count-un-read";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationCountUnRead(_response);
        });
    }

    protected processNotificationCountUnRead(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    webhook(body: SePayNotifyDto | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/public/payment/sepay/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWebhook(_response);
        });
    }

    protected processWebhook(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    permissionGetModules( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        let url_ = this.baseUrl + "/api/v1/permission/modules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPermissionGetModules(_response);
        });
    }

    protected processPermissionGetModules(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfEnumListEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(null as any);
    }

    /**
     * @param module (optional) 
     * @param permission (optional) 
     * @param tenantId (optional) 
     * @return OK
     */
    permissionGetUsersByPermission(module: ModuleEnum | undefined, permission: PermissionEnum | undefined, tenantId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPermissionUsersDto> {
        let url_ = this.baseUrl + "/api/v1/permission/users-by-permission?";
        if (module === null)
            throw new Error("The parameter 'module' cannot be null.");
        else if (module !== undefined)
            url_ += "module=" + encodeURIComponent("" + module) + "&";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPermissionGetUsersByPermission(_response);
        });
    }

    protected processPermissionGetUsersByPermission(response: AxiosResponse): Promise<ApiResponse_1OfPermissionUsersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPermissionUsersDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPermissionUsersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPermissionUsersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    permissionAddUser(body: PermissionAddUserDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/permission/add-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPermissionAddUser(_response);
        });
    }

    protected processPermissionAddUser(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    permissionRemoveUser(body: PermissionRemoveUserDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/permission/remove-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPermissionRemoveUser(_response);
        });
    }

    protected processPermissionRemoveUser(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    receiptGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfReceiptEntity> {
        let url_ = this.baseUrl + "/api/v1/receipt/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptGetById(_response);
        });
    }

    protected processReceiptGetById(response: AxiosResponse): Promise<ApiResponse_1OfReceiptEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfReceiptEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfReceiptEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfReceiptEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveReceipt(body: ReceiptEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfReceiptDto> {
        let url_ = this.baseUrl + "/api/v1/receipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveReceipt(_response);
        });
    }

    protected processSaveReceipt(response: AxiosResponse): Promise<ApiResponse_1OfReceiptDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfReceiptDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfReceiptDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfReceiptDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchPreviewReceipt(body: ReceiptBatchCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto> {
        let url_ = this.baseUrl + "/api/v1/receipt/batch/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchPreviewReceipt(_response);
        });
    }

    protected processBatchPreviewReceipt(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchCreateReceipt(body: ReceiptBatchCreateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfReceiptBatchCreateResultDto> {
        let url_ = this.baseUrl + "/api/v1/receipt/batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchCreateReceipt(_response);
        });
    }

    protected processBatchCreateReceipt(response: AxiosResponse): Promise<ApiResponse_1OfReceiptBatchCreateResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfReceiptBatchCreateResultDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfReceiptBatchCreateResultDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfReceiptBatchCreateResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    receiptGetList(body: ReceiptGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfReceiptListDto> {
        let url_ = this.baseUrl + "/api/v1/receipt/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptGetList(_response);
        });
    }

    protected processReceiptGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfReceiptListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfReceiptListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfReceiptListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfReceiptListDto>(null as any);
    }

    /**
     * @return OK
     */
    receiptDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/receipt/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptDelete(_response);
        });
    }

    protected processReceiptDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getPaymentTracking(body: PaymentTrackingQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfPaymentTrackingDto> {
        let url_ = this.baseUrl + "/api/v1/receipt/payment-tracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentTracking(_response);
        });
    }

    protected processGetPaymentTracking(response: AxiosResponse): Promise<ApiResponse_1OfPaymentTrackingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfPaymentTrackingDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfPaymentTrackingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfPaymentTrackingDto>(null as any);
    }

    /**
     * @return OK
     */
    receiptCheckPayment( cancelToken?: CancelToken): Promise<ReceiptEntity[]> {
        let url_ = this.baseUrl + "/api/v1/receipt/check-payment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptCheckPayment(_response);
        });
    }

    protected processReceiptCheckPayment(response: AxiosResponse): Promise<ReceiptEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReceiptEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReceiptEntity[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReceiptEntity[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    receiptUpdatePaymentNotify(body: number[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/receipt/update-payment-notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReceiptUpdatePaymentNotify(_response);
        });
    }

    protected processReceiptUpdatePaymentNotify(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    roleSave(body: RoleDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/role/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleSave(_response);
        });
    }

    protected processRoleSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @return OK
     */
    roleGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetById(_response);
        });
    }

    protected processRoleGetById(response: AxiosResponse): Promise<ApiResponse_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfRoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return OK
     */
    roleGetList(keyword: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfRoleDto> {
        let url_ = this.baseUrl + "/api/v1/role/list?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetList(_response);
        });
    }

    protected processRoleGetList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfRoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfRoleDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfRoleDto>(null as any);
    }

    /**
     * @return OK
     */
    getListModule( cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        let url_ = this.baseUrl + "/api/v1/role/list-module";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListModule(_response);
        });
    }

    protected processGetListModule(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfEnumListEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfEnumListEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfEnumListEntity>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    roleDelete(id: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/role/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleDelete(_response);
        });
    }

    protected processRoleDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    scholarShipGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfScholarShipEntity> {
        let url_ = this.baseUrl + "/api/v1/scholar-ship/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScholarShipGetById(_response);
        });
    }

    protected processScholarShipGetById(response: AxiosResponse): Promise<ApiResponse_1OfScholarShipEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfScholarShipEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfScholarShipEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfScholarShipEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveScholarShip(body: ScholarShipEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/scholar-ship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveScholarShip(_response);
        });
    }

    protected processSaveScholarShip(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scholarShipGetList(body: ScholarShipGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfScholarShipEntity> {
        let url_ = this.baseUrl + "/api/v1/scholar-ship/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScholarShipGetList(_response);
        });
    }

    protected processScholarShipGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfScholarShipEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfScholarShipEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfScholarShipEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfScholarShipEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scholarShipGetCurrent(body: ScholarShipCurrentQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfScholarShipEntity> {
        let url_ = this.baseUrl + "/api/v1/scholar-ship/list-current";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScholarShipGetCurrent(_response);
        });
    }

    protected processScholarShipGetCurrent(response: AxiosResponse): Promise<ApiResponse_1OfScholarShipEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfScholarShipEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfScholarShipEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfScholarShipEntity>(null as any);
    }

    /**
     * @return OK
     */
    scholarShipDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/scholar-ship/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScholarShipDelete(_response);
        });
    }

    protected processScholarShipDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    seedGradeData( cancelToken?: CancelToken): Promise<ApiResponse_1OfSeedResult> {
        let url_ = this.baseUrl + "/api/v1/seed/grade-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSeedGradeData(_response);
        });
    }

    protected processSeedGradeData(response: AxiosResponse): Promise<ApiResponse_1OfSeedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSeedResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSeedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSeedResult>(null as any);
    }

    /**
     * @return OK
     */
    resetGradeData( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/seed/reset-grade-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetGradeData(_response);
        });
    }

    protected processResetGradeData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentGetList(body: StudentGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfStudentListDto> {
        let url_ = this.baseUrl + "/api/v1/student/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentGetList(_response);
        });
    }

    protected processStudentGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfStudentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfStudentListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentStatusStatistics(body: StudentStatusStatisticsQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/student/status-statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentStatusStatistics(_response);
        });
    }

    protected processStudentStatusStatistics(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentStatusStatisticsExport(body: StudentStatusStatisticsQuery | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/student/status-statistics-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentStatusStatisticsExport(_response);
        });
    }

    protected processStudentStatusStatisticsExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentStatusStatisticsSummary(body: StudentStatusStatisticsSummaryQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto> {
        let url_ = this.baseUrl + "/api/v1/student/status-statistics-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentStatusStatisticsSummary(_response);
        });
    }

    protected processStudentStatusStatisticsSummary(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentStatusStatisticsSummaryExport(body: StudentStatusStatisticsSummaryQuery | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/student/status-statistics-summary-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentStatusStatisticsSummaryExport(_response);
        });
    }

    protected processStudentStatusStatisticsSummaryExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentListByStatusMonth(body: StudentListByStatusMonthQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto> {
        let url_ = this.baseUrl + "/api/v1/student/list-by-status-month";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentListByStatusMonth(_response);
        });
    }

    protected processStudentListByStatusMonth(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentListByStatusMonthExport(body: StudentListByStatusMonthQuery | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/student/list-by-status-month-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentListByStatusMonthExport(_response);
        });
    }

    protected processStudentListByStatusMonthExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    studentGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentListDto> {
        let url_ = this.baseUrl + "/api/v1/student/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentGetById(_response);
        });
    }

    protected processStudentGetById(response: AxiosResponse): Promise<ApiResponse_1OfStudentListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentListDto>(null as any);
    }

    /**
     * @param guidId (optional) 
     * @return OK
     */
    studentGetByGuidId(guidId: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentEntity> {
        let url_ = this.baseUrl + "/api/v1/student/get-by-guidid?";
        if (guidId === null)
            throw new Error("The parameter 'guidId' cannot be null.");
        else if (guidId !== undefined)
            url_ += "guidId=" + encodeURIComponent("" + guidId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentGetByGuidId(_response);
        });
    }

    protected processStudentGetByGuidId(response: AxiosResponse): Promise<ApiResponse_1OfStudentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveStudent(body: StudentListDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentEntity> {
        let url_ = this.baseUrl + "/api/v1/student";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveStudent(_response);
        });
    }

    protected processSaveStudent(response: AxiosResponse): Promise<ApiResponse_1OfStudentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    parentSaveStudent(body: StudentEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentEntity> {
        let url_ = this.baseUrl + "/api/v1/student/parent-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParentSaveStudent(_response);
        });
    }

    protected processParentSaveStudent(response: AxiosResponse): Promise<ApiResponse_1OfStudentEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentEntity>(null as any);
    }

    /**
     * @return OK
     */
    studentDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentDelete(_response);
        });
    }

    protected processStudentDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    studentSendAccounting(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/send-accounting?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentSendAccounting(_response);
        });
    }

    protected processStudentSendAccounting(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    studentSendAdmissions(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/send-admissions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentSendAdmissions(_response);
        });
    }

    protected processStudentSendAdmissions(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    studentAdmissionConfirm(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/admission-confirm?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentAdmissionConfirm(_response);
        });
    }

    protected processStudentAdmissionConfirm(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param note (optional) 
     * @return OK
     */
    studentReturned(id: number | undefined, note: string | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/returned?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentReturned(_response);
        });
    }

    protected processStudentReturned(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    studentApprove(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/approve?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentApprove(_response);
        });
    }

    protected processStudentApprove(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentSupplemented(body: StudentListDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/supplemented";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentSupplemented(_response);
        });
    }

    protected processStudentSupplemented(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @return OK
     */
    getStudentDocumentList(studentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStudentDocumentDto> {
        let url_ = this.baseUrl + "/api/v1/student/document-list?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStudentDocumentList(_response);
        });
    }

    protected processGetStudentDocumentList(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStudentDocumentDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStudentDocumentDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStudentDocumentDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStudentDocumentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateStudentDocument(body: StudentDocumentUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/student/document-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStudentDocument(_response);
        });
    }

    protected processUpdateStudentDocument(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    importExcel(body: Blob | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentBulkImportResult> {
        let url_ = this.baseUrl + "/api/v1/student/import-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: AxiosResponse): Promise<ApiResponse_1OfStudentBulkImportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentBulkImportResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentBulkImportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentBulkImportResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    studentBulkImport(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentBulkImportResult> {
        let url_ = this.baseUrl + "/api/v1/student/bulk-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentBulkImport(_response);
        });
    }

    protected processStudentBulkImport(response: AxiosResponse): Promise<ApiResponse_1OfStudentBulkImportResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentBulkImportResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentBulkImportResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentBulkImportResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    studentBulkImportAdvanced(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentBulkImportAdvancedResult> {
        let url_ = this.baseUrl + "/api/v1/student/bulk-import-advanced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentBulkImportAdvanced(_response);
        });
    }

    protected processStudentBulkImportAdvanced(response: AxiosResponse): Promise<ApiResponse_1OfStudentBulkImportAdvancedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentBulkImportAdvancedResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentBulkImportAdvancedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentBulkImportAdvancedResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    studentBulkImportFull(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentBulkImportFullResult> {
        let url_ = this.baseUrl + "/api/v1/student/bulk-import-full";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentBulkImportFull(_response);
        });
    }

    protected processStudentBulkImportFull(response: AxiosResponse): Promise<ApiResponse_1OfStudentBulkImportFullResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentBulkImportFullResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentBulkImportFullResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentBulkImportFullResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    studentBulkImportV2(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentBulkImportV2Result> {
        let url_ = this.baseUrl + "/api/v1/student/bulk-import-v2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentBulkImportV2(_response);
        });
    }

    protected processStudentBulkImportV2(response: AxiosResponse): Promise<ApiResponse_1OfStudentBulkImportV2Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentBulkImportV2Result.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentBulkImportV2Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentBulkImportV2Result>(null as any);
    }

    /**
     * @return OK
     */
    exportTemplate( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/student/export-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplate(_response);
        });
    }

    protected processExportTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    exportTemplateAdvanced( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/student/export-template-advanced";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplateAdvanced(_response);
        });
    }

    protected processExportTemplateAdvanced(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    exportTemplateFull( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/student/export-template-full";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTemplateFull(_response);
        });
    }

    protected processExportTemplateFull(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    exportGoogleWorkspaceCsv( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/student/export-google-workspace-csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportGoogleWorkspaceCsv(_response);
        });
    }

    protected processExportGoogleWorkspaceCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    studentExportExcel(body: StudentGetListQuery | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/student/export-excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentExportExcel(_response);
        });
    }

    protected processStudentExportExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @param isFull (optional) 
     * @return OK
     */
    changeDocumentStatus(studentId: number | undefined, isFull: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/change-document-status?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (isFull === null)
            throw new Error("The parameter 'isFull' cannot be null.");
        else if (isFull !== undefined)
            url_ += "isFull=" + encodeURIComponent("" + isFull) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeDocumentStatus(_response);
        });
    }

    protected processChangeDocumentStatus(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    parseExcelAdvanced(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfStudentParseExcelAdvancedResult> {
        let url_ = this.baseUrl + "/api/v1/student/parse-excel-advanced";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParseExcelAdvanced(_response);
        });
    }

    protected processParseExcelAdvanced(response: AxiosResponse): Promise<ApiResponse_1OfStudentParseExcelAdvancedResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfStudentParseExcelAdvancedResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfStudentParseExcelAdvancedResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfStudentParseExcelAdvancedResult>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @param scholarShipId (optional) 
     * @return OK
     */
    studentSetScholarShip(studentId: number | undefined, scholarShipId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/student/student-set-scholar-ship?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (scholarShipId === null)
            throw new Error("The parameter 'scholarShipId' cannot be null.");
        else if (scholarShipId !== undefined)
            url_ += "scholarShipId=" + encodeURIComponent("" + scholarShipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStudentSetScholarShip(_response);
        });
    }

    protected processStudentSetScholarShip(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    getTimeline(studentId: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStudentStatusTimelineNode> {
        let url_ = this.baseUrl + "/api/v1/student-status/timeline/{studentId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeline(_response);
        });
    }

    protected processGetTimeline(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStudentStatusTimelineNode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStudentStatusTimelineNode.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusTimelineNode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusTimelineNode>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @param classId (optional) 
     * @return OK
     */
    getTimelineByClass(studentId: number | undefined, classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfStudentStatusTimelineNode> {
        let url_ = this.baseUrl + "/api/v1/student-status/timeline-by-class?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimelineByClass(_response);
        });
    }

    protected processGetTimelineByClass(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfStudentStatusTimelineNode> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfStudentStatusTimelineNode.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusTimelineNode>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfStudentStatusTimelineNode>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateStatus(body: StudentStatusUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/student-status/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    batchUpdateStatus(body: StudentStatusBatchUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBatchUpdateResult> {
        let url_ = this.baseUrl + "/api/v1/student-status/batch-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBatchUpdateStatus(_response);
        });
    }

    protected processBatchUpdateStatus(response: AxiosResponse): Promise<ApiResponse_1OfBatchUpdateResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBatchUpdateResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBatchUpdateResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBatchUpdateResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateByClass(body: StudentStatusBulkUpdateByClassCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBulkUpdateByClassResult> {
        let url_ = this.baseUrl + "/api/v1/student-status/bulk-update-by-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateByClass(_response);
        });
    }

    protected processBulkUpdateByClass(response: AxiosResponse): Promise<ApiResponse_1OfBulkUpdateByClassResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBulkUpdateByClassResult.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBulkUpdateByClassResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBulkUpdateByClassResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subjectGetList(body: SubjectGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfSubjectListDto> {
        let url_ = this.baseUrl + "/api/v1/subject/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectGetList(_response);
        });
    }

    protected processSubjectGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfSubjectListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfSubjectListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfSubjectListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfSubjectListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    subjectGetById(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfSubjectEntity> {
        let url_ = this.baseUrl + "/api/v1/subject/get-by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectGetById(_response);
        });
    }

    protected processSubjectGetById(response: AxiosResponse): Promise<ApiResponse_1OfSubjectEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSubjectEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSubjectEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSubjectEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subjectSave(body: SubjectEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/subject/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectSave(_response);
        });
    }

    protected processSubjectSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    subjectDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/subject/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectDelete(_response);
        });
    }

    protected processSubjectDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subjectScoreGetList(body: SubjectScoreGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfSubjectScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/subject-score/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectScoreGetList(_response);
        });
    }

    protected processSubjectScoreGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfSubjectScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfSubjectScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfSubjectScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfSubjectScoreListDto>(null as any);
    }

    /**
     * @param classId (optional) 
     * @param subjectId (optional) 
     * @param academicYearId (optional) 
     * @param semester (optional) 
     * @return OK
     */
    subjectScoreGetByClassSubject(classId: number | undefined, subjectId: number | undefined, academicYearId: number | undefined, semester: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfSubjectScoreListDto> {
        let url_ = this.baseUrl + "/api/v1/subject-score/get-by-class-subject?";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (subjectId === null)
            throw new Error("The parameter 'subjectId' cannot be null.");
        else if (subjectId !== undefined)
            url_ += "subjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (academicYearId === null)
            throw new Error("The parameter 'academicYearId' cannot be null.");
        else if (academicYearId !== undefined)
            url_ += "academicYearId=" + encodeURIComponent("" + academicYearId) + "&";
        if (semester === null)
            throw new Error("The parameter 'semester' cannot be null.");
        else if (semester !== undefined)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectScoreGetByClassSubject(_response);
        });
    }

    protected processSubjectScoreGetByClassSubject(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfSubjectScoreListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfSubjectScoreListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfSubjectScoreListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfSubjectScoreListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subjectScoreSave(body: SubjectScoreEntity | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfInt64> {
        let url_ = this.baseUrl + "/api/v1/subject-score/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectScoreSave(_response);
        });
    }

    protected processSubjectScoreSave(response: AxiosResponse): Promise<ApiResponse_1OfInt64> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfInt64.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfInt64>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfInt64>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    subjectScoreBatchSave(body: SubjectScoreBatchSaveDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/subject-score/batch-save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectScoreBatchSave(_response);
        });
    }

    protected processSubjectScoreBatchSave(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    subjectScoreDelete(id: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/subject-score/delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubjectScoreDelete(_response);
        });
    }

    protected processSubjectScoreDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    initSystem( cancelToken?: CancelToken): Promise<ApiResponse_1OfSystemInitDto> {
        let url_ = this.baseUrl + "/api/v1/system/init";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitSystem(_response);
        });
    }

    protected processInitSystem(response: AxiosResponse): Promise<ApiResponse_1OfSystemInitDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfSystemInitDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfSystemInitDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfSystemInitDto>(null as any);
    }

    /**
     * @return OK
     */
    tagGetById(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetById(_response);
        });
    }

    protected processTagGetById(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveTag(body: TagDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTag(_response);
        });
    }

    protected processSaveTag(response: AxiosResponse): Promise<ApiResponse_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfTagDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetList(body: TagGetListQuery | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetList(_response);
        });
    }

    protected processTagGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTagListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTagListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTagListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagGetByIds(body: number[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTagDto> {
        let url_ = this.baseUrl + "/api/v1/tag/list-by-ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagGetByIds(_response);
        });
    }

    protected processTagGetByIds(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTagDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTagDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTagDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTagDto>(null as any);
    }

    /**
     * @return OK
     */
    tagDelete(id: number, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagDelete(_response);
        });
    }

    protected processTagDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isHot (optional) 
     * @return OK
     */
    tagUpadteHot(id: number | undefined, isHot: boolean | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/tag/update-hot?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isHot === null)
            throw new Error("The parameter 'isHot' cannot be null.");
        else if (isHot !== undefined)
            url_ += "IsHot=" + encodeURIComponent("" + isHot) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTagUpadteHot(_response);
        });
    }

    protected processTagUpadteHot(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    testKafka( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/test/test-kafka";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestKafka(_response);
        });
    }

    protected processTestKafka(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    testParseJson( cancelToken?: CancelToken): Promise<ApiResponse_1OfResponseX> {
        let url_ = this.baseUrl + "/api/v1/test/test-parsejson";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestParseJson(_response);
        });
    }

    protected processTestParseJson(response: AxiosResponse): Promise<ApiResponse_1OfResponseX> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfResponseX.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfResponseX>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfResponseX>(null as any);
    }

    /**
     * @return OK
     */
    testLog( cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/test/test-log";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestLog(_response);
        });
    }

    protected processTestLog(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    transcriptGetList(body: TranscriptGetListFilter | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfFilterResult_1OfTranscriptListDto> {
        let url_ = this.baseUrl + "/api/v1/transcript/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscriptGetList(_response);
        });
    }

    protected processTranscriptGetList(response: AxiosResponse): Promise<ApiResponse_1OfFilterResult_1OfTranscriptListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfFilterResult_1OfTranscriptListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfFilterResult_1OfTranscriptListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfFilterResult_1OfTranscriptListDto>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @return OK
     */
    transcriptGetByStudent(studentId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfList_1OfTranscriptListDto> {
        let url_ = this.baseUrl + "/api/v1/transcript/get-by-student?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscriptGetByStudent(_response);
        });
    }

    protected processTranscriptGetByStudent(response: AxiosResponse): Promise<ApiResponse_1OfList_1OfTranscriptListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfList_1OfTranscriptListDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfList_1OfTranscriptListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfList_1OfTranscriptListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    transcriptCalculate(body: TranscriptCalculateDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/transcript/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscriptCalculate(_response);
        });
    }

    protected processTranscriptCalculate(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @param studentId (optional) 
     * @return OK
     */
    transcriptExportPdf(studentId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/transcript/export-pdf?";
        if (studentId === null)
            throw new Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranscriptExportPdf(_response);
        });
    }

    protected processTranscriptExportPdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @param classId (optional) 
     * @return OK
     */
    getByEmail(email: string | undefined, classId: number | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserInfoDto> {
        let url_ = this.baseUrl + "/api/v1/user/get-by-email?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByEmail(_response);
        });
    }

    protected processGetByEmail(response: AxiosResponse): Promise<ApiResponse_1OfUserInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserInfoDto.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserInfoDto>(null as any);
    }

    /**
     * @return OK
     */
    downloadTemplateImport( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/template-import";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTemplateImport(_response);
        });
    }

    protected processDownloadTemplateImport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    importUser(file: FileParameter | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/user/import-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportUser(_response);
        });
    }

    protected processImportUser(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userMobileTokenSave(body: UserMobileTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-mobile-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserMobileTokenSave(_response);
        });
    }

    protected processUserMobileTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserMobileTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserMobileTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserMobileTokenEntity>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return OK
     */
    roleGetByUser(userId: number | undefined, id: string, cancelToken?: CancelToken): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/user-permission/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRoleGetByUser(_response);
        });
    }

    protected processRoleGetByUser(response: AxiosResponse): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RoleDto.fromJS(resultData200);
            return Promise.resolve<RoleDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenSave(body: UserWebTokenUpdateCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfUserWebTokenEntity> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenSave(_response);
        });
    }

    protected processUserWebTokenSave(response: AxiosResponse): Promise<ApiResponse_1OfUserWebTokenEntity> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfUserWebTokenEntity.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfUserWebTokenEntity>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    userWebTokenDelete(body: UserWebTokenDeleteCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse_1OfBoolean> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserWebTokenDelete(_response);
        });
    }

    protected processUserWebTokenDelete(response: AxiosResponse): Promise<ApiResponse_1OfBoolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfBoolean.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfBoolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfBoolean>(null as any);
    }

    /**
     * @return OK
     */
    generateVapidKeys( cancelToken?: CancelToken): Promise<ApiResponse_1OfVapidDetails> {
        let url_ = this.baseUrl + "/api/v1/user-web-token/generate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateVapidKeys(_response);
        });
    }

    protected processGenerateVapidKeys(response: AxiosResponse): Promise<ApiResponse_1OfVapidDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiResponse_1OfVapidDetails.fromJS(resultData200);
            return Promise.resolve<ApiResponse_1OfVapidDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_1OfVapidDetails>(null as any);
    }

    /**
     * @return OK
     */
    getWeatherForecast( cancelToken?: CancelToken): Promise<WeatherForecast[]> {
        let url_ = this.baseUrl + "/weatherforecast/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherForecast(_response);
        });
    }

    protected processGetWeatherForecast(response: AxiosResponse): Promise<WeatherForecast[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WeatherForecast.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<WeatherForecast[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherForecast[]>(null as any);
    }
}

export class BankAccountEntity implements IBankAccountEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    bankName!: string;
    bankCode!: string;
    accountNumber!: string;
    accountName!: string;
    branch?: string | undefined;
    description?: string | undefined;
    bankLogo?: string | undefined;
    isDefault?: boolean;
    status?: number;
    displayOrder?: number;

    constructor(data?: IBankAccountEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.branch = _data["branch"];
            this.description = _data["description"];
            this.bankLogo = _data["bankLogo"];
            this.isDefault = _data["isDefault"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): BankAccountEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["branch"] = this.branch;
        data["description"] = this.description;
        data["bankLogo"] = this.bankLogo;
        data["isDefault"] = this.isDefault;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IBankAccountEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    bankName: string;
    bankCode: string;
    accountNumber: string;
    accountName: string;
    branch?: string | undefined;
    description?: string | undefined;
    bankLogo?: string | undefined;
    isDefault?: boolean;
    status?: number;
    displayOrder?: number;
}

export class DNTCaptchaApiResponse implements IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;

    constructor(data?: IDNTCaptchaApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dntCaptchaImgUrl = _data["dntCaptchaImgUrl"];
            this.dntCaptchaId = _data["dntCaptchaId"];
            this.dntCaptchaTextValue = _data["dntCaptchaTextValue"];
            this.dntCaptchaTokenValue = _data["dntCaptchaTokenValue"];
        }
    }

    static fromJS(data: any): DNTCaptchaApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DNTCaptchaApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dntCaptchaImgUrl"] = this.dntCaptchaImgUrl;
        data["dntCaptchaId"] = this.dntCaptchaId;
        data["dntCaptchaTextValue"] = this.dntCaptchaTextValue;
        data["dntCaptchaTokenValue"] = this.dntCaptchaTokenValue;
        return data;
    }
}

export interface IDNTCaptchaApiResponse {
    dntCaptchaImgUrl?: string | undefined;
    dntCaptchaId?: string | undefined;
    dntCaptchaTextValue?: string | undefined;
    dntCaptchaTokenValue?: string | undefined;
}

export class Enum implements IEnum {

    constructor(data?: IEnum) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Enum {
        data = typeof data === 'object' ? data : {};
        let result = new Enum();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEnum {
}

export class PermissionAddUserDto implements IPermissionAddUserDto {
    userId?: number;
    module?: ModuleEnum;
    permission?: PermissionEnum;
    tenantId?: number;

    constructor(data?: IPermissionAddUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.module = _data["module"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): PermissionAddUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionAddUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["module"] = this.module;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IPermissionAddUserDto {
    userId?: number;
    module?: ModuleEnum;
    permission?: PermissionEnum;
    tenantId?: number;
}

export class PermissionRemoveUserDto implements IPermissionRemoveUserDto {
    userId?: number;
    module?: ModuleEnum;
    permission?: PermissionEnum;
    tenantId?: number;

    constructor(data?: IPermissionRemoveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.module = _data["module"];
            this.permission = _data["permission"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): PermissionRemoveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionRemoveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["module"] = this.module;
        data["permission"] = this.permission;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IPermissionRemoveUserDto {
    userId?: number;
    module?: ModuleEnum;
    permission?: PermissionEnum;
    tenantId?: number;
}

export class PermissionRoleInfoDto implements IPermissionRoleInfoDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IPermissionRoleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PermissionRoleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionRoleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPermissionRoleInfoDto {
    id?: number;
    name?: string | undefined;
}

export class PermissionUserInfoDto implements IPermissionUserInfoDto {
    id?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    isDirectPermission?: boolean;
    roleNames?: string[] | undefined;

    constructor(data?: IPermissionUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.isDirectPermission = _data["isDirectPermission"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["isDirectPermission"] = this.isDirectPermission;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }
}

export interface IPermissionUserInfoDto {
    id?: number;
    userName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    isDirectPermission?: boolean;
    roleNames?: string[] | undefined;
}

export class PermissionUsersDto implements IPermissionUsersDto {
    users?: PermissionUserInfoDto[] | undefined;
    roles?: PermissionRoleInfoDto[] | undefined;

    constructor(data?: IPermissionUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(PermissionUserInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(PermissionRoleInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionUsersDto {
    users?: PermissionUserInfoDto[] | undefined;
    roles?: PermissionRoleInfoDto[] | undefined;
}

export class ResponseX implements IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;

    constructor(data?: IResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.fileId = _data["fileId"];
            this.docType = _data["docType"];
            if (_data["pages"]) {
                this.pages = {} as any;
                for (let key in _data["pages"]) {
                    if (_data["pages"].hasOwnProperty(key))
                        (<any>this.pages)![key] = _data["pages"][key] !== undefined ? _data["pages"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["fileId"] = this.fileId;
        data["docType"] = this.docType;
        if (this.pages) {
            data["pages"] = {};
            for (let key in this.pages) {
                if (this.pages.hasOwnProperty(key))
                    (<any>data["pages"])[key] = (<any>this.pages)[key];
            }
        }
        return data;
    }
}

export interface IResponseX {
    sessionId?: number;
    fileId?: number;
    docType?: string | undefined;
    pages?: { [key: string]: number[][]; } | undefined;
}

export class SystemEnums implements ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;

    constructor(data?: ISystemEnums) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.values = _data["values"] ? Enum.fromJS(_data["values"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EnumItemEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemEnums {
        data = typeof data === 'object' ? data : {};
        let result = new SystemEnums();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["values"] = this.values ? this.values.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemEnums {
    code?: string | undefined;
    values?: Enum;
    items?: EnumItemEntity[] | undefined;
}

export class SystemInitDto implements ISystemInitDto {
    category?: CategoryEntity[] | undefined;
    academicYear?: AcademicYearDto[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: ObjectPermissionDto[] | undefined;
    currentObject?: CurrentObjectDto;
    users?: UserWithSimpleInfoDto[] | undefined;
    allowUpdateStudentStatus?: boolean;
    enableGradeManagement?: boolean;

    constructor(data?: ISystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(CategoryEntity.fromJS(item));
            }
            if (Array.isArray(_data["academicYear"])) {
                this.academicYear = [] as any;
                for (let item of _data["academicYear"])
                    this.academicYear!.push(AcademicYearDto.fromJS(item));
            }
            if (Array.isArray(_data["enums"])) {
                this.enums = [] as any;
                for (let item of _data["enums"])
                    this.enums!.push(SystemEnums.fromJS(item));
            }
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [] as any;
                for (let item of _data["userPermissions"])
                    this.userPermissions!.push(ObjectPermissionDto.fromJS(item));
            }
            this.currentObject = _data["currentObject"] ? CurrentObjectDto.fromJS(_data["currentObject"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.allowUpdateStudentStatus = _data["allowUpdateStudentStatus"];
            this.enableGradeManagement = _data["enableGradeManagement"];
        }
    }

    static fromJS(data: any): SystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item.toJSON());
        }
        if (Array.isArray(this.academicYear)) {
            data["academicYear"] = [];
            for (let item of this.academicYear)
                data["academicYear"].push(item.toJSON());
        }
        if (Array.isArray(this.enums)) {
            data["enums"] = [];
            for (let item of this.enums)
                data["enums"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item.toJSON());
        }
        data["currentObject"] = this.currentObject ? this.currentObject.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["allowUpdateStudentStatus"] = this.allowUpdateStudentStatus;
        data["enableGradeManagement"] = this.enableGradeManagement;
        return data;
    }
}

export interface ISystemInitDto {
    category?: CategoryEntity[] | undefined;
    academicYear?: AcademicYearDto[] | undefined;
    enums?: SystemEnums[] | undefined;
    userPermissions?: ObjectPermissionDto[] | undefined;
    currentObject?: CurrentObjectDto;
    users?: UserWithSimpleInfoDto[] | undefined;
    allowUpdateStudentStatus?: boolean;
    enableGradeManagement?: boolean;
}

export class WeatherForecast implements IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    readonly temperatureF?: number;
    summary?: string | undefined;

    constructor(data?: IWeatherForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.temperatureC = _data["temperatureC"];
            (<any>this).temperatureF = _data["temperatureF"];
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): WeatherForecast {
        data = typeof data === 'object' ? data : {};
        let result = new WeatherForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>undefined;
        data["temperatureC"] = this.temperatureC;
        data["temperatureF"] = this.temperatureF;
        data["summary"] = this.summary;
        return data;
    }
}

export interface IWeatherForecast {
    date?: Date;
    temperatureC?: number;
    temperatureF?: number;
    summary?: string | undefined;
}

export class AcademicYearDto implements IAcademicYearDto {
    id?: number;
    startPeriod1?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IAcademicYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startPeriod1 = _data["startPeriod1"] ? new Date(_data["startPeriod1"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AcademicYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startPeriod1"] = this.startPeriod1 ? this.startPeriod1.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IAcademicYearDto {
    id?: number;
    startPeriod1?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;
}

export class ChangeEmailDto implements IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;

    constructor(data?: IChangeEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.password = _data["password"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ChangeEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["password"] = this.password;
        data["email"] = this.email;
        return data;
    }
}

export interface IChangeEmailDto {
    id?: number;
    password?: string | undefined;
    email?: string | undefined;
}

export class ChangePasswordDto implements IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.reNewPassword = _data["reNewPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["reNewPassword"] = this.reNewPassword;
        return data;
    }
}

export interface IChangePasswordDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;
}

export class CurrentObjectDto implements ICurrentObjectDto {
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;

    constructor(data?: ICurrentObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CurrentObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        return data;
    }
}

export interface ICurrentObjectDto {
    id?: number;
    type?: UserTypeEnum;
    name?: string | undefined;
}

export class Disable2FADto implements IDisable2FADto {
    code?: string | undefined;

    constructor(data?: IDisable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Disable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Disable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IDisable2FADto {
    code?: string | undefined;
}

export class Enable2FADto implements IEnable2FADto {
    code?: string | undefined;

    constructor(data?: IEnable2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): Enable2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Enable2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface IEnable2FADto {
    code?: string | undefined;
}

export class FirstTimeChangePasswordDto implements IFirstTimeChangePasswordDto {
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;

    constructor(data?: IFirstTimeChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.reNewPassword = _data["reNewPassword"];
        }
    }

    static fromJS(data: any): FirstTimeChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirstTimeChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["reNewPassword"] = this.reNewPassword;
        return data;
    }
}

export interface IFirstTimeChangePasswordDto {
    newPassword?: string | undefined;
    reNewPassword?: string | undefined;
}

export class ForgotPasswordCheckOTPResource implements IForgotPasswordCheckOTPResource {
    username?: string | undefined;
    otp?: string | undefined;

    constructor(data?: IForgotPasswordCheckOTPResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ForgotPasswordCheckOTPResource {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordCheckOTPResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["otp"] = this.otp;
        return data;
    }
}

export interface IForgotPasswordCheckOTPResource {
    username?: string | undefined;
    otp?: string | undefined;
}

export class LoginResponseDto implements ILoginResponseDto {
    require2Fa?: boolean;
    requirePasswordChange?: boolean;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;

    constructor(data?: ILoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.require2Fa = _data["require2Fa"];
            this.requirePasswordChange = _data["requirePasswordChange"];
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.userInfo = _data["userInfo"] ? UserInfoDto.fromJS(_data["userInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["require2Fa"] = this.require2Fa;
        data["requirePasswordChange"] = this.requirePasswordChange;
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["userInfo"] = this.userInfo ? this.userInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginResponseDto {
    require2Fa?: boolean;
    requirePasswordChange?: boolean;
    token?: string | undefined;
    refreshToken?: string | undefined;
    userInfo?: UserInfoDto;
}

export class LoginWith2FADto implements ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;

    constructor(data?: ILoginWith2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): LoginWith2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWith2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["code"] = this.code;
        return data;
    }
}

export interface ILoginWith2FADto {
    userName?: string | undefined;
    code?: string | undefined;
}

export class RefreshTokenResponseDto implements IRefreshTokenResponseDto {
    token?: string | undefined;

    constructor(data?: IRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IRefreshTokenResponseDto {
    token?: string | undefined;
}

export class RegisterDto implements IRegisterDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    identifierCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    address?: string | undefined;

    constructor(data?: IRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.id = _data["id"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.provinceId = _data["provinceId"];
            this.identifierCode = _data["identifierCode"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): RegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["provinceId"] = this.provinceId;
        data["identifierCode"] = this.identifierCode;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["address"] = this.address;
        return data;
    }
}

export interface IRegisterDto {
    userName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: number[] | undefined;
    id?: number;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    provinceId?: number;
    identifierCode?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    address?: string | undefined;
}

export class ResetPasswordByUserNameResource implements IResetPasswordByUserNameResource {
    username?: string | undefined;
    password?: string | undefined;
    rePassword?: string | undefined;
    token?: string | undefined;

    constructor(data?: IResetPasswordByUserNameResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.rePassword = _data["rePassword"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ResetPasswordByUserNameResource {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordByUserNameResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["rePassword"] = this.rePassword;
        data["token"] = this.token;
        return data;
    }
}

export interface IResetPasswordByUserNameResource {
    username?: string | undefined;
    password?: string | undefined;
    rePassword?: string | undefined;
    token?: string | undefined;
}

export class Setup2FADto implements ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;

    constructor(data?: ISetup2FADto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sharedKey = _data["sharedKey"];
            this.authenticatorUri = _data["authenticatorUri"];
        }
    }

    static fromJS(data: any): Setup2FADto {
        data = typeof data === 'object' ? data : {};
        let result = new Setup2FADto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sharedKey"] = this.sharedKey;
        data["authenticatorUri"] = this.authenticatorUri;
        return data;
    }
}

export interface ISetup2FADto {
    sharedKey?: string | undefined;
    authenticatorUri?: string | undefined;
}

export class UpdateAvatarDto implements IUpdateAvatarDto {
    avatar?: string | undefined;

    constructor(data?: IUpdateAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateAvatarDto {
    avatar?: string | undefined;
}

export class UpdateInfoDto implements IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IUpdateInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.phoneNumber = _data["phoneNumber"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): UpdateInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["phoneNumber"] = this.phoneNumber;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IUpdateInfoDto {
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    avatar?: string | undefined;
}

export class UserInfoDto implements IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;
    type?: UserTypeEnum;
    passwordChanged?: boolean;
    objectId?: number;

    constructor(data?: IUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.lastLoginDate = _data["lastLoginDate"];
            this.type = _data["type"];
            this.passwordChanged = _data["passwordChanged"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): UserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["lastLoginDate"] = this.lastLoginDate;
        data["type"] = this.type;
        data["passwordChanged"] = this.passwordChanged;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IUserInfoDto {
    id?: number;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    lastLoginDate?: string | undefined;
    type?: UserTypeEnum;
    passwordChanged?: boolean;
    objectId?: number;
}

export class CreateConfigDto implements ICreateConfigDto {
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;

    constructor(data?: ICreateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.isSystem = _data["isSystem"];
            this.groupType = _data["groupType"];
        }
    }

    static fromJS(data: any): CreateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["isSystem"] = this.isSystem;
        data["groupType"] = this.groupType;
        return data;
    }
}

export interface ICreateConfigDto {
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;
}

export class FileUploadByUrlResponseDto implements IFileUploadByUrlResponseDto {
    path?: string | undefined;

    constructor(data?: IFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
        }
    }

    static fromJS(data: any): FileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        return data;
    }
}

export interface IFileUploadByUrlResponseDto {
    path?: string | undefined;
}

export class FolderNodeDataDto implements IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;

    constructor(data?: IFolderNodeDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.fileCount = _data["fileCount"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): FolderNodeDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["fileCount"] = this.fileCount;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IFolderNodeDataDto {
    id?: number;
    parentId?: number;
    fileCount?: number;
    createdBy?: number;
}

export class FolderNodeDto implements IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;

    constructor(data?: IFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.data = _data["data"] ? FolderNodeDataDto.fromJS(_data["data"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(FolderNodeDto.fromJS(item));
            }
            this.state = _data["state"] ? FolderNodeStateDto.fromJS(_data["state"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFolderNodeDto {
    id?: string | undefined;
    text?: string | undefined;
    data?: FolderNodeDataDto;
    children?: FolderNodeDto[] | undefined;
    state?: FolderNodeStateDto;
}

export class FolderNodeStateDto implements IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;

    constructor(data?: IFolderNodeStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.opened = _data["opened"];
            this.disabled = _data["disabled"];
        }
    }

    static fromJS(data: any): FolderNodeStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderNodeStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["opened"] = this.opened;
        data["disabled"] = this.disabled;
        return data;
    }
}

export interface IFolderNodeStateDto {
    selected?: boolean;
    opened?: boolean;
    disabled?: boolean;
}

export class FolderUpdateDto implements IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderUpdateDto {
    id?: number;
    name?: string | undefined;
    parentId?: number;
}

export class SePayNotifyDto implements ISePayNotifyDto {
    id?: number;
    gateway?: string | undefined;
    transactionDate?: string | undefined;
    accountNumber?: string | undefined;
    code?: string | undefined;
    content?: string | undefined;
    transferType?: string | undefined;
    transferAmount?: number;
    referenceCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: ISePayNotifyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gateway = _data["gateway"];
            this.transactionDate = _data["transactionDate"];
            this.accountNumber = _data["accountNumber"];
            this.code = _data["code"];
            this.content = _data["content"];
            this.transferType = _data["transferType"];
            this.transferAmount = _data["transferAmount"];
            this.referenceCode = _data["referenceCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SePayNotifyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SePayNotifyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gateway"] = this.gateway;
        data["transactionDate"] = this.transactionDate;
        data["accountNumber"] = this.accountNumber;
        data["code"] = this.code;
        data["content"] = this.content;
        data["transferType"] = this.transferType;
        data["transferAmount"] = this.transferAmount;
        data["referenceCode"] = this.referenceCode;
        data["description"] = this.description;
        return data;
    }
}

export interface ISePayNotifyDto {
    id?: number;
    gateway?: string | undefined;
    transactionDate?: string | undefined;
    accountNumber?: string | undefined;
    code?: string | undefined;
    content?: string | undefined;
    transferType?: string | undefined;
    transferAmount?: number;
    referenceCode?: string | undefined;
    description?: string | undefined;
}

export class UpdateConfigDto implements IUpdateConfigDto {
    id?: number;
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;

    constructor(data?: IUpdateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.isSystem = _data["isSystem"];
            this.groupType = _data["groupType"];
        }
    }

    static fromJS(data: any): UpdateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["isSystem"] = this.isSystem;
        data["groupType"] = this.groupType;
        return data;
    }
}

export interface IUpdateConfigDto {
    id?: number;
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;
}

export class UserGetListQuery implements IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;

    constructor(data?: IUserGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UserGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        return data;
    }
}

export interface IUserGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
}

export class GetListLogQuery implements IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IGetListLogQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.objectType = _data["objectType"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): GetListLogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListLogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["objectType"] = this.objectType;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IGetListLogQuery {
    keyword?: string | undefined;
    objectType?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class BankAccountGetListQuery implements IBankAccountGetListQuery {
    keyword?: string | undefined;
    status?: number | undefined;

    constructor(data?: IBankAccountGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BankAccountGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["status"] = this.status;
        return data;
    }
}

export interface IBankAccountGetListQuery {
    keyword?: string | undefined;
    status?: number | undefined;
}

export class QrGenerateQuery implements IQrGenerateQuery {
    bankAccountId?: number | undefined;
    amount?: number | undefined;
    content?: string | undefined;

    constructor(data?: IQrGenerateQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccountId = _data["bankAccountId"];
            this.amount = _data["amount"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): QrGenerateQuery {
        data = typeof data === 'object' ? data : {};
        let result = new QrGenerateQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccountId"] = this.bankAccountId;
        data["amount"] = this.amount;
        data["content"] = this.content;
        return data;
    }
}

export interface IQrGenerateQuery {
    bankAccountId?: number | undefined;
    amount?: number | undefined;
    content?: string | undefined;
}

export class GetListUserForCreateChatGroupQuery implements IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;

    constructor(data?: IGetListUserForCreateChatGroupQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.status = _data["status"];
            this.chatGroupType = _data["chatGroupType"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.type = _data["type"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): GetListUserForCreateChatGroupQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetListUserForCreateChatGroupQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["status"] = this.status;
        data["chatGroupType"] = this.chatGroupType;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IGetListUserForCreateChatGroupQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    status?: number;
    chatGroupType?: number;
    keyword?: string | undefined;
    roleIds?: number[] | undefined;
    type?: UserTypeEnum;
    objectId?: number;
}

export class ClassAddListUserCommand implements IClassAddListUserCommand {
    userIds?: number[] | undefined;
    classId?: number;
    role?: ClassUserRoleEnum;

    constructor(data?: IClassAddListUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.classId = _data["classId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ClassAddListUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassAddListUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["classId"] = this.classId;
        data["role"] = this.role;
        return data;
    }
}

export interface IClassAddListUserCommand {
    userIds?: number[] | undefined;
    classId?: number;
    role?: ClassUserRoleEnum;
}

export class ClassChangeClassCommand implements IClassChangeClassCommand {
    userIds?: number[] | undefined;
    oldClassId?: number;
    newClassId?: number;
    status?: StudentStatusEnum;

    constructor(data?: IClassChangeClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.oldClassId = _data["oldClassId"];
            this.newClassId = _data["newClassId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ClassChangeClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassChangeClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["oldClassId"] = this.oldClassId;
        data["newClassId"] = this.newClassId;
        data["status"] = this.status;
        return data;
    }
}

export interface IClassChangeClassCommand {
    userIds?: number[] | undefined;
    oldClassId?: number;
    newClassId?: number;
    status?: StudentStatusEnum;
}

export class ClassRemoveUserCommand implements IClassRemoveUserCommand {
    userId?: number;
    classId?: number;

    constructor(data?: IClassRemoveUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): ClassRemoveUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassRemoveUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IClassRemoveUserCommand {
    userId?: number;
    classId?: number;
}

export class ClassUpdateStatusUserCommand implements IClassUpdateStatusUserCommand {
    userId?: number;
    classId?: number;
    status?: StudentStatusEnum;
    note?: string | undefined;

    constructor(data?: IClassUpdateStatusUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.classId = _data["classId"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ClassUpdateStatusUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ClassUpdateStatusUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface IClassUpdateStatusUserCommand {
    userId?: number;
    classId?: number;
    status?: StudentStatusEnum;
    note?: string | undefined;
}

export class FeeScheduleCurrentQuery implements IFeeScheduleCurrentQuery {
    admissionDate?: Date | undefined;
    period?: number | undefined;
    majorId?: number | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    studentId?: number | undefined;

    constructor(data?: IFeeScheduleCurrentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.period = _data["period"];
            this.majorId = _data["majorId"];
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.studentId = _data["studentId"];
        }
    }

    static fromJS(data: any): FeeScheduleCurrentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FeeScheduleCurrentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["period"] = this.period;
        data["majorId"] = this.majorId;
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["studentId"] = this.studentId;
        return data;
    }
}

export interface IFeeScheduleCurrentQuery {
    admissionDate?: Date | undefined;
    period?: number | undefined;
    majorId?: number | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    studentId?: number | undefined;
}

export class FeeScheduleGetListQuery implements IFeeScheduleGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    majorId?: number | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    keyword?: string | undefined;

    constructor(data?: IFeeScheduleGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.majorId = _data["majorId"];
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): FeeScheduleGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FeeScheduleGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["majorId"] = this.majorId;
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["keyword"] = this.keyword;
        return data;
    }
}

export interface IFeeScheduleGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    majorId?: number | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    keyword?: string | undefined;
}

export class FileUpdateAvatarCommand implements IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;

    constructor(data?: IFileUpdateAvatarCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): FileUpdateAvatarCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateAvatarCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IFileUpdateAvatarCommand {
    id?: number;
    avatar?: string | undefined;
}

export class FileUpdateCommand implements IFileUpdateCommand {
    file?: FileEntity;

    constructor(data?: IFileUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileEntity.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFileUpdateCommand {
    file?: FileEntity;
}

export class FileUpdateNameCommand implements IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IFileUpdateNameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileUpdateNameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateNameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileUpdateNameCommand {
    id?: number;
    name?: string | undefined;
}

export class FileUpdateStatusCommand implements IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;

    constructor(data?: IFileUpdateStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FileUpdateStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpdateStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IFileUpdateStatusCommand {
    id?: number;
    status?: FileStatusEnum;
}

export class FolderDeleteCommand implements IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;

    constructor(data?: IFolderDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.moveFileToFolderId = _data["moveFileToFolderId"];
        }
    }

    static fromJS(data: any): FolderDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["moveFileToFolderId"] = this.moveFileToFolderId;
        return data;
    }
}

export interface IFolderDeleteCommand {
    id?: number;
    moveFileToFolderId?: number;
}

export class FolderUpdateCommand implements IFolderUpdateCommand {
    folder?: FolderUpdateDto;

    constructor(data?: IFolderUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder = _data["folder"] ? FolderUpdateDto.fromJS(_data["folder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new FolderUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFolderUpdateCommand {
    folder?: FolderUpdateDto;
}

export class UserMobileTokenUpdateCommand implements IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;

    constructor(data?: IUserMobileTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserMobileTokenEntity.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMobileTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserMobileTokenUpdateCommand {
    token?: UserMobileTokenEntity;
}

export class UserWebTokenDeleteCommand implements IUserWebTokenDeleteCommand {
    id?: number;

    constructor(data?: IUserWebTokenDeleteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserWebTokenDeleteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenDeleteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IUserWebTokenDeleteCommand {
    id?: number;
}

export class UserWebTokenUpdateCommand implements IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;

    constructor(data?: IUserWebTokenUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? UserWebTokenEntity.fromJS(_data["token"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserWebTokenUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserWebTokenUpdateCommand {
    token?: UserWebTokenEntity;
}

export class FileGetListQuery implements IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IFileGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.keyword = _data["keyword"];
            this.folderId = _data["folderId"];
            this.extensions = _data["extensions"];
            this.isGetAll = _data["isGetAll"];
            this.status = _data["status"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): FileGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FileGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["keyword"] = this.keyword;
        data["folderId"] = this.folderId;
        data["extensions"] = this.extensions;
        data["isGetAll"] = this.isGetAll;
        data["status"] = this.status;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IFileGetListQuery {
    userId?: number;
    keyword?: string | undefined;
    folderId?: number;
    extensions?: string | undefined;
    isGetAll?: boolean;
    status?: number;
    sortBy?: string | undefined;
    sortDirection?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class FolderGetAllQuery implements IFolderGetAllQuery {

    constructor(data?: IFolderGetAllQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): FolderGetAllQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetAllQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IFolderGetAllQuery {
}

export class FolderGetListQuery implements IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;

    constructor(data?: IFolderGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.isGetAll = _data["isGetAll"];
        }
    }

    static fromJS(data: any): FolderGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new FolderGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["isGetAll"] = this.isGetAll;
        return data;
    }
}

export interface IFolderGetListQuery {
    keyword?: string | undefined;
    isGetAll?: boolean;
}

export class LocalityGetListQuery implements ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;

    constructor(data?: ILocalityGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): LocalityGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ILocalityGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    type?: LocalityTypeEnum;
    parentId?: number | undefined;
}

export class PaymentTrackingQuery implements IPaymentTrackingQuery {
    academicYearId?: number | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;

    constructor(data?: IPaymentTrackingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.academicYearId = _data["academicYearId"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.keyword = _data["keyword"];
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PaymentTrackingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTrackingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academicYearId"] = this.academicYearId;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["keyword"] = this.keyword;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPaymentTrackingQuery {
    academicYearId?: number | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    keyword?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
}

export class ReceiptGetListQuery implements IReceiptGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    studentId?: number | undefined;

    constructor(data?: IReceiptGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.statusProcess = _data["statusProcess"];
            this.studentId = _data["studentId"];
        }
    }

    static fromJS(data: any): ReceiptGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["statusProcess"] = this.statusProcess;
        data["studentId"] = this.studentId;
        return data;
    }
}

export interface IReceiptGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    studentId?: number | undefined;
}

export class ScholarShipCurrentQuery implements IScholarShipCurrentQuery {
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    admissionDate?: Date | undefined;

    constructor(data?: IScholarShipCurrentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScholarShipCurrentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScholarShipCurrentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScholarShipCurrentQuery {
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    admissionDate?: Date | undefined;
}

export class ScholarShipGetListQuery implements IScholarShipGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    objectType?: ScholarShipTypeEnum;
    keyword?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IScholarShipGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.objectType = _data["objectType"];
            this.keyword = _data["keyword"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScholarShipGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScholarShipGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["objectType"] = this.objectType;
        data["keyword"] = this.keyword;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScholarShipGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    trainingType?: number | undefined;
    academicYearId?: number | undefined;
    objectType?: ScholarShipTypeEnum;
    keyword?: string | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export class StudentAddMultiCommand implements IStudentAddMultiCommand {
    students?: StudentAddDto[] | undefined;
    password?: string | undefined;
    classId?: number;

    constructor(data?: IStudentAddMultiCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentAddDto.fromJS(item));
            }
            this.password = _data["password"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentAddMultiCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAddMultiCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        data["password"] = this.password;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentAddMultiCommand {
    students?: StudentAddDto[] | undefined;
    password?: string | undefined;
    classId?: number;
}

export class StudentChangePasswordCommand implements IStudentChangePasswordCommand {
    classId?: number;
    userId?: number;
    password?: string | undefined;

    constructor(data?: IStudentChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.userId = _data["userId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): StudentChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    }
}

export interface IStudentChangePasswordCommand {
    classId?: number;
    userId?: number;
    password?: string | undefined;
}

export class StudentCopyFromClassCommand implements IStudentCopyFromClassCommand {
    classId?: number;
    newClassId?: number;

    constructor(data?: IStudentCopyFromClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.newClassId = _data["newClassId"];
        }
    }

    static fromJS(data: any): StudentCopyFromClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentCopyFromClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["newClassId"] = this.newClassId;
        return data;
    }
}

export interface IStudentCopyFromClassCommand {
    classId?: number;
    newClassId?: number;
}

export class BatchUpdateResult implements IBatchUpdateResult {
    successCount?: number;
    failedCount?: number;
    successIds?: number[] | undefined;
    failedIds?: number[] | undefined;

    constructor(data?: IBatchUpdateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["successIds"])) {
                this.successIds = [] as any;
                for (let item of _data["successIds"])
                    this.successIds!.push(item);
            }
            if (Array.isArray(_data["failedIds"])) {
                this.failedIds = [] as any;
                for (let item of _data["failedIds"])
                    this.failedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BatchUpdateResult {
        data = typeof data === 'object' ? data : {};
        let result = new BatchUpdateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.successIds)) {
            data["successIds"] = [];
            for (let item of this.successIds)
                data["successIds"].push(item);
        }
        if (Array.isArray(this.failedIds)) {
            data["failedIds"] = [];
            for (let item of this.failedIds)
                data["failedIds"].push(item);
        }
        return data;
    }
}

export interface IBatchUpdateResult {
    successCount?: number;
    failedCount?: number;
    successIds?: number[] | undefined;
    failedIds?: number[] | undefined;
}

export class BulkUpdateByClassResult implements IBulkUpdateByClassResult {
    classSummaries?: ClassStatusSummary[] | undefined;
    totalClasses?: number;
    totalStudents?: number;
    successCount?: number;
    skippedCount?: number;
    isConfirmed?: boolean;

    constructor(data?: IBulkUpdateByClassResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["classSummaries"])) {
                this.classSummaries = [] as any;
                for (let item of _data["classSummaries"])
                    this.classSummaries!.push(ClassStatusSummary.fromJS(item));
            }
            this.totalClasses = _data["totalClasses"];
            this.totalStudents = _data["totalStudents"];
            this.successCount = _data["successCount"];
            this.skippedCount = _data["skippedCount"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BulkUpdateByClassResult {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateByClassResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.classSummaries)) {
            data["classSummaries"] = [];
            for (let item of this.classSummaries)
                data["classSummaries"].push(item.toJSON());
        }
        data["totalClasses"] = this.totalClasses;
        data["totalStudents"] = this.totalStudents;
        data["successCount"] = this.successCount;
        data["skippedCount"] = this.skippedCount;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBulkUpdateByClassResult {
    classSummaries?: ClassStatusSummary[] | undefined;
    totalClasses?: number;
    totalStudents?: number;
    successCount?: number;
    skippedCount?: number;
    isConfirmed?: boolean;
}

export class ClassStatusSummary implements IClassStatusSummary {
    classId?: number;
    className?: string | undefined;
    classCode?: string | undefined;
    statusCounts?: { [key: string]: number; } | undefined;
    totalStudents?: number;

    constructor(data?: IClassStatusSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.classCode = _data["classCode"];
            if (_data["statusCounts"]) {
                this.statusCounts = {} as any;
                for (let key in _data["statusCounts"]) {
                    if (_data["statusCounts"].hasOwnProperty(key))
                        (<any>this.statusCounts)![key] = _data["statusCounts"][key];
                }
            }
            this.totalStudents = _data["totalStudents"];
        }
    }

    static fromJS(data: any): ClassStatusSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ClassStatusSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["classCode"] = this.classCode;
        if (this.statusCounts) {
            data["statusCounts"] = {};
            for (let key in this.statusCounts) {
                if (this.statusCounts.hasOwnProperty(key))
                    (<any>data["statusCounts"])[key] = (<any>this.statusCounts)[key];
            }
        }
        data["totalStudents"] = this.totalStudents;
        return data;
    }
}

export interface IClassStatusSummary {
    classId?: number;
    className?: string | undefined;
    classCode?: string | undefined;
    statusCounts?: { [key: string]: number; } | undefined;
    totalStudents?: number;
}

export class StudentDocumentUpdateCommand implements IStudentDocumentUpdateCommand {
    studentId?: number;
    documentTypeId?: number;
    status1?: number | undefined;
    status2?: number | undefined;
    scanFileUrl?: string | undefined;
    actualDocumentCount?: number | undefined;
    reviewDocumentCount?: number | undefined;
    mindful?: boolean | undefined;
    mindfulNote?: string | undefined;

    constructor(data?: IStudentDocumentUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.documentTypeId = _data["documentTypeId"];
            this.status1 = _data["status1"];
            this.status2 = _data["status2"];
            this.scanFileUrl = _data["scanFileUrl"];
            this.actualDocumentCount = _data["actualDocumentCount"];
            this.reviewDocumentCount = _data["reviewDocumentCount"];
            this.mindful = _data["mindful"];
            this.mindfulNote = _data["mindfulNote"];
        }
    }

    static fromJS(data: any): StudentDocumentUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDocumentUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["documentTypeId"] = this.documentTypeId;
        data["status1"] = this.status1;
        data["status2"] = this.status2;
        data["scanFileUrl"] = this.scanFileUrl;
        data["actualDocumentCount"] = this.actualDocumentCount;
        data["reviewDocumentCount"] = this.reviewDocumentCount;
        data["mindful"] = this.mindful;
        data["mindfulNote"] = this.mindfulNote;
        return data;
    }
}

export interface IStudentDocumentUpdateCommand {
    studentId?: number;
    documentTypeId?: number;
    status1?: number | undefined;
    status2?: number | undefined;
    scanFileUrl?: string | undefined;
    actualDocumentCount?: number | undefined;
    reviewDocumentCount?: number | undefined;
    mindful?: boolean | undefined;
    mindfulNote?: string | undefined;
}

export class StudentStatusBatchUpdateCommand implements IStudentStatusBatchUpdateCommand {
    studentIds?: number[] | undefined;
    year?: number;
    month?: number;
    status1?: number;
    status2?: number;
    note?: string | undefined;
    reason?: number;
    classId?: number;

    constructor(data?: IStudentStatusBatchUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studentIds"])) {
                this.studentIds = [] as any;
                for (let item of _data["studentIds"])
                    this.studentIds!.push(item);
            }
            this.year = _data["year"];
            this.month = _data["month"];
            this.status1 = _data["status1"];
            this.status2 = _data["status2"];
            this.note = _data["note"];
            this.reason = _data["reason"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentStatusBatchUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusBatchUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentIds)) {
            data["studentIds"] = [];
            for (let item of this.studentIds)
                data["studentIds"].push(item);
        }
        data["year"] = this.year;
        data["month"] = this.month;
        data["status1"] = this.status1;
        data["status2"] = this.status2;
        data["note"] = this.note;
        data["reason"] = this.reason;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentStatusBatchUpdateCommand {
    studentIds?: number[] | undefined;
    year?: number;
    month?: number;
    status1?: number;
    status2?: number;
    note?: string | undefined;
    reason?: number;
    classId?: number;
}

export class StudentStatusBulkUpdateByClassCommand implements IStudentStatusBulkUpdateByClassCommand {
    isConfirm?: boolean;

    constructor(data?: IStudentStatusBulkUpdateByClassCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConfirm = _data["isConfirm"];
        }
    }

    static fromJS(data: any): StudentStatusBulkUpdateByClassCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusBulkUpdateByClassCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConfirm"] = this.isConfirm;
        return data;
    }
}

export interface IStudentStatusBulkUpdateByClassCommand {
    isConfirm?: boolean;
}

export class StudentStatusUpdateCommand implements IStudentStatusUpdateCommand {
    studentId?: number;
    year?: number;
    month?: number;
    status1?: number;
    status2?: number;
    note?: string | undefined;
    reason?: number;
    classId?: number;

    constructor(data?: IStudentStatusUpdateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.status1 = _data["status1"];
            this.status2 = _data["status2"];
            this.note = _data["note"];
            this.reason = _data["reason"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentStatusUpdateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusUpdateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["status1"] = this.status1;
        data["status2"] = this.status2;
        data["note"] = this.note;
        data["reason"] = this.reason;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentStatusUpdateCommand {
    studentId?: number;
    year?: number;
    month?: number;
    status1?: number;
    status2?: number;
    note?: string | undefined;
    reason?: number;
    classId?: number;
}

export class StudentDocumentDto implements IStudentDocumentDto {
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    quantity?: number;
    priority?: number;
    status1?: number;
    status2?: number;
    scanFileUrl?: string | undefined;
    status1Date?: Date | undefined;
    status2Date?: Date | undefined;
    status1UpdateBy?: number;
    status2UpdateBy?: number;
    actualDocumentCount?: number | undefined;
    reviewDocumentCount?: number | undefined;
    lastModifiedDate?: Date | undefined;
    mindful?: boolean | undefined;
    mindfulNote?: string | undefined;

    constructor(data?: IStudentDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTypeId = _data["documentTypeId"];
            this.documentTypeName = _data["documentTypeName"];
            this.quantity = _data["quantity"];
            this.priority = _data["priority"];
            this.status1 = _data["status1"];
            this.status2 = _data["status2"];
            this.scanFileUrl = _data["scanFileUrl"];
            this.status1Date = _data["status1Date"] ? new Date(_data["status1Date"].toString()) : <any>undefined;
            this.status2Date = _data["status2Date"] ? new Date(_data["status2Date"].toString()) : <any>undefined;
            this.status1UpdateBy = _data["status1UpdateBy"];
            this.status2UpdateBy = _data["status2UpdateBy"];
            this.actualDocumentCount = _data["actualDocumentCount"];
            this.reviewDocumentCount = _data["reviewDocumentCount"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.mindful = _data["mindful"];
            this.mindfulNote = _data["mindfulNote"];
        }
    }

    static fromJS(data: any): StudentDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeId"] = this.documentTypeId;
        data["documentTypeName"] = this.documentTypeName;
        data["quantity"] = this.quantity;
        data["priority"] = this.priority;
        data["status1"] = this.status1;
        data["status2"] = this.status2;
        data["scanFileUrl"] = this.scanFileUrl;
        data["status1Date"] = this.status1Date ? this.status1Date.toISOString() : <any>undefined;
        data["status2Date"] = this.status2Date ? this.status2Date.toISOString() : <any>undefined;
        data["status1UpdateBy"] = this.status1UpdateBy;
        data["status2UpdateBy"] = this.status2UpdateBy;
        data["actualDocumentCount"] = this.actualDocumentCount;
        data["reviewDocumentCount"] = this.reviewDocumentCount;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["mindful"] = this.mindful;
        data["mindfulNote"] = this.mindfulNote;
        return data;
    }
}

export interface IStudentDocumentDto {
    documentTypeId?: number;
    documentTypeName?: string | undefined;
    quantity?: number;
    priority?: number;
    status1?: number;
    status2?: number;
    scanFileUrl?: string | undefined;
    status1Date?: Date | undefined;
    status2Date?: Date | undefined;
    status1UpdateBy?: number;
    status2UpdateBy?: number;
    actualDocumentCount?: number | undefined;
    reviewDocumentCount?: number | undefined;
    lastModifiedDate?: Date | undefined;
    mindful?: boolean | undefined;
    mindfulNote?: string | undefined;
}

export class StudentGetListQuery implements IStudentGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    classIds?: number[] | undefined;
    academicYearId?: number | undefined;
    academicYearIds?: number[] | undefined;
    keyword?: string | undefined;
    ethnic?: string | undefined;
    admissionDateFrom?: Date | undefined;
    admissionDateTo?: Date | undefined;
    createdDateFrom?: Date | undefined;
    createdDateTo?: Date | undefined;
    documentStatus?: StudentDocumentStatusEnum;
    listStatus?: StudentProcessStatusEnum[] | undefined;
    status?: StudentProcessStatusEnum;
    provinceId?: number | undefined;
    provinceIds?: number[] | undefined;
    trainingType?: number | undefined;
    trainingTypes?: number[] | undefined;
    major?: number | undefined;
    majors?: number[] | undefined;
    gender?: number | undefined;
    notInClass?: boolean | undefined;
    hasStudentCode?: boolean | undefined;
    hasEmail?: boolean | undefined;
    hasPaid?: boolean | undefined;
    isFull?: boolean | undefined;
    mindful?: boolean | undefined;
    isExport?: boolean | undefined;
    birthDay?: Date | undefined;

    constructor(data?: IStudentGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            if (Array.isArray(_data["classIds"])) {
                this.classIds = [] as any;
                for (let item of _data["classIds"])
                    this.classIds!.push(item);
            }
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.keyword = _data["keyword"];
            this.ethnic = _data["ethnic"];
            this.admissionDateFrom = _data["admissionDateFrom"] ? new Date(_data["admissionDateFrom"].toString()) : <any>undefined;
            this.admissionDateTo = _data["admissionDateTo"] ? new Date(_data["admissionDateTo"].toString()) : <any>undefined;
            this.createdDateFrom = _data["createdDateFrom"] ? new Date(_data["createdDateFrom"].toString()) : <any>undefined;
            this.createdDateTo = _data["createdDateTo"] ? new Date(_data["createdDateTo"].toString()) : <any>undefined;
            this.documentStatus = _data["documentStatus"];
            if (Array.isArray(_data["listStatus"])) {
                this.listStatus = [] as any;
                for (let item of _data["listStatus"])
                    this.listStatus!.push(item);
            }
            this.status = _data["status"];
            this.provinceId = _data["provinceId"];
            if (Array.isArray(_data["provinceIds"])) {
                this.provinceIds = [] as any;
                for (let item of _data["provinceIds"])
                    this.provinceIds!.push(item);
            }
            this.trainingType = _data["trainingType"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            this.major = _data["major"];
            if (Array.isArray(_data["majors"])) {
                this.majors = [] as any;
                for (let item of _data["majors"])
                    this.majors!.push(item);
            }
            this.gender = _data["gender"];
            this.notInClass = _data["notInClass"];
            this.hasStudentCode = _data["hasStudentCode"];
            this.hasEmail = _data["hasEmail"];
            this.hasPaid = _data["hasPaid"];
            this.isFull = _data["isFull"];
            this.mindful = _data["mindful"];
            this.isExport = _data["isExport"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StudentGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StudentGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        if (Array.isArray(this.classIds)) {
            data["classIds"] = [];
            for (let item of this.classIds)
                data["classIds"].push(item);
        }
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["keyword"] = this.keyword;
        data["ethnic"] = this.ethnic;
        data["admissionDateFrom"] = this.admissionDateFrom ? this.admissionDateFrom.toISOString() : <any>undefined;
        data["admissionDateTo"] = this.admissionDateTo ? this.admissionDateTo.toISOString() : <any>undefined;
        data["createdDateFrom"] = this.createdDateFrom ? this.createdDateFrom.toISOString() : <any>undefined;
        data["createdDateTo"] = this.createdDateTo ? this.createdDateTo.toISOString() : <any>undefined;
        data["documentStatus"] = this.documentStatus;
        if (Array.isArray(this.listStatus)) {
            data["listStatus"] = [];
            for (let item of this.listStatus)
                data["listStatus"].push(item);
        }
        data["status"] = this.status;
        data["provinceId"] = this.provinceId;
        if (Array.isArray(this.provinceIds)) {
            data["provinceIds"] = [];
            for (let item of this.provinceIds)
                data["provinceIds"].push(item);
        }
        data["trainingType"] = this.trainingType;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        data["major"] = this.major;
        if (Array.isArray(this.majors)) {
            data["majors"] = [];
            for (let item of this.majors)
                data["majors"].push(item);
        }
        data["gender"] = this.gender;
        data["notInClass"] = this.notInClass;
        data["hasStudentCode"] = this.hasStudentCode;
        data["hasEmail"] = this.hasEmail;
        data["hasPaid"] = this.hasPaid;
        data["isFull"] = this.isFull;
        data["mindful"] = this.mindful;
        data["isExport"] = this.isExport;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStudentGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    classIds?: number[] | undefined;
    academicYearId?: number | undefined;
    academicYearIds?: number[] | undefined;
    keyword?: string | undefined;
    ethnic?: string | undefined;
    admissionDateFrom?: Date | undefined;
    admissionDateTo?: Date | undefined;
    createdDateFrom?: Date | undefined;
    createdDateTo?: Date | undefined;
    documentStatus?: StudentDocumentStatusEnum;
    listStatus?: StudentProcessStatusEnum[] | undefined;
    status?: StudentProcessStatusEnum;
    provinceId?: number | undefined;
    provinceIds?: number[] | undefined;
    trainingType?: number | undefined;
    trainingTypes?: number[] | undefined;
    major?: number | undefined;
    majors?: number[] | undefined;
    gender?: number | undefined;
    notInClass?: boolean | undefined;
    hasStudentCode?: boolean | undefined;
    hasEmail?: boolean | undefined;
    hasPaid?: boolean | undefined;
    isFull?: boolean | undefined;
    mindful?: boolean | undefined;
    isExport?: boolean | undefined;
    birthDay?: Date | undefined;
}

export class StudentListByStatusMonthDto implements IStudentListByStatusMonthDto {
    id?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    className?: string | undefined;
    note?: string | undefined;
    academicYearId?: number | undefined;
    trainingTypeId?: number | undefined;
    majorId?: number | undefined;
    status?: StudentStatusEnum;

    constructor(data?: IStudentListByStatusMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentCode = _data["studentCode"];
            this.fullName = _data["fullName"];
            this.className = _data["className"];
            this.note = _data["note"];
            this.academicYearId = _data["academicYearId"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.majorId = _data["majorId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StudentListByStatusMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentListByStatusMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentCode"] = this.studentCode;
        data["fullName"] = this.fullName;
        data["className"] = this.className;
        data["note"] = this.note;
        data["academicYearId"] = this.academicYearId;
        data["trainingTypeId"] = this.trainingTypeId;
        data["majorId"] = this.majorId;
        data["status"] = this.status;
        return data;
    }
}

export interface IStudentListByStatusMonthDto {
    id?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    className?: string | undefined;
    note?: string | undefined;
    academicYearId?: number | undefined;
    trainingTypeId?: number | undefined;
    majorId?: number | undefined;
    status?: StudentStatusEnum;
}

export class StudentListByStatusMonthQuery implements IStudentListByStatusMonthQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    academicYearId?: number | undefined;
    trainingTypeId?: number | undefined;
    majorId?: number | undefined;
    month?: number;
    year?: number;
    classType?: ClassTypeEnum;
    status?: StudentStatusEnum;

    constructor(data?: IStudentListByStatusMonthQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.academicYearId = _data["academicYearId"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.majorId = _data["majorId"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.classType = _data["classType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StudentListByStatusMonthQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StudentListByStatusMonthQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["academicYearId"] = this.academicYearId;
        data["trainingTypeId"] = this.trainingTypeId;
        data["majorId"] = this.majorId;
        data["month"] = this.month;
        data["year"] = this.year;
        data["classType"] = this.classType;
        data["status"] = this.status;
        return data;
    }
}

export interface IStudentListByStatusMonthQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    academicYearId?: number | undefined;
    trainingTypeId?: number | undefined;
    majorId?: number | undefined;
    month?: number;
    year?: number;
    classType?: ClassTypeEnum;
    status?: StudentStatusEnum;
}

export class StudentStatusStatisticsQuery implements IStudentStatusStatisticsQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    classIds?: number[] | undefined;
    academicYearIds?: number[] | undefined;
    keyword?: string | undefined;
    admissionDateFrom?: Date | undefined;
    admissionDateTo?: Date | undefined;
    createdDateFrom?: Date | undefined;
    createdDateTo?: Date | undefined;
    documentStatus?: StudentDocumentStatusEnum;
    listStatus?: StudentProcessStatusEnum[] | undefined;
    status?: StudentProcessStatusEnum;
    provinceIds?: number[] | undefined;
    trainingTypes?: number[] | undefined;
    majors?: number[] | undefined;
    classTypes?: ClassTypeEnum[] | undefined;
    monthFrom?: string | undefined;
    monthTo?: string | undefined;
    gender?: number | undefined;
    hasPaid?: boolean | undefined;

    constructor(data?: IStudentStatusStatisticsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            if (Array.isArray(_data["classIds"])) {
                this.classIds = [] as any;
                for (let item of _data["classIds"])
                    this.classIds!.push(item);
            }
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.keyword = _data["keyword"];
            this.admissionDateFrom = _data["admissionDateFrom"] ? new Date(_data["admissionDateFrom"].toString()) : <any>undefined;
            this.admissionDateTo = _data["admissionDateTo"] ? new Date(_data["admissionDateTo"].toString()) : <any>undefined;
            this.createdDateFrom = _data["createdDateFrom"] ? new Date(_data["createdDateFrom"].toString()) : <any>undefined;
            this.createdDateTo = _data["createdDateTo"] ? new Date(_data["createdDateTo"].toString()) : <any>undefined;
            this.documentStatus = _data["documentStatus"];
            if (Array.isArray(_data["listStatus"])) {
                this.listStatus = [] as any;
                for (let item of _data["listStatus"])
                    this.listStatus!.push(item);
            }
            this.status = _data["status"];
            if (Array.isArray(_data["provinceIds"])) {
                this.provinceIds = [] as any;
                for (let item of _data["provinceIds"])
                    this.provinceIds!.push(item);
            }
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            if (Array.isArray(_data["majors"])) {
                this.majors = [] as any;
                for (let item of _data["majors"])
                    this.majors!.push(item);
            }
            if (Array.isArray(_data["classTypes"])) {
                this.classTypes = [] as any;
                for (let item of _data["classTypes"])
                    this.classTypes!.push(item);
            }
            this.monthFrom = _data["monthFrom"];
            this.monthTo = _data["monthTo"];
            this.gender = _data["gender"];
            this.hasPaid = _data["hasPaid"];
        }
    }

    static fromJS(data: any): StudentStatusStatisticsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusStatisticsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        if (Array.isArray(this.classIds)) {
            data["classIds"] = [];
            for (let item of this.classIds)
                data["classIds"].push(item);
        }
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["keyword"] = this.keyword;
        data["admissionDateFrom"] = this.admissionDateFrom ? this.admissionDateFrom.toISOString() : <any>undefined;
        data["admissionDateTo"] = this.admissionDateTo ? this.admissionDateTo.toISOString() : <any>undefined;
        data["createdDateFrom"] = this.createdDateFrom ? this.createdDateFrom.toISOString() : <any>undefined;
        data["createdDateTo"] = this.createdDateTo ? this.createdDateTo.toISOString() : <any>undefined;
        data["documentStatus"] = this.documentStatus;
        if (Array.isArray(this.listStatus)) {
            data["listStatus"] = [];
            for (let item of this.listStatus)
                data["listStatus"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.provinceIds)) {
            data["provinceIds"] = [];
            for (let item of this.provinceIds)
                data["provinceIds"].push(item);
        }
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        if (Array.isArray(this.majors)) {
            data["majors"] = [];
            for (let item of this.majors)
                data["majors"].push(item);
        }
        if (Array.isArray(this.classTypes)) {
            data["classTypes"] = [];
            for (let item of this.classTypes)
                data["classTypes"].push(item);
        }
        data["monthFrom"] = this.monthFrom;
        data["monthTo"] = this.monthTo;
        data["gender"] = this.gender;
        data["hasPaid"] = this.hasPaid;
        return data;
    }
}

export interface IStudentStatusStatisticsQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number | undefined;
    classIds?: number[] | undefined;
    academicYearIds?: number[] | undefined;
    keyword?: string | undefined;
    admissionDateFrom?: Date | undefined;
    admissionDateTo?: Date | undefined;
    createdDateFrom?: Date | undefined;
    createdDateTo?: Date | undefined;
    documentStatus?: StudentDocumentStatusEnum;
    listStatus?: StudentProcessStatusEnum[] | undefined;
    status?: StudentProcessStatusEnum;
    provinceIds?: number[] | undefined;
    trainingTypes?: number[] | undefined;
    majors?: number[] | undefined;
    classTypes?: ClassTypeEnum[] | undefined;
    monthFrom?: string | undefined;
    monthTo?: string | undefined;
    gender?: number | undefined;
    hasPaid?: boolean | undefined;
}

export class StudentStatusStatisticsSummaryQuery implements IStudentStatusStatisticsSummaryQuery {
    sortExpression?: string | undefined;
    academicYearIds?: number[] | undefined;
    trainingTypes?: number[] | undefined;
    majors?: number[] | undefined;
    classTypes?: ClassTypeEnum[] | undefined;
    monthFrom?: string | undefined;
    monthTo?: string | undefined;

    constructor(data?: IStudentStatusStatisticsSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            if (Array.isArray(_data["majors"])) {
                this.majors = [] as any;
                for (let item of _data["majors"])
                    this.majors!.push(item);
            }
            if (Array.isArray(_data["classTypes"])) {
                this.classTypes = [] as any;
                for (let item of _data["classTypes"])
                    this.classTypes!.push(item);
            }
            this.monthFrom = _data["monthFrom"];
            this.monthTo = _data["monthTo"];
        }
    }

    static fromJS(data: any): StudentStatusStatisticsSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusStatisticsSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        if (Array.isArray(this.majors)) {
            data["majors"] = [];
            for (let item of this.majors)
                data["majors"].push(item);
        }
        if (Array.isArray(this.classTypes)) {
            data["classTypes"] = [];
            for (let item of this.classTypes)
                data["classTypes"].push(item);
        }
        data["monthFrom"] = this.monthFrom;
        data["monthTo"] = this.monthTo;
        return data;
    }
}

export interface IStudentStatusStatisticsSummaryQuery {
    sortExpression?: string | undefined;
    academicYearIds?: number[] | undefined;
    trainingTypes?: number[] | undefined;
    majors?: number[] | undefined;
    classTypes?: ClassTypeEnum[] | undefined;
    monthFrom?: string | undefined;
    monthTo?: string | undefined;
}

export class StudentStatusTimelineNode implements IStudentStatusTimelineNode {
    year?: number;
    month?: number;
    status?: StudentStatusEntity;
    isFuture?: boolean;
    lastModifiedBy?: number;
    classId?: number;

    constructor(data?: IStudentStatusTimelineNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.status = _data["status"] ? StudentStatusEntity.fromJS(_data["status"]) : <any>undefined;
            this.isFuture = _data["isFuture"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentStatusTimelineNode {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusTimelineNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["isFuture"] = this.isFuture;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentStatusTimelineNode {
    year?: number;
    month?: number;
    status?: StudentStatusEntity;
    isFuture?: boolean;
    lastModifiedBy?: number;
    classId?: number;
}

export class StudentBulkImportAdvancedError implements IStudentBulkImportAdvancedError {
    rowIndex?: number;
    studentName?: string | undefined;
    error?: string | undefined;

    constructor(data?: IStudentBulkImportAdvancedError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.studentName = _data["studentName"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): StudentBulkImportAdvancedError {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportAdvancedError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["studentName"] = this.studentName;
        data["error"] = this.error;
        return data;
    }
}

export interface IStudentBulkImportAdvancedError {
    rowIndex?: number;
    studentName?: string | undefined;
    error?: string | undefined;
}

export class StudentBulkImportAdvancedResult implements IStudentBulkImportAdvancedResult {
    totalProcessed?: number;
    successCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportAdvancedError[] | undefined;
    updateCount?: number;

    constructor(data?: IStudentBulkImportAdvancedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(StudentBulkImportAdvancedError.fromJS(item));
            }
            this.updateCount = _data["updateCount"];
        }
    }

    static fromJS(data: any): StudentBulkImportAdvancedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportAdvancedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["updateCount"] = this.updateCount;
        return data;
    }
}

export interface IStudentBulkImportAdvancedResult {
    totalProcessed?: number;
    successCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportAdvancedError[] | undefined;
    updateCount?: number;
}

export class StudentBulkImportError implements IStudentBulkImportError {
    rowIndex?: number;
    studentName?: string | undefined;
    error?: string | undefined;

    constructor(data?: IStudentBulkImportError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.studentName = _data["studentName"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): StudentBulkImportError {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["studentName"] = this.studentName;
        data["error"] = this.error;
        return data;
    }
}

export interface IStudentBulkImportError {
    rowIndex?: number;
    studentName?: string | undefined;
    error?: string | undefined;
}

export class StudentBulkImportFullError implements IStudentBulkImportFullError {
    rowIndex?: number;
    studentCode?: string | undefined;
    studentName?: string | undefined;
    error?: string | undefined;

    constructor(data?: IStudentBulkImportFullError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.studentCode = _data["studentCode"];
            this.studentName = _data["studentName"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): StudentBulkImportFullError {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportFullError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["studentCode"] = this.studentCode;
        data["studentName"] = this.studentName;
        data["error"] = this.error;
        return data;
    }
}

export interface IStudentBulkImportFullError {
    rowIndex?: number;
    studentCode?: string | undefined;
    studentName?: string | undefined;
    error?: string | undefined;
}

export class StudentBulkImportFullResult implements IStudentBulkImportFullResult {
    totalProcessed?: number;
    successCount?: number;
    updateCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportFullError[] | undefined;

    constructor(data?: IStudentBulkImportFullResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.successCount = _data["successCount"];
            this.updateCount = _data["updateCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(StudentBulkImportFullError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentBulkImportFullResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportFullResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["successCount"] = this.successCount;
        data["updateCount"] = this.updateCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentBulkImportFullResult {
    totalProcessed?: number;
    successCount?: number;
    updateCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportFullError[] | undefined;
}

export class StudentBulkImportResult implements IStudentBulkImportResult {
    totalProcessed?: number;
    successCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportError[] | undefined;

    constructor(data?: IStudentBulkImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(StudentBulkImportError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentBulkImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentBulkImportResult {
    totalProcessed?: number;
    successCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportError[] | undefined;
}

export class StudentBulkImportV2Error implements IStudentBulkImportV2Error {
    rowIndex?: number;
    studentCode?: string | undefined;
    studentName?: string | undefined;
    error?: string | undefined;

    constructor(data?: IStudentBulkImportV2Error) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.studentCode = _data["studentCode"];
            this.studentName = _data["studentName"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): StudentBulkImportV2Error {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportV2Error();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["studentCode"] = this.studentCode;
        data["studentName"] = this.studentName;
        data["error"] = this.error;
        return data;
    }
}

export interface IStudentBulkImportV2Error {
    rowIndex?: number;
    studentCode?: string | undefined;
    studentName?: string | undefined;
    error?: string | undefined;
}

export class StudentBulkImportV2Result implements IStudentBulkImportV2Result {
    totalProcessed?: number;
    successCount?: number;
    updateCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportV2Error[] | undefined;

    constructor(data?: IStudentBulkImportV2Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProcessed = _data["totalProcessed"];
            this.successCount = _data["successCount"];
            this.updateCount = _data["updateCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(StudentBulkImportV2Error.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentBulkImportV2Result {
        data = typeof data === 'object' ? data : {};
        let result = new StudentBulkImportV2Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProcessed"] = this.totalProcessed;
        data["successCount"] = this.successCount;
        data["updateCount"] = this.updateCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentBulkImportV2Result {
    totalProcessed?: number;
    successCount?: number;
    updateCount?: number;
    failedCount?: number;
    errors?: StudentBulkImportV2Error[] | undefined;
}

export class StudentParseData implements IStudentParseData {
    stt?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    middleName?: string | undefined;
    firstName?: string | undefined;
    gender?: string | undefined;
    birthDay?: Date | undefined;
    phone?: string | undefined;
    schoolEmail?: string | undefined;
    personalEmail?: string | undefined;
    area?: string | undefined;
    address?: string | undefined;
    trainingType?: string | undefined;
    major?: string | undefined;
    className?: string | undefined;
    academicYear?: string | undefined;
    birthPlace?: string | undefined;
    ethnicity?: string | undefined;
    citizenId?: string | undefined;
    enrollmentDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    campus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    highSchool?: string | undefined;
    highSchoolProvince?: string | undefined;
    profileStatus?: string | undefined;
    note?: string | undefined;
    tuitionFee?: string | undefined;
    processStatus?: string | undefined;
    registrationForm?: string | undefined;
    resume?: string | undefined;
    birthCertificate?: string | undefined;
    citizenIdCopy?: string | undefined;
    graduationCertificate?: string | undefined;
    diploma?: string | undefined;
    academicRecord?: string | undefined;
    healthCheck?: string | undefined;
    residenceConfirmation?: string | undefined;
    photo?: string | undefined;
    temporaryAddress?: string | undefined;
    isValid?: boolean;
    errors?: string[] | undefined;

    constructor(data?: IStudentParseData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stt = _data["stt"];
            this.studentCode = _data["studentCode"];
            this.fullName = _data["fullName"];
            this.middleName = _data["middleName"];
            this.firstName = _data["firstName"];
            this.gender = _data["gender"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.phone = _data["phone"];
            this.schoolEmail = _data["schoolEmail"];
            this.personalEmail = _data["personalEmail"];
            this.area = _data["area"];
            this.address = _data["address"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.className = _data["className"];
            this.academicYear = _data["academicYear"];
            this.birthPlace = _data["birthPlace"];
            this.ethnicity = _data["ethnicity"];
            this.citizenId = _data["citizenId"];
            this.enrollmentDate = _data["enrollmentDate"] ? new Date(_data["enrollmentDate"].toString()) : <any>undefined;
            this.admissionsConsultantName = _data["admissionsConsultantName"];
            this.campus = _data["campus"];
            this.fatherName = _data["fatherName"];
            this.fatherPhone = _data["fatherPhone"];
            this.motherName = _data["motherName"];
            this.motherPhone = _data["motherPhone"];
            this.guardianName = _data["guardianName"];
            this.guardianPhone = _data["guardianPhone"];
            this.highSchool = _data["highSchool"];
            this.highSchoolProvince = _data["highSchoolProvince"];
            this.profileStatus = _data["profileStatus"];
            this.note = _data["note"];
            this.tuitionFee = _data["tuitionFee"];
            this.processStatus = _data["processStatus"];
            this.registrationForm = _data["registrationForm"];
            this.resume = _data["resume"];
            this.birthCertificate = _data["birthCertificate"];
            this.citizenIdCopy = _data["citizenIdCopy"];
            this.graduationCertificate = _data["graduationCertificate"];
            this.diploma = _data["diploma"];
            this.academicRecord = _data["academicRecord"];
            this.healthCheck = _data["healthCheck"];
            this.residenceConfirmation = _data["residenceConfirmation"];
            this.photo = _data["photo"];
            this.temporaryAddress = _data["temporaryAddress"];
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): StudentParseData {
        data = typeof data === 'object' ? data : {};
        let result = new StudentParseData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stt"] = this.stt;
        data["studentCode"] = this.studentCode;
        data["fullName"] = this.fullName;
        data["middleName"] = this.middleName;
        data["firstName"] = this.firstName;
        data["gender"] = this.gender;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["phone"] = this.phone;
        data["schoolEmail"] = this.schoolEmail;
        data["personalEmail"] = this.personalEmail;
        data["area"] = this.area;
        data["address"] = this.address;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["className"] = this.className;
        data["academicYear"] = this.academicYear;
        data["birthPlace"] = this.birthPlace;
        data["ethnicity"] = this.ethnicity;
        data["citizenId"] = this.citizenId;
        data["enrollmentDate"] = this.enrollmentDate ? this.enrollmentDate.toISOString() : <any>undefined;
        data["admissionsConsultantName"] = this.admissionsConsultantName;
        data["campus"] = this.campus;
        data["fatherName"] = this.fatherName;
        data["fatherPhone"] = this.fatherPhone;
        data["motherName"] = this.motherName;
        data["motherPhone"] = this.motherPhone;
        data["guardianName"] = this.guardianName;
        data["guardianPhone"] = this.guardianPhone;
        data["highSchool"] = this.highSchool;
        data["highSchoolProvince"] = this.highSchoolProvince;
        data["profileStatus"] = this.profileStatus;
        data["note"] = this.note;
        data["tuitionFee"] = this.tuitionFee;
        data["processStatus"] = this.processStatus;
        data["registrationForm"] = this.registrationForm;
        data["resume"] = this.resume;
        data["birthCertificate"] = this.birthCertificate;
        data["citizenIdCopy"] = this.citizenIdCopy;
        data["graduationCertificate"] = this.graduationCertificate;
        data["diploma"] = this.diploma;
        data["academicRecord"] = this.academicRecord;
        data["healthCheck"] = this.healthCheck;
        data["residenceConfirmation"] = this.residenceConfirmation;
        data["photo"] = this.photo;
        data["temporaryAddress"] = this.temporaryAddress;
        data["isValid"] = this.isValid;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IStudentParseData {
    stt?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    middleName?: string | undefined;
    firstName?: string | undefined;
    gender?: string | undefined;
    birthDay?: Date | undefined;
    phone?: string | undefined;
    schoolEmail?: string | undefined;
    personalEmail?: string | undefined;
    area?: string | undefined;
    address?: string | undefined;
    trainingType?: string | undefined;
    major?: string | undefined;
    className?: string | undefined;
    academicYear?: string | undefined;
    birthPlace?: string | undefined;
    ethnicity?: string | undefined;
    citizenId?: string | undefined;
    enrollmentDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    campus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    highSchool?: string | undefined;
    highSchoolProvince?: string | undefined;
    profileStatus?: string | undefined;
    note?: string | undefined;
    tuitionFee?: string | undefined;
    processStatus?: string | undefined;
    registrationForm?: string | undefined;
    resume?: string | undefined;
    birthCertificate?: string | undefined;
    citizenIdCopy?: string | undefined;
    graduationCertificate?: string | undefined;
    diploma?: string | undefined;
    academicRecord?: string | undefined;
    healthCheck?: string | undefined;
    residenceConfirmation?: string | undefined;
    photo?: string | undefined;
    temporaryAddress?: string | undefined;
    isValid?: boolean;
    errors?: string[] | undefined;
}

export class StudentParseExcelAdvancedResult implements IStudentParseExcelAdvancedResult {
    students?: StudentParseData[] | undefined;
    totalRows?: number;
    validRows?: number;
    invalidRows?: number;

    constructor(data?: IStudentParseExcelAdvancedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["students"])) {
                this.students = [] as any;
                for (let item of _data["students"])
                    this.students!.push(StudentParseData.fromJS(item));
            }
            this.totalRows = _data["totalRows"];
            this.validRows = _data["validRows"];
            this.invalidRows = _data["invalidRows"];
        }
    }

    static fromJS(data: any): StudentParseExcelAdvancedResult {
        data = typeof data === 'object' ? data : {};
        let result = new StudentParseExcelAdvancedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.students)) {
            data["students"] = [];
            for (let item of this.students)
                data["students"].push(item.toJSON());
        }
        data["totalRows"] = this.totalRows;
        data["validRows"] = this.validRows;
        data["invalidRows"] = this.invalidRows;
        return data;
    }
}

export interface IStudentParseExcelAdvancedResult {
    students?: StudentParseData[] | undefined;
    totalRows?: number;
    validRows?: number;
    invalidRows?: number;
}

export class EnumItemEntity implements IEnumItemEntity {
    id?: number;
    name?: string | undefined;
    readonly code?: string | undefined;

    constructor(data?: IEnumItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            (<any>this).code = _data["code"];
        }
    }

    static fromJS(data: any): EnumItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IEnumItemEntity {
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
}

export class EnumListEntity implements IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;

    constructor(data?: IEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isZone = _data["isZone"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(EnumListEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isZone"] = this.isZone;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnumListEntity {
    value?: number;
    code?: string | undefined;
    name?: string | undefined;
    isZone?: boolean;
    permissions?: EnumListEntity[] | undefined;
}

export class ApiResponse_1OfBoolean implements IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfBoolean {
    data?: boolean;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfString implements IApiResponse_1OfList_1OfString {
    data?: string[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfString {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfString {
    data?: string[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFolderNodeDto implements IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFolderNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FolderNodeDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFolderNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFolderNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFolderNodeDto {
    data?: FolderNodeDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStudentDocumentDto implements IApiResponse_1OfList_1OfStudentDocumentDto {
    data?: StudentDocumentDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStudentDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentDocumentDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStudentDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStudentDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStudentDocumentDto {
    data?: StudentDocumentDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStudentStatusTimelineNode implements IApiResponse_1OfList_1OfStudentStatusTimelineNode {
    data?: StudentStatusTimelineNode[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStudentStatusTimelineNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentStatusTimelineNode.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStudentStatusTimelineNode {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStudentStatusTimelineNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStudentStatusTimelineNode {
    data?: StudentStatusTimelineNode[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfEnumListEntity implements IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfEnumListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EnumListEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfEnumListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfEnumListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfEnumListEntity {
    data?: EnumListEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfComponentScoreListDto implements IApiResponse_1OfList_1OfComponentScoreListDto {
    data?: ComponentScoreListDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfComponentScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ComponentScoreListDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfComponentScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfComponentScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfComponentScoreListDto {
    data?: ComponentScoreListDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfConductScoreListDto implements IApiResponse_1OfList_1OfConductScoreListDto {
    data?: ConductScoreListDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfConductScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConductScoreListDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfConductScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfConductScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfConductScoreListDto {
    data?: ConductScoreListDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfObjectPermissionDto implements IApiResponse_1OfList_1OfObjectPermissionDto {
    data?: ObjectPermissionDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfObjectPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ObjectPermissionDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfObjectPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfObjectPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfObjectPermissionDto {
    data?: ObjectPermissionDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto implements IApiResponse_1OfList_1OfReceiptBatchPreviewItemDto {
    data?: ReceiptBatchPreviewItemDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfReceiptBatchPreviewItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReceiptBatchPreviewItemDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfReceiptBatchPreviewItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfReceiptBatchPreviewItemDto {
    data?: ReceiptBatchPreviewItemDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfRoleDto implements IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RoleDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfRoleDto {
    data?: RoleDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto implements IApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto {
    data?: StudentStatusStatisticsSummaryDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentStatusStatisticsSummaryDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfStudentStatusStatisticsSummaryDto {
    data?: StudentStatusStatisticsSummaryDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfSubjectScoreListDto implements IApiResponse_1OfList_1OfSubjectScoreListDto {
    data?: SubjectScoreListDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfSubjectScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubjectScoreListDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfSubjectScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfSubjectScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfSubjectScoreListDto {
    data?: SubjectScoreListDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTagDto implements IApiResponse_1OfList_1OfTagDto {
    data?: TagDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTagDto {
    data?: TagDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfTranscriptListDto implements IApiResponse_1OfList_1OfTranscriptListDto {
    data?: TranscriptListDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfTranscriptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TranscriptListDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfTranscriptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfTranscriptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfTranscriptListDto {
    data?: TranscriptListDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfUserWithSimpleInfoDto implements IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfUserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfUserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfUserWithSimpleInfoDto {
    data?: UserWithSimpleInfoDto[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFeeScheduleEntity implements IApiResponse_1OfList_1OfFeeScheduleEntity {
    data?: FeeScheduleEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFeeScheduleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeeScheduleEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFeeScheduleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFeeScheduleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFeeScheduleEntity {
    data?: FeeScheduleEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfFileMetaDataEntity implements IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileMetaDataEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfFileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfFileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfFileMetaDataEntity {
    data?: FileMetaDataEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfLocalityEntity implements IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfLocalityEntity {
    data?: LocalityEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfList_1OfAcademicYearEntity implements IApiResponse_1OfList_1OfAcademicYearEntity {
    data?: AcademicYearEntity[] | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfList_1OfAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AcademicYearEntity.fromJS(item));
            }
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfList_1OfAcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfList_1OfAcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfList_1OfAcademicYearEntity {
    data?: AcademicYearEntity[] | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfInt64 implements IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfInt64 {
    data?: number;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfObject implements IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfObject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfObject {
    data?: any | undefined;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPermissionUsersDto implements IApiResponse_1OfPermissionUsersDto {
    data?: PermissionUsersDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPermissionUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PermissionUsersDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPermissionUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPermissionUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPermissionUsersDto {
    data?: PermissionUsersDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfResponseX implements IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfResponseX) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ResponseX.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfResponseX {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfResponseX();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfResponseX {
    data?: ResponseX;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSystemInitDto implements IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSystemInitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SystemInitDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSystemInitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSystemInitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSystemInitDto {
    data?: SystemInitDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCurrentObjectDto implements IApiResponse_1OfCurrentObjectDto {
    data?: CurrentObjectDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCurrentObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CurrentObjectDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCurrentObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCurrentObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCurrentObjectDto {
    data?: CurrentObjectDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfLoginResponseDto implements IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfLoginResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? LoginResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfLoginResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfLoginResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfLoginResponseDto {
    data?: LoginResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRefreshTokenResponseDto implements IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRefreshTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RefreshTokenResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRefreshTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRefreshTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRefreshTokenResponseDto {
    data?: RefreshTokenResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRegisterDto implements IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RegisterDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRegisterDto {
    data?: RegisterDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserInfoDto implements IApiResponse_1OfUserInfoDto {
    data?: UserInfoDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserInfoDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserInfoDto {
    data?: UserInfoDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFileUploadByUrlResponseDto implements IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFileUploadByUrlResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FileUploadByUrlResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFileUploadByUrlResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFileUploadByUrlResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFileUploadByUrlResponseDto {
    data?: FileUploadByUrlResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfBatchUpdateResult implements IApiResponse_1OfBatchUpdateResult {
    data?: BatchUpdateResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfBatchUpdateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BatchUpdateResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfBatchUpdateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfBatchUpdateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfBatchUpdateResult {
    data?: BatchUpdateResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfBulkUpdateByClassResult implements IApiResponse_1OfBulkUpdateByClassResult {
    data?: BulkUpdateByClassResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfBulkUpdateByClassResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BulkUpdateByClassResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfBulkUpdateByClassResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfBulkUpdateByClassResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfBulkUpdateByClassResult {
    data?: BulkUpdateByClassResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentBulkImportAdvancedResult implements IApiResponse_1OfStudentBulkImportAdvancedResult {
    data?: StudentBulkImportAdvancedResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentBulkImportAdvancedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentBulkImportAdvancedResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentBulkImportAdvancedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentBulkImportAdvancedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentBulkImportAdvancedResult {
    data?: StudentBulkImportAdvancedResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentBulkImportFullResult implements IApiResponse_1OfStudentBulkImportFullResult {
    data?: StudentBulkImportFullResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentBulkImportFullResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentBulkImportFullResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentBulkImportFullResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentBulkImportFullResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentBulkImportFullResult {
    data?: StudentBulkImportFullResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentBulkImportResult implements IApiResponse_1OfStudentBulkImportResult {
    data?: StudentBulkImportResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentBulkImportResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentBulkImportResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentBulkImportResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentBulkImportResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentBulkImportResult {
    data?: StudentBulkImportResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentBulkImportV2Result implements IApiResponse_1OfStudentBulkImportV2Result {
    data?: StudentBulkImportV2Result;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentBulkImportV2Result) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentBulkImportV2Result.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentBulkImportV2Result {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentBulkImportV2Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentBulkImportV2Result {
    data?: StudentBulkImportV2Result;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentParseExcelAdvancedResult implements IApiResponse_1OfStudentParseExcelAdvancedResult {
    data?: StudentParseExcelAdvancedResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentParseExcelAdvancedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentParseExcelAdvancedResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentParseExcelAdvancedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentParseExcelAdvancedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentParseExcelAdvancedResult {
    data?: StudentParseExcelAdvancedResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupDetailDto implements IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupDetailDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupDetailDto {
    data?: ChatGroupDetailDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfClassDetailDto implements IApiResponse_1OfClassDetailDto {
    data?: ClassDetailDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfClassDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ClassDetailDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfClassDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfClassDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfClassDetailDto {
    data?: ClassDetailDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfDashboardStudentStatusDto implements IApiResponse_1OfDashboardStudentStatusDto {
    data?: DashboardStudentStatusDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfDashboardStudentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DashboardStudentStatusDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfDashboardStudentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfDashboardStudentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfDashboardStudentStatusDto {
    data?: DashboardStudentStatusDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFeeScheduleDto implements IApiResponse_1OfFeeScheduleDto {
    data?: FeeScheduleDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFeeScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FeeScheduleDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFeeScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFeeScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFeeScheduleDto {
    data?: FeeScheduleDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfPaymentTrackingDto implements IApiResponse_1OfPaymentTrackingDto {
    data?: PaymentTrackingDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfPaymentTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? PaymentTrackingDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfPaymentTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfPaymentTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfPaymentTrackingDto {
    data?: PaymentTrackingDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfReceiptBatchCreateResultDto implements IApiResponse_1OfReceiptBatchCreateResultDto {
    data?: ReceiptBatchCreateResultDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfReceiptBatchCreateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReceiptBatchCreateResultDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfReceiptBatchCreateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfReceiptBatchCreateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfReceiptBatchCreateResultDto {
    data?: ReceiptBatchCreateResultDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfReceiptDto implements IApiResponse_1OfReceiptDto {
    data?: ReceiptDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReceiptDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfReceiptDto {
    data?: ReceiptDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfRoleDto implements IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? RoleDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfRoleDto {
    data?: RoleDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentListDto implements IApiResponse_1OfStudentListDto {
    data?: StudentListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentListDto {
    data?: StudentListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfTagDto implements IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? TagDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfTagDto {
    data?: TagDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfActivityLogEntity implements IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ActivityLogEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfActivityLogEntity {
    data?: ActivityLogEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto implements IApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto {
    data?: FilterResult_1OfStudentListByStatusMonthDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfStudentListByStatusMonthDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfStudentListByStatusMonthDto {
    data?: FilterResult_1OfStudentListByStatusMonthDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfCategoryListDto implements IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfCategoryListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfCategoryListDto {
    data?: FilterResult_1OfCategoryListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfClassListDto implements IApiResponse_1OfFilterResult_1OfClassListDto {
    data?: FilterResult_1OfClassListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfClassListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfClassListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfClassListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfClassListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfClassListDto {
    data?: FilterResult_1OfClassListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfComponentScoreListDto implements IApiResponse_1OfFilterResult_1OfComponentScoreListDto {
    data?: FilterResult_1OfComponentScoreListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfComponentScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfComponentScoreListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfComponentScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfComponentScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfComponentScoreListDto {
    data?: FilterResult_1OfComponentScoreListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfConductScoreListDto implements IApiResponse_1OfFilterResult_1OfConductScoreListDto {
    data?: FilterResult_1OfConductScoreListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfConductScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfConductScoreListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfConductScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfConductScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfConductScoreListDto {
    data?: FilterResult_1OfConductScoreListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListActivityLogDto implements IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListActivityLogDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListActivityLogDto {
    data?: FilterResult_1OfListActivityLogDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatGroupDto implements IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatGroupDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatGroupDto {
    data?: FilterResult_1OfListChatGroupDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto implements IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfListChatMessageByGroupDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfListChatMessageByGroupDto {
    data?: FilterResult_1OfListChatMessageByGroupDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfReceiptListDto implements IApiResponse_1OfFilterResult_1OfReceiptListDto {
    data?: FilterResult_1OfReceiptListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfReceiptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfReceiptListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfReceiptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfReceiptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfReceiptListDto {
    data?: FilterResult_1OfReceiptListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfStudentListDto implements IApiResponse_1OfFilterResult_1OfStudentListDto {
    data?: FilterResult_1OfStudentListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfStudentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfStudentListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfStudentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfStudentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfStudentListDto {
    data?: FilterResult_1OfStudentListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto implements IApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto {
    data?: FilterResult_1OfStudentStatusStatisticsDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfStudentStatusStatisticsDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfStudentStatusStatisticsDto {
    data?: FilterResult_1OfStudentStatusStatisticsDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfSubjectListDto implements IApiResponse_1OfFilterResult_1OfSubjectListDto {
    data?: FilterResult_1OfSubjectListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfSubjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfSubjectListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfSubjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfSubjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfSubjectListDto {
    data?: FilterResult_1OfSubjectListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfSubjectScoreListDto implements IApiResponse_1OfFilterResult_1OfSubjectScoreListDto {
    data?: FilterResult_1OfSubjectScoreListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfSubjectScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfSubjectScoreListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfSubjectScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfSubjectScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfSubjectScoreListDto {
    data?: FilterResult_1OfSubjectScoreListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTagListDto implements IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTagListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTagListDto {
    data?: FilterResult_1OfTagListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfTranscriptListDto implements IApiResponse_1OfFilterResult_1OfTranscriptListDto {
    data?: FilterResult_1OfTranscriptListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfTranscriptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfTranscriptListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfTranscriptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfTranscriptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfTranscriptListDto {
    data?: FilterResult_1OfTranscriptListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfUserListDto implements IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfUserListDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfUserListDto {
    data?: FilterResult_1OfUserListDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfConfigEntity implements IApiResponse_1OfFilterResult_1OfConfigEntity {
    data?: FilterResult_1OfConfigEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfConfigEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfConfigEntity {
    data?: FilterResult_1OfConfigEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfFileEntity implements IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfFileEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfFileEntity {
    data?: FilterResult_1OfFileEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfLocalityEntity implements IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfLocalityEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfLocalityEntity {
    data?: FilterResult_1OfLocalityEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFilterResult_1OfScholarShipEntity implements IApiResponse_1OfFilterResult_1OfScholarShipEntity {
    data?: FilterResult_1OfScholarShipEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFilterResult_1OfScholarShipEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FilterResult_1OfScholarShipEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFilterResult_1OfScholarShipEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFilterResult_1OfScholarShipEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFilterResult_1OfScholarShipEntity {
    data?: FilterResult_1OfScholarShipEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfCategoryEntity implements IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfCategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? CategoryEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfCategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfCategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfCategoryEntity {
    data?: CategoryEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfChatGroupEntity implements IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ChatGroupEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfChatGroupEntity {
    data?: ChatGroupEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfConfigEntity implements IApiResponse_1OfConfigEntity {
    data?: ConfigEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ConfigEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfConfigEntity {
    data?: ConfigEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFeeScheduleEntity implements IApiResponse_1OfFeeScheduleEntity {
    data?: FeeScheduleEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFeeScheduleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FeeScheduleEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFeeScheduleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFeeScheduleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFeeScheduleEntity {
    data?: FeeScheduleEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfFolderEntity implements IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? FolderEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfFolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfFolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfFolderEntity {
    data?: FolderEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserMobileTokenEntity implements IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserMobileTokenEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserMobileTokenEntity {
    data?: UserMobileTokenEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfUserWebTokenEntity implements IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? UserWebTokenEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfUserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfUserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfUserWebTokenEntity {
    data?: UserWebTokenEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfScholarShipEntity implements IApiResponse_1OfScholarShipEntity {
    data?: ScholarShipEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfScholarShipEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ScholarShipEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfScholarShipEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfScholarShipEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfScholarShipEntity {
    data?: ScholarShipEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfAcademicYearEntity implements IApiResponse_1OfAcademicYearEntity {
    data?: AcademicYearEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AcademicYearEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfAcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfAcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfAcademicYearEntity {
    data?: AcademicYearEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSubjectEntity implements IApiResponse_1OfSubjectEntity {
    data?: SubjectEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSubjectEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SubjectEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSubjectEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSubjectEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSubjectEntity {
    data?: SubjectEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfReceiptEntity implements IApiResponse_1OfReceiptEntity {
    data?: ReceiptEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfReceiptEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ReceiptEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfReceiptEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfReceiptEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfReceiptEntity {
    data?: ReceiptEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfStudentEntity implements IApiResponse_1OfStudentEntity {
    data?: StudentEntity;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfStudentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? StudentEntity.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfStudentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfStudentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfStudentEntity {
    data?: StudentEntity;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfQrGenerateResponseDto implements IApiResponse_1OfQrGenerateResponseDto {
    data?: QrGenerateResponseDto;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfQrGenerateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? QrGenerateResponseDto.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfQrGenerateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfQrGenerateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfQrGenerateResponseDto {
    data?: QrGenerateResponseDto;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfSeedResult implements IApiResponse_1OfSeedResult {
    data?: SeedResult;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfSeedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SeedResult.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfSeedResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfSeedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfSeedResult {
    data?: SeedResult;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export class ApiResponse_1OfVapidDetails implements IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    readonly success?: boolean;
    code?: ErrorCodeEnum;

    constructor(data?: IApiResponse_1OfVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? VapidDetails.fromJS(_data["data"]) : <any>undefined;
            this.message = _data["message"];
            (<any>this).success = _data["success"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApiResponse_1OfVapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponse_1OfVapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["message"] = this.message;
        data["success"] = this.success;
        data["code"] = this.code;
        return data;
    }
}

export interface IApiResponse_1OfVapidDetails {
    data?: VapidDetails;
    message?: string | undefined;
    success?: boolean;
    code?: ErrorCodeEnum;
}

export enum CategoryTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ClassListSearchTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ClassStatusEnum {
    _1 = 1,
    _2 = 2,
}

export enum ClassTypeEnum {
    _1 = 1,
    _2 = 2,
}

export enum ClassUserRoleEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CommonStatusEnum {
    _1 = 1,
    _2 = 2,
}

export enum ConductEvaluationStepEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum ErrorCodeEnum {
    _0 = 0,
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _104 = 104,
    _105 = 105,
    _106 = 106,
    _107 = 107,
    _108 = 108,
    _109 = 109,
    _110 = 110,
    _111 = 111,
    _112 = 112,
    _113 = 113,
    _114 = 114,
    _115 = 115,
    _116 = 116,
    _117 = 117,
    _118 = 118,
    _119 = 119,
    _120 = 120,
    _121 = 121,
    _122 = 122,
    _123 = 123,
    _200 = 200,
    _201 = 201,
    _202 = 202,
    _203 = 203,
    _204 = 204,
    _205 = 205,
    _206 = 206,
    _207 = 207,
    _208 = 208,
    _226 = 226,
    _300 = 300,
    _301 = 301,
    _302 = 302,
    _303 = 303,
    _304 = 304,
    _305 = 305,
    _306 = 306,
    _307 = 307,
    _308 = 308,
    _400 = 400,
    _401 = 401,
    _402 = 402,
    _403 = 403,
    _404 = 404,
    _405 = 405,
    _406 = 406,
    _407 = 407,
    _408 = 408,
    _409 = 409,
    _410 = 410,
    _411 = 411,
    _412 = 412,
    _413 = 413,
    _414 = 414,
    _415 = 415,
    _416 = 416,
    _417 = 417,
    _421 = 421,
    _422 = 422,
    _423 = 423,
    _424 = 424,
    _426 = 426,
    _428 = 428,
    _429 = 429,
    _431 = 431,
    _451 = 451,
    _500 = 500,
    _501 = 501,
    _502 = 502,
    _503 = 503,
    _504 = 504,
    _505 = 505,
    _506 = 506,
    _507 = 507,
    _508 = 508,
    _510 = 510,
    _511 = 511,
    _512 = 512,
    _513 = 513,
    __1 = -1,
}

export enum LocalityStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum ModuleEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _11 = 11,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _98 = 98,
    _99 = 99,
}

export enum PaymentMethodEnum {
    _1 = 1,
    _2 = 2,
}

export enum PermissionEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _1073741824 = 1073741824,
    _34359738368 = 34359738368,
}

export enum ReceiptProcessStatusEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum ReceiptStatusEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum StudentDocumentStatusEnum {
    _1 = 1,
    _2 = 2,
}

export enum StudentProcessStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum StudentStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
}

export enum StudentStepEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum SubjectScoreStatusEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum UserTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class BankAccountDto implements IBankAccountDto {
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    bankCode?: string | undefined;
    id?: number;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.accountNumber = _data["accountNumber"];
            this.accountName = _data["accountName"];
            this.bankCode = _data["bankCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["accountNumber"] = this.accountNumber;
        data["accountName"] = this.accountName;
        data["bankCode"] = this.bankCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IBankAccountDto {
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    accountName?: string | undefined;
    bankCode?: string | undefined;
    id?: number;
}

export class CategoryGetListQuery implements ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;
    type?: CategoryTypeEnum;

    constructor(data?: ICategoryGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.code = _data["code"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CategoryGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["code"] = this.code;
        data["type"] = this.type;
        return data;
    }
}

export interface ICategoryGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    code?: string | undefined;
    type?: CategoryTypeEnum;
}

export class CategoryListDto implements ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    type?: CategoryTypeEnum;
    trainingTypes?: number[] | undefined;

    constructor(data?: ICategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        return data;
    }
}

export interface ICategoryListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    type?: CategoryTypeEnum;
    trainingTypes?: number[] | undefined;
}

export class ChatGroupDetailDto implements IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;

    constructor(data?: IChatGroupDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            if (Array.isArray(_data["listUserOfGroup"])) {
                this.listUserOfGroup = [] as any;
                for (let item of _data["listUserOfGroup"])
                    this.listUserOfGroup!.push(UserWithSimpleInfoDto.fromJS(item));
            }
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): ChatGroupDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        if (Array.isArray(this.listUserOfGroup)) {
            data["listUserOfGroup"] = [];
            for (let item of this.listUserOfGroup)
                data["listUserOfGroup"].push(item.toJSON());
        }
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IChatGroupDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    listUserOfGroup?: UserWithSimpleInfoDto[] | undefined;
    isOnline?: boolean;
}

export class ClassByUserDto implements IClassByUserDto {
    id?: number;
    name?: string | undefined;
    studentId?: number;
    status?: StudentStatusEnum;
    createdDate?: Date;

    constructor(data?: IClassByUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.studentId = _data["studentId"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ClassByUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassByUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["studentId"] = this.studentId;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IClassByUserDto {
    id?: number;
    name?: string | undefined;
    studentId?: number;
    status?: StudentStatusEnum;
    createdDate?: Date;
}

export class ClassDetailDto implements IClassDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;
    currentRole?: ClassUserRoleEnum;

    constructor(data?: IClassDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.trainingType = _data["trainingType"];
            this.classType = _data["classType"];
            this.major = _data["major"];
            this.maxStudent = _data["maxStudent"];
            this.status = _data["status"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            this.currentRole = _data["currentRole"];
        }
    }

    static fromJS(data: any): ClassDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["trainingType"] = this.trainingType;
        data["classType"] = this.classType;
        data["major"] = this.major;
        data["maxStudent"] = this.maxStudent;
        data["status"] = this.status;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item.toJSON());
        }
        data["currentRole"] = this.currentRole;
        return data;
    }
}

export interface IClassDetailDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;
    currentRole?: ClassUserRoleEnum;
}

export class ClassGetListFilter implements IClassGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    academicYearIds?: number[] | undefined;
    status?: ClassStatusEnum;
    trainingType?: number | undefined;
    trainingTypes?: number[] | undefined;
    major?: number | undefined;
    majors?: number[] | undefined;
    classType?: ClassTypeEnum;
    classTypes?: ClassTypeEnum[] | undefined;
    userId?: number | undefined;
    searchType?: ClassListSearchTypeEnum;
    excludeStudentId?: number | undefined;

    constructor(data?: IClassGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.status = _data["status"];
            this.trainingType = _data["trainingType"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            this.major = _data["major"];
            if (Array.isArray(_data["majors"])) {
                this.majors = [] as any;
                for (let item of _data["majors"])
                    this.majors!.push(item);
            }
            this.classType = _data["classType"];
            if (Array.isArray(_data["classTypes"])) {
                this.classTypes = [] as any;
                for (let item of _data["classTypes"])
                    this.classTypes!.push(item);
            }
            this.userId = _data["userId"];
            this.searchType = _data["searchType"];
            this.excludeStudentId = _data["excludeStudentId"];
        }
    }

    static fromJS(data: any): ClassGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ClassGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["status"] = this.status;
        data["trainingType"] = this.trainingType;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        data["major"] = this.major;
        if (Array.isArray(this.majors)) {
            data["majors"] = [];
            for (let item of this.majors)
                data["majors"].push(item);
        }
        data["classType"] = this.classType;
        if (Array.isArray(this.classTypes)) {
            data["classTypes"] = [];
            for (let item of this.classTypes)
                data["classTypes"].push(item);
        }
        data["userId"] = this.userId;
        data["searchType"] = this.searchType;
        data["excludeStudentId"] = this.excludeStudentId;
        return data;
    }
}

export interface IClassGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    academicYearIds?: number[] | undefined;
    status?: ClassStatusEnum;
    trainingType?: number | undefined;
    trainingTypes?: number[] | undefined;
    major?: number | undefined;
    majors?: number[] | undefined;
    classType?: ClassTypeEnum;
    classTypes?: ClassTypeEnum[] | undefined;
    userId?: number | undefined;
    searchType?: ClassListSearchTypeEnum;
    excludeStudentId?: number | undefined;
}

export class ClassListDto implements IClassListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;
    countStudent?: number;
    currentRole?: ClassUserRoleEnum;
    isManager?: boolean;

    constructor(data?: IClassListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.trainingType = _data["trainingType"];
            this.classType = _data["classType"];
            this.major = _data["major"];
            this.maxStudent = _data["maxStudent"];
            this.status = _data["status"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            this.countStudent = _data["countStudent"];
            this.currentRole = _data["currentRole"];
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClassListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["trainingType"] = this.trainingType;
        data["classType"] = this.classType;
        data["major"] = this.major;
        data["maxStudent"] = this.maxStudent;
        data["status"] = this.status;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item.toJSON());
        }
        data["countStudent"] = this.countStudent;
        data["currentRole"] = this.currentRole;
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;
    countStudent?: number;
    currentRole?: ClassUserRoleEnum;
    isManager?: boolean;
}

export class ComponentScoreBatchSaveDto implements IComponentScoreBatchSaveDto {
    classId?: number;
    subjectId?: number;
    academicYearId?: number;
    semester?: number;
    items?: ComponentScoreItemDto[] | undefined;

    constructor(data?: IComponentScoreBatchSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.subjectId = _data["subjectId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ComponentScoreItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentScoreBatchSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentScoreBatchSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["subjectId"] = this.subjectId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IComponentScoreBatchSaveDto {
    classId?: number;
    subjectId?: number;
    academicYearId?: number;
    semester?: number;
    items?: ComponentScoreItemDto[] | undefined;
}

export class ComponentScoreGetListFilter implements IComponentScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    subjectId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;

    constructor(data?: IComponentScoreGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.classId = _data["classId"];
            this.subjectId = _data["subjectId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.studentId = _data["studentId"];
        }
    }

    static fromJS(data: any): ComponentScoreGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentScoreGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["classId"] = this.classId;
        data["subjectId"] = this.subjectId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["studentId"] = this.studentId;
        return data;
    }
}

export interface IComponentScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    subjectId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
}

export class ComponentScoreItemDto implements IComponentScoreItemDto {
    id?: number;
    studentId?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    note?: string | undefined;

    constructor(data?: IComponentScoreItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentId = _data["studentId"];
            this.regularScores = _data["regularScores"];
            this.periodicScores = _data["periodicScores"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ComponentScoreItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentScoreItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentId"] = this.studentId;
        data["regularScores"] = this.regularScores;
        data["periodicScores"] = this.periodicScores;
        data["note"] = this.note;
        return data;
    }
}

export interface IComponentScoreItemDto {
    id?: number;
    studentId?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    note?: string | undefined;
}

export class ComponentScoreListDto implements IComponentScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    averageScore?: number | undefined;
    isEligibleForExam?: boolean;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    subjectName?: string | undefined;
    subjectCode?: string | undefined;

    constructor(data?: IComponentScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.subjectId = _data["subjectId"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.regularScores = _data["regularScores"];
            this.periodicScores = _data["periodicScores"];
            this.averageScore = _data["averageScore"];
            this.isEligibleForExam = _data["isEligibleForExam"];
            this.note = _data["note"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
            this.subjectName = _data["subjectName"];
            this.subjectCode = _data["subjectCode"];
        }
    }

    static fromJS(data: any): ComponentScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["subjectId"] = this.subjectId;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["regularScores"] = this.regularScores;
        data["periodicScores"] = this.periodicScores;
        data["averageScore"] = this.averageScore;
        data["isEligibleForExam"] = this.isEligibleForExam;
        data["note"] = this.note;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        data["subjectName"] = this.subjectName;
        data["subjectCode"] = this.subjectCode;
        return data;
    }
}

export interface IComponentScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    averageScore?: number | undefined;
    isEligibleForExam?: boolean;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    subjectName?: string | undefined;
    subjectCode?: string | undefined;
}

export class ConductScoreBatchSaveDto implements IConductScoreBatchSaveDto {
    classId?: number;
    academicYearId?: number;
    semester?: number;
    step?: ConductEvaluationStepEnum;
    items?: ConductScoreItemDto[] | undefined;

    constructor(data?: IConductScoreBatchSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.step = _data["step"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConductScoreItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConductScoreBatchSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConductScoreBatchSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["step"] = this.step;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConductScoreBatchSaveDto {
    classId?: number;
    academicYearId?: number;
    semester?: number;
    step?: ConductEvaluationStepEnum;
    items?: ConductScoreItemDto[] | undefined;
}

export class ConductScoreGetListFilter implements IConductScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    currentStep?: ConductEvaluationStepEnum;

    constructor(data?: IConductScoreGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.studentId = _data["studentId"];
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): ConductScoreGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ConductScoreGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["studentId"] = this.studentId;
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface IConductScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    currentStep?: ConductEvaluationStepEnum;
}

export class ConductScoreItemDto implements IConductScoreItemDto {
    id?: number;
    studentId?: number;
    score?: number | undefined;
    comment?: string | undefined;

    constructor(data?: IConductScoreItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentId = _data["studentId"];
            this.score = _data["score"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ConductScoreItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConductScoreItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentId"] = this.studentId;
        data["score"] = this.score;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IConductScoreItemDto {
    id?: number;
    studentId?: number;
    score?: number | undefined;
    comment?: string | undefined;
}

export class ConductScoreListDto implements IConductScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    studentSelfScore?: number | undefined;
    teacherScore?: number | undefined;
    departmentScore?: number | undefined;
    councilScore?: number | undefined;
    currentStep?: ConductEvaluationStepEnum;
    classification?: string | undefined;
    studentComment?: string | undefined;
    teacherComment?: string | undefined;
    departmentComment?: string | undefined;
    councilComment?: string | undefined;
    teacherBy?: number;
    teacherDate?: Date | undefined;
    departmentBy?: number;
    departmentDate?: Date | undefined;
    councilBy?: number;
    councilDate?: Date | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;

    constructor(data?: IConductScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.studentSelfScore = _data["studentSelfScore"];
            this.teacherScore = _data["teacherScore"];
            this.departmentScore = _data["departmentScore"];
            this.councilScore = _data["councilScore"];
            this.currentStep = _data["currentStep"];
            this.classification = _data["classification"];
            this.studentComment = _data["studentComment"];
            this.teacherComment = _data["teacherComment"];
            this.departmentComment = _data["departmentComment"];
            this.councilComment = _data["councilComment"];
            this.teacherBy = _data["teacherBy"];
            this.teacherDate = _data["teacherDate"] ? new Date(_data["teacherDate"].toString()) : <any>undefined;
            this.departmentBy = _data["departmentBy"];
            this.departmentDate = _data["departmentDate"] ? new Date(_data["departmentDate"].toString()) : <any>undefined;
            this.councilBy = _data["councilBy"];
            this.councilDate = _data["councilDate"] ? new Date(_data["councilDate"].toString()) : <any>undefined;
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
        }
    }

    static fromJS(data: any): ConductScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConductScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["studentSelfScore"] = this.studentSelfScore;
        data["teacherScore"] = this.teacherScore;
        data["departmentScore"] = this.departmentScore;
        data["councilScore"] = this.councilScore;
        data["currentStep"] = this.currentStep;
        data["classification"] = this.classification;
        data["studentComment"] = this.studentComment;
        data["teacherComment"] = this.teacherComment;
        data["departmentComment"] = this.departmentComment;
        data["councilComment"] = this.councilComment;
        data["teacherBy"] = this.teacherBy;
        data["teacherDate"] = this.teacherDate ? this.teacherDate.toISOString() : <any>undefined;
        data["departmentBy"] = this.departmentBy;
        data["departmentDate"] = this.departmentDate ? this.departmentDate.toISOString() : <any>undefined;
        data["councilBy"] = this.councilBy;
        data["councilDate"] = this.councilDate ? this.councilDate.toISOString() : <any>undefined;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        return data;
    }
}

export interface IConductScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    studentSelfScore?: number | undefined;
    teacherScore?: number | undefined;
    departmentScore?: number | undefined;
    councilScore?: number | undefined;
    currentStep?: ConductEvaluationStepEnum;
    classification?: string | undefined;
    studentComment?: string | undefined;
    teacherComment?: string | undefined;
    departmentComment?: string | undefined;
    councilComment?: string | undefined;
    teacherBy?: number;
    teacherDate?: Date | undefined;
    departmentBy?: number;
    departmentDate?: Date | undefined;
    councilBy?: number;
    councilDate?: Date | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
}

export class CreateChatGroupDto implements ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;

    constructor(data?: ICreateChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.name = _data["name"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): CreateChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["name"] = this.name;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface ICreateChatGroupDto {
    userIds?: number[] | undefined;
    name?: string | undefined;
    type?: number;
    documentId?: number | undefined;
}

export class DashboardCategoryCountDto implements IDashboardCategoryCountDto {
    categoryId?: number;
    name?: string | undefined;
    count?: number;

    constructor(data?: IDashboardCategoryCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DashboardCategoryCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardCategoryCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["count"] = this.count;
        return data;
    }
}

export interface IDashboardCategoryCountDto {
    categoryId?: number;
    name?: string | undefined;
    count?: number;
}

export class DashboardMonthlyStatusDto implements IDashboardMonthlyStatusDto {
    year?: number;
    month?: number;
    studying?: number;
    newlyEnrolled?: number;
    droppedOut?: number;

    constructor(data?: IDashboardMonthlyStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.studying = _data["studying"];
            this.newlyEnrolled = _data["newlyEnrolled"];
            this.droppedOut = _data["droppedOut"];
        }
    }

    static fromJS(data: any): DashboardMonthlyStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMonthlyStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["studying"] = this.studying;
        data["newlyEnrolled"] = this.newlyEnrolled;
        data["droppedOut"] = this.droppedOut;
        return data;
    }
}

export interface IDashboardMonthlyStatusDto {
    year?: number;
    month?: number;
    studying?: number;
    newlyEnrolled?: number;
    droppedOut?: number;
}

export class DashboardStudentStatusDto implements IDashboardStudentStatusDto {
    studying?: number;
    deferred?: number;
    droppedOut?: number;
    longTermLeave?: number;
    pending?: number;
    other?: number;
    total?: number;
    monthlyData?: DashboardMonthlyStatusDto[] | undefined;
    byTrainingType?: DashboardCategoryCountDto[] | undefined;
    byMajor?: DashboardCategoryCountDto[] | undefined;

    constructor(data?: IDashboardStudentStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studying = _data["studying"];
            this.deferred = _data["deferred"];
            this.droppedOut = _data["droppedOut"];
            this.longTermLeave = _data["longTermLeave"];
            this.pending = _data["pending"];
            this.other = _data["other"];
            this.total = _data["total"];
            if (Array.isArray(_data["monthlyData"])) {
                this.monthlyData = [] as any;
                for (let item of _data["monthlyData"])
                    this.monthlyData!.push(DashboardMonthlyStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["byTrainingType"])) {
                this.byTrainingType = [] as any;
                for (let item of _data["byTrainingType"])
                    this.byTrainingType!.push(DashboardCategoryCountDto.fromJS(item));
            }
            if (Array.isArray(_data["byMajor"])) {
                this.byMajor = [] as any;
                for (let item of _data["byMajor"])
                    this.byMajor!.push(DashboardCategoryCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardStudentStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStudentStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studying"] = this.studying;
        data["deferred"] = this.deferred;
        data["droppedOut"] = this.droppedOut;
        data["longTermLeave"] = this.longTermLeave;
        data["pending"] = this.pending;
        data["other"] = this.other;
        data["total"] = this.total;
        if (Array.isArray(this.monthlyData)) {
            data["monthlyData"] = [];
            for (let item of this.monthlyData)
                data["monthlyData"].push(item.toJSON());
        }
        if (Array.isArray(this.byTrainingType)) {
            data["byTrainingType"] = [];
            for (let item of this.byTrainingType)
                data["byTrainingType"].push(item.toJSON());
        }
        if (Array.isArray(this.byMajor)) {
            data["byMajor"] = [];
            for (let item of this.byMajor)
                data["byMajor"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboardStudentStatusDto {
    studying?: number;
    deferred?: number;
    droppedOut?: number;
    longTermLeave?: number;
    pending?: number;
    other?: number;
    total?: number;
    monthlyData?: DashboardMonthlyStatusDto[] | undefined;
    byTrainingType?: DashboardCategoryCountDto[] | undefined;
    byMajor?: DashboardCategoryCountDto[] | undefined;
}

export class FeeScheduleDto implements IFeeScheduleDto {
    feeSchedule?: FeeScheduleEntity;
    scholarShip?: ScholarShipDto;
    deposit?: number;
    depositByInput?: number | undefined;
    serviceFee?: number | undefined;
    previousBalance?: number | undefined;

    constructor(data?: IFeeScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeSchedule = _data["feeSchedule"] ? FeeScheduleEntity.fromJS(_data["feeSchedule"]) : <any>undefined;
            this.scholarShip = _data["scholarShip"] ? ScholarShipDto.fromJS(_data["scholarShip"]) : <any>undefined;
            this.deposit = _data["deposit"];
            this.depositByInput = _data["depositByInput"];
            this.serviceFee = _data["serviceFee"];
            this.previousBalance = _data["previousBalance"];
        }
    }

    static fromJS(data: any): FeeScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeSchedule"] = this.feeSchedule ? this.feeSchedule.toJSON() : <any>undefined;
        data["scholarShip"] = this.scholarShip ? this.scholarShip.toJSON() : <any>undefined;
        data["deposit"] = this.deposit;
        data["depositByInput"] = this.depositByInput;
        data["serviceFee"] = this.serviceFee;
        data["previousBalance"] = this.previousBalance;
        return data;
    }
}

export interface IFeeScheduleDto {
    feeSchedule?: FeeScheduleEntity;
    scholarShip?: ScholarShipDto;
    deposit?: number;
    depositByInput?: number | undefined;
    serviceFee?: number | undefined;
    previousBalance?: number | undefined;
}

export class ListActivityLogDto implements IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;

    constructor(data?: IListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
            this.createdName = _data["createdName"];
            this.createdAvatar = _data["createdAvatar"];
        }
    }

    static fromJS(data: any): ListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        data["createdName"] = this.createdName;
        data["createdAvatar"] = this.createdAvatar;
        return data;
    }
}

export interface IListActivityLogDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
    createdName?: string | undefined;
    createdAvatar?: string | undefined;
}

export class ListChatGroupDto implements IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;

    constructor(data?: IListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
            this.lastMessage = _data["lastMessage"];
            this.lastMessageDate = _data["lastMessageDate"] ? new Date(_data["lastMessageDate"].toString()) : <any>undefined;
            this.isOnline = _data["isOnline"];
            this.lastMessageType = _data["lastMessageType"];
            this.friendId = _data["friendId"];
            this.lastMessageId = _data["lastMessageId"];
            this.lastMessageIsRead = _data["lastMessageIsRead"];
        }
    }

    static fromJS(data: any): ListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        data["lastMessage"] = this.lastMessage;
        data["lastMessageDate"] = this.lastMessageDate ? this.lastMessageDate.toISOString() : <any>undefined;
        data["isOnline"] = this.isOnline;
        data["lastMessageType"] = this.lastMessageType;
        data["friendId"] = this.friendId;
        data["lastMessageId"] = this.lastMessageId;
        data["lastMessageIsRead"] = this.lastMessageIsRead;
        return data;
    }
}

export interface IListChatGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
    lastMessage?: string | undefined;
    lastMessageDate?: Date | undefined;
    isOnline?: boolean;
    lastMessageType?: number;
    friendId?: number | undefined;
    lastMessageId?: number | undefined;
    lastMessageIsRead?: boolean | undefined;
}

export class ListChatMessageByGroupDto implements IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;

    constructor(data?: IListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.senderId = _data["senderId"];
            this.chatGroupId = _data["chatGroupId"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderAvatar = _data["senderAvatar"];
            this.chatGroupName = _data["chatGroupName"];
            this.chatGroupAvatar = _data["chatGroupAvatar"];
            if (Array.isArray(_data["listFilePath"])) {
                this.listFilePath = [] as any;
                for (let item of _data["listFilePath"])
                    this.listFilePath!.push(item);
            }
            this.isOnline = _data["isOnline"];
            this.chatGroupType = _data["chatGroupType"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): ListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["senderId"] = this.senderId;
        data["chatGroupId"] = this.chatGroupId;
        data["content"] = this.content;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderAvatar"] = this.senderAvatar;
        data["chatGroupName"] = this.chatGroupName;
        data["chatGroupAvatar"] = this.chatGroupAvatar;
        if (Array.isArray(this.listFilePath)) {
            data["listFilePath"] = [];
            for (let item of this.listFilePath)
                data["listFilePath"].push(item);
        }
        data["isOnline"] = this.isOnline;
        data["chatGroupType"] = this.chatGroupType;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IListChatMessageByGroupDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    senderId?: number;
    chatGroupId?: number;
    content?: string | undefined;
    type?: number;
    senderName?: string | undefined;
    senderAvatar?: string | undefined;
    chatGroupName?: string | undefined;
    chatGroupAvatar?: string | undefined;
    listFilePath?: string[] | undefined;
    isOnline?: boolean;
    chatGroupType?: number;
    isRead?: boolean | undefined;
}

export class MonthStatistics implements IMonthStatistics {
    studying?: number;
    deferred?: number;
    droppedOut?: number;
    longTermLeave?: number;
    returned?: number;
    newlyEnrolled?: number;
    pending?: number;
    deferredWarning1?: number;
    studyAbroadTransfer?: number;
    temporarilySuspended?: number;
    total?: number;
    dropoutRate?: number;

    constructor(data?: IMonthStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studying = _data["studying"];
            this.deferred = _data["deferred"];
            this.droppedOut = _data["droppedOut"];
            this.longTermLeave = _data["longTermLeave"];
            this.returned = _data["returned"];
            this.newlyEnrolled = _data["newlyEnrolled"];
            this.pending = _data["pending"];
            this.deferredWarning1 = _data["deferredWarning1"];
            this.studyAbroadTransfer = _data["studyAbroadTransfer"];
            this.temporarilySuspended = _data["temporarilySuspended"];
            this.total = _data["total"];
            this.dropoutRate = _data["dropoutRate"];
        }
    }

    static fromJS(data: any): MonthStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new MonthStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studying"] = this.studying;
        data["deferred"] = this.deferred;
        data["droppedOut"] = this.droppedOut;
        data["longTermLeave"] = this.longTermLeave;
        data["returned"] = this.returned;
        data["newlyEnrolled"] = this.newlyEnrolled;
        data["pending"] = this.pending;
        data["deferredWarning1"] = this.deferredWarning1;
        data["studyAbroadTransfer"] = this.studyAbroadTransfer;
        data["temporarilySuspended"] = this.temporarilySuspended;
        data["total"] = this.total;
        data["dropoutRate"] = this.dropoutRate;
        return data;
    }
}

export interface IMonthStatistics {
    studying?: number;
    deferred?: number;
    droppedOut?: number;
    longTermLeave?: number;
    returned?: number;
    newlyEnrolled?: number;
    pending?: number;
    deferredWarning1?: number;
    studyAbroadTransfer?: number;
    temporarilySuspended?: number;
    total?: number;
    dropoutRate?: number;
}

export class NotificationDto implements INotificationDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    type?: string | undefined;
    createdDate?: Date;
    isRead?: boolean;
    url?: string | undefined;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.type = _data["type"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["content"] = this.content;
        data["type"] = this.type;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        data["url"] = this.url;
        return data;
    }
}

export interface INotificationDto {
    id?: number;
    title?: string | undefined;
    content?: string | undefined;
    type?: string | undefined;
    createdDate?: Date;
    isRead?: boolean;
    url?: string | undefined;
}

export class ObjectPermissionDto implements IObjectPermissionDto {
    id?: number;
    objectId?: number;
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isCategory?: boolean;
    isFull?: boolean;
    tenantId?: number;
    permissions?: ObjectPermissionDetailEntity[] | undefined;

    constructor(data?: IObjectPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectId = _data["objectId"];
            this.module = _data["module"];
            this.moduleName = _data["moduleName"];
            this.isCategory = _data["isCategory"];
            this.isFull = _data["isFull"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ObjectPermissionDetailEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjectPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectId"] = this.objectId;
        data["module"] = this.module;
        data["moduleName"] = this.moduleName;
        data["isCategory"] = this.isCategory;
        data["isFull"] = this.isFull;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjectPermissionDto {
    id?: number;
    objectId?: number;
    module?: ModuleEnum;
    moduleName?: string | undefined;
    isCategory?: boolean;
    isFull?: boolean;
    tenantId?: number;
    permissions?: ObjectPermissionDetailEntity[] | undefined;
}

export class PaymentTrackingDto implements IPaymentTrackingDto {
    summary?: PaymentTrackingSummaryDto;
    students?: FilterResult_1OfStudentPaymentTrackingDto;

    constructor(data?: IPaymentTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? PaymentTrackingSummaryDto.fromJS(_data["summary"]) : <any>undefined;
            this.students = _data["students"] ? FilterResult_1OfStudentPaymentTrackingDto.fromJS(_data["students"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["students"] = this.students ? this.students.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentTrackingDto {
    summary?: PaymentTrackingSummaryDto;
    students?: FilterResult_1OfStudentPaymentTrackingDto;
}

export class PaymentTrackingSummaryDto implements IPaymentTrackingSummaryDto {
    totalStudents?: number;
    completedStudents?: number;
    lowDebtStudents?: number;
    highDebtStudents?: number;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    completionRate?: number;

    constructor(data?: IPaymentTrackingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalStudents = _data["totalStudents"];
            this.completedStudents = _data["completedStudents"];
            this.lowDebtStudents = _data["lowDebtStudents"];
            this.highDebtStudents = _data["highDebtStudents"];
            this.totalAmount = _data["totalAmount"];
            this.totalPaid = _data["totalPaid"];
            this.totalDebt = _data["totalDebt"];
            this.completionRate = _data["completionRate"];
        }
    }

    static fromJS(data: any): PaymentTrackingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTrackingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalStudents"] = this.totalStudents;
        data["completedStudents"] = this.completedStudents;
        data["lowDebtStudents"] = this.lowDebtStudents;
        data["highDebtStudents"] = this.highDebtStudents;
        data["totalAmount"] = this.totalAmount;
        data["totalPaid"] = this.totalPaid;
        data["totalDebt"] = this.totalDebt;
        data["completionRate"] = this.completionRate;
        return data;
    }
}

export interface IPaymentTrackingSummaryDto {
    totalStudents?: number;
    completedStudents?: number;
    lowDebtStudents?: number;
    highDebtStudents?: number;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    completionRate?: number;
}

export class ReceiptBatchCreateDto implements IReceiptBatchCreateDto {
    name!: string;
    receiptType!: ReceiptTypeEnum;
    period?: number | undefined;
    amount?: number | undefined;
    note?: string | undefined;
    bankAccountId?: number | undefined;
    studentIds!: number[];
    includeScholarShip?: boolean;
    paymentMethod?: PaymentMethodEnum;

    constructor(data?: IReceiptBatchCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.studentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.receiptType = _data["receiptType"];
            this.period = _data["period"];
            this.amount = _data["amount"];
            this.note = _data["note"];
            this.bankAccountId = _data["bankAccountId"];
            if (Array.isArray(_data["studentIds"])) {
                this.studentIds = [] as any;
                for (let item of _data["studentIds"])
                    this.studentIds!.push(item);
            }
            this.includeScholarShip = _data["includeScholarShip"];
            this.paymentMethod = _data["paymentMethod"];
        }
    }

    static fromJS(data: any): ReceiptBatchCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBatchCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["receiptType"] = this.receiptType;
        data["period"] = this.period;
        data["amount"] = this.amount;
        data["note"] = this.note;
        data["bankAccountId"] = this.bankAccountId;
        if (Array.isArray(this.studentIds)) {
            data["studentIds"] = [];
            for (let item of this.studentIds)
                data["studentIds"].push(item);
        }
        data["includeScholarShip"] = this.includeScholarShip;
        data["paymentMethod"] = this.paymentMethod;
        return data;
    }
}

export interface IReceiptBatchCreateDto {
    name: string;
    receiptType: ReceiptTypeEnum;
    period?: number | undefined;
    amount?: number | undefined;
    note?: string | undefined;
    bankAccountId?: number | undefined;
    studentIds: number[];
    includeScholarShip?: boolean;
    paymentMethod?: PaymentMethodEnum;
}

export class ReceiptBatchCreateErrorDto implements IReceiptBatchCreateErrorDto {
    studentId?: number;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IReceiptBatchCreateErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ReceiptBatchCreateErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBatchCreateErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IReceiptBatchCreateErrorDto {
    studentId?: number;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    errorMessage?: string | undefined;
}

export class ReceiptBatchCreateResultDto implements IReceiptBatchCreateResultDto {
    totalStudents?: number;
    successCount?: number;
    failedCount?: number;
    errors?: ReceiptBatchCreateErrorDto[] | undefined;
    createdReceipts?: ReceiptDto[] | undefined;

    constructor(data?: IReceiptBatchCreateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalStudents = _data["totalStudents"];
            this.successCount = _data["successCount"];
            this.failedCount = _data["failedCount"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ReceiptBatchCreateErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["createdReceipts"])) {
                this.createdReceipts = [] as any;
                for (let item of _data["createdReceipts"])
                    this.createdReceipts!.push(ReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceiptBatchCreateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBatchCreateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalStudents"] = this.totalStudents;
        data["successCount"] = this.successCount;
        data["failedCount"] = this.failedCount;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        if (Array.isArray(this.createdReceipts)) {
            data["createdReceipts"] = [];
            for (let item of this.createdReceipts)
                data["createdReceipts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReceiptBatchCreateResultDto {
    totalStudents?: number;
    successCount?: number;
    failedCount?: number;
    errors?: ReceiptBatchCreateErrorDto[] | undefined;
    createdReceipts?: ReceiptDto[] | undefined;
}

export class ReceiptBatchPreviewItemDto implements IReceiptBatchPreviewItemDto {
    studentId?: number;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    tuitionFee?: number;
    extraFee?: number;
    serviceFee?: number;
    scholarshipAmount?: number;
    scholarshipName?: string | undefined;
    deposit?: number;
    previousBalance?: number;
    totalAmount?: number;
    hasError?: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IReceiptBatchPreviewItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
            this.tuitionFee = _data["tuitionFee"];
            this.extraFee = _data["extraFee"];
            this.serviceFee = _data["serviceFee"];
            this.scholarshipAmount = _data["scholarshipAmount"];
            this.scholarshipName = _data["scholarshipName"];
            this.deposit = _data["deposit"];
            this.previousBalance = _data["previousBalance"];
            this.totalAmount = _data["totalAmount"];
            this.hasError = _data["hasError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ReceiptBatchPreviewItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptBatchPreviewItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        data["tuitionFee"] = this.tuitionFee;
        data["extraFee"] = this.extraFee;
        data["serviceFee"] = this.serviceFee;
        data["scholarshipAmount"] = this.scholarshipAmount;
        data["scholarshipName"] = this.scholarshipName;
        data["deposit"] = this.deposit;
        data["previousBalance"] = this.previousBalance;
        data["totalAmount"] = this.totalAmount;
        data["hasError"] = this.hasError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IReceiptBatchPreviewItemDto {
    studentId?: number;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    tuitionFee?: number;
    extraFee?: number;
    serviceFee?: number;
    scholarshipAmount?: number;
    scholarshipName?: string | undefined;
    deposit?: number;
    previousBalance?: number;
    totalAmount?: number;
    hasError?: boolean;
    errorMessage?: string | undefined;
}

export class ReceiptDto implements IReceiptDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;
    qrData?: QrGenerateResponseDto;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.statusProcess = _data["statusProcess"];
            this.paymentMethod = _data["paymentMethod"];
            this.receiptType = _data["receiptType"];
            this.paid = _data["paid"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.period = _data["period"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ReceiptDetailEntity.fromJS(item));
            }
            this.qrContent = _data["qrContent"];
            this.bankAccountId = _data["bankAccountId"];
            this.isAuto = _data["isAuto"];
            this.isNofify = _data["isNofify"];
            this.transactionLog = _data["transactionLog"];
            this.image = _data["image"];
            this.deposit = _data["deposit"];
            this.previousBalance = _data["previousBalance"];
            this.qrData = _data["qrData"] ? QrGenerateResponseDto.fromJS(_data["qrData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["statusProcess"] = this.statusProcess;
        data["paymentMethod"] = this.paymentMethod;
        data["receiptType"] = this.receiptType;
        data["paid"] = this.paid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["period"] = this.period;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["qrContent"] = this.qrContent;
        data["bankAccountId"] = this.bankAccountId;
        data["isAuto"] = this.isAuto;
        data["isNofify"] = this.isNofify;
        data["transactionLog"] = this.transactionLog;
        data["image"] = this.image;
        data["deposit"] = this.deposit;
        data["previousBalance"] = this.previousBalance;
        data["qrData"] = this.qrData ? this.qrData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReceiptDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;
    qrData?: QrGenerateResponseDto;
}

export class ReceiptListDto implements IReceiptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;

    constructor(data?: IReceiptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.statusProcess = _data["statusProcess"];
            this.paymentMethod = _data["paymentMethod"];
            this.receiptType = _data["receiptType"];
            this.paid = _data["paid"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.period = _data["period"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ReceiptDetailEntity.fromJS(item));
            }
            this.qrContent = _data["qrContent"];
            this.bankAccountId = _data["bankAccountId"];
            this.isAuto = _data["isAuto"];
            this.isNofify = _data["isNofify"];
            this.transactionLog = _data["transactionLog"];
            this.image = _data["image"];
            this.deposit = _data["deposit"];
            this.previousBalance = _data["previousBalance"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
        }
    }

    static fromJS(data: any): ReceiptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["statusProcess"] = this.statusProcess;
        data["paymentMethod"] = this.paymentMethod;
        data["receiptType"] = this.receiptType;
        data["paid"] = this.paid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["period"] = this.period;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["qrContent"] = this.qrContent;
        data["bankAccountId"] = this.bankAccountId;
        data["isAuto"] = this.isAuto;
        data["isNofify"] = this.isNofify;
        data["transactionLog"] = this.transactionLog;
        data["image"] = this.image;
        data["deposit"] = this.deposit;
        data["previousBalance"] = this.previousBalance;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        return data;
    }
}

export interface IReceiptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    listModule?: ObjectPermissionDto[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userCount = _data["userCount"];
            if (Array.isArray(_data["listModule"])) {
                this.listModule = [] as any;
                for (let item of _data["listModule"])
                    this.listModule!.push(ObjectPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userCount"] = this.userCount;
        if (Array.isArray(this.listModule)) {
            data["listModule"] = [];
            for (let item of this.listModule)
                data["listModule"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleDto {
    id?: number;
    name?: string | undefined;
    userCount?: number;
    listModule?: ObjectPermissionDto[] | undefined;
}

export class ScholarShipDto implements IScholarShipDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    amount?: number;
    quantity?: number;
    objectType?: ScholarShipTypeEnum;
    academicYearId?: number;
    trainingTypes?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amountDetail?: number[] | undefined;
    usedCount?: number;
    amountPeriod?: number;

    constructor(data?: IScholarShipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["amountDetail"])) {
                this.amountDetail = [] as any;
                for (let item of _data["amountDetail"])
                    this.amountDetail!.push(item);
            }
            this.usedCount = _data["usedCount"];
            this.amountPeriod = _data["amountPeriod"];
        }
    }

    static fromJS(data: any): ScholarShipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScholarShipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.amountDetail)) {
            data["amountDetail"] = [];
            for (let item of this.amountDetail)
                data["amountDetail"].push(item);
        }
        data["usedCount"] = this.usedCount;
        data["amountPeriod"] = this.amountPeriod;
        return data;
    }
}

export interface IScholarShipDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    amount?: number;
    quantity?: number;
    objectType?: ScholarShipTypeEnum;
    academicYearId?: number;
    trainingTypes?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amountDetail?: number[] | undefined;
    usedCount?: number;
    amountPeriod?: number;
}

export class StudentAddDto implements IStudentAddDto {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IStudentAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): StudentAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IStudentAddDto {
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export class StudentFilterDto implements IStudentFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    gender?: number | undefined;
    status?: StudentStatusEnum;

    constructor(data?: IStudentFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.classId = _data["classId"];
            this.keyword = _data["keyword"];
            this.gender = _data["gender"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StudentFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["classId"] = this.classId;
        data["keyword"] = this.keyword;
        data["gender"] = this.gender;
        data["status"] = this.status;
        return data;
    }
}

export interface IStudentFilterDto {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    classId?: number;
    keyword?: string | undefined;
    gender?: number | undefined;
    status?: StudentStatusEnum;
}

export class StudentListDto implements IStudentListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    studentCodeTemp?: string | undefined;
    studentCode?: string | undefined;
    profileCode?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    email?: string | undefined;
    isEmailGenerated?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    temporaryAddress?: string | undefined;
    admissionDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    motherStatus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    fatherStatus?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    personalEmail?: string | undefined;
    trainingType?: number;
    major?: number;
    department?: number;
    facility?: number;
    note?: string | undefined;
    schoolName?: string | undefined;
    schoolProvinceId?: number;
    provinceId?: number;
    placeOfBirth?: string | undefined;
    ethnic?: string | undefined;
    identityCardNumber?: string | undefined;
    studentObjectType?: number;
    academicYearId?: number;
    startAcademicYearId?: number;
    documentStatus?: StudentDocumentStatusEnum;
    step?: StudentStepEnum;
    status?: StudentProcessStatusEnum;
    sendBy?: number;
    sendDate?: Date | undefined;
    accountingBy?: number;
    accountingDate?: Date | undefined;
    affairBy?: number;
    affairDate?: Date | undefined;
    processNote?: string | undefined;
    scholarShipId?: number;
    index?: number;
    trainingFacility?: number;
    guidId?: string | undefined;
    deposit?: number | undefined;
    classUsers?: ClassUserEntity[] | undefined;
    receipts?: ReceiptEntity[] | undefined;
    userName?: string | undefined;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    documentCount?: number;
    statusInClass?: StudentStatusEnum;
    class?: ClassByUserDto;
    careerClass?: ClassByUserDto;
    documentComplete?: number[] | undefined;
    statusByTime?: StudentStatusEntity[] | undefined;

    constructor(data?: IStudentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.studentCodeTemp = _data["studentCodeTemp"];
            this.studentCode = _data["studentCode"];
            this.profileCode = _data["profileCode"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.email = _data["email"];
            this.isEmailGenerated = _data["isEmailGenerated"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.temporaryAddress = _data["temporaryAddress"];
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.admissionsConsultantName = _data["admissionsConsultantName"];
            this.motherName = _data["motherName"];
            this.motherPhone = _data["motherPhone"];
            this.motherStatus = _data["motherStatus"];
            this.fatherName = _data["fatherName"];
            this.fatherPhone = _data["fatherPhone"];
            this.fatherStatus = _data["fatherStatus"];
            this.guardianName = _data["guardianName"];
            this.guardianPhone = _data["guardianPhone"];
            this.personalEmail = _data["personalEmail"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.department = _data["department"];
            this.facility = _data["facility"];
            this.note = _data["note"];
            this.schoolName = _data["schoolName"];
            this.schoolProvinceId = _data["schoolProvinceId"];
            this.provinceId = _data["provinceId"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.ethnic = _data["ethnic"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.studentObjectType = _data["studentObjectType"];
            this.academicYearId = _data["academicYearId"];
            this.startAcademicYearId = _data["startAcademicYearId"];
            this.documentStatus = _data["documentStatus"];
            this.step = _data["step"];
            this.status = _data["status"];
            this.sendBy = _data["sendBy"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.accountingBy = _data["accountingBy"];
            this.accountingDate = _data["accountingDate"] ? new Date(_data["accountingDate"].toString()) : <any>undefined;
            this.affairBy = _data["affairBy"];
            this.affairDate = _data["affairDate"] ? new Date(_data["affairDate"].toString()) : <any>undefined;
            this.processNote = _data["processNote"];
            this.scholarShipId = _data["scholarShipId"];
            this.index = _data["index"];
            this.trainingFacility = _data["trainingFacility"];
            this.guidId = _data["guidId"];
            this.deposit = _data["deposit"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptEntity.fromJS(item));
            }
            this.userName = _data["userName"];
            this.totalAmount = _data["totalAmount"];
            this.totalPaid = _data["totalPaid"];
            this.totalDebt = _data["totalDebt"];
            this.documentCount = _data["documentCount"];
            this.statusInClass = _data["statusInClass"];
            this.class = _data["class"] ? ClassByUserDto.fromJS(_data["class"]) : <any>undefined;
            this.careerClass = _data["careerClass"] ? ClassByUserDto.fromJS(_data["careerClass"]) : <any>undefined;
            if (Array.isArray(_data["documentComplete"])) {
                this.documentComplete = [] as any;
                for (let item of _data["documentComplete"])
                    this.documentComplete!.push(item);
            }
            if (Array.isArray(_data["statusByTime"])) {
                this.statusByTime = [] as any;
                for (let item of _data["statusByTime"])
                    this.statusByTime!.push(StudentStatusEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["studentCodeTemp"] = this.studentCodeTemp;
        data["studentCode"] = this.studentCode;
        data["profileCode"] = this.profileCode;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["email"] = this.email;
        data["isEmailGenerated"] = this.isEmailGenerated;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["temporaryAddress"] = this.temporaryAddress;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["admissionsConsultantName"] = this.admissionsConsultantName;
        data["motherName"] = this.motherName;
        data["motherPhone"] = this.motherPhone;
        data["motherStatus"] = this.motherStatus;
        data["fatherName"] = this.fatherName;
        data["fatherPhone"] = this.fatherPhone;
        data["fatherStatus"] = this.fatherStatus;
        data["guardianName"] = this.guardianName;
        data["guardianPhone"] = this.guardianPhone;
        data["personalEmail"] = this.personalEmail;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["department"] = this.department;
        data["facility"] = this.facility;
        data["note"] = this.note;
        data["schoolName"] = this.schoolName;
        data["schoolProvinceId"] = this.schoolProvinceId;
        data["provinceId"] = this.provinceId;
        data["placeOfBirth"] = this.placeOfBirth;
        data["ethnic"] = this.ethnic;
        data["identityCardNumber"] = this.identityCardNumber;
        data["studentObjectType"] = this.studentObjectType;
        data["academicYearId"] = this.academicYearId;
        data["startAcademicYearId"] = this.startAcademicYearId;
        data["documentStatus"] = this.documentStatus;
        data["step"] = this.step;
        data["status"] = this.status;
        data["sendBy"] = this.sendBy;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["accountingBy"] = this.accountingBy;
        data["accountingDate"] = this.accountingDate ? this.accountingDate.toISOString() : <any>undefined;
        data["affairBy"] = this.affairBy;
        data["affairDate"] = this.affairDate ? this.affairDate.toISOString() : <any>undefined;
        data["processNote"] = this.processNote;
        data["scholarShipId"] = this.scholarShipId;
        data["index"] = this.index;
        data["trainingFacility"] = this.trainingFacility;
        data["guidId"] = this.guidId;
        data["deposit"] = this.deposit;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        data["userName"] = this.userName;
        data["totalAmount"] = this.totalAmount;
        data["totalPaid"] = this.totalPaid;
        data["totalDebt"] = this.totalDebt;
        data["documentCount"] = this.documentCount;
        data["statusInClass"] = this.statusInClass;
        data["class"] = this.class ? this.class.toJSON() : <any>undefined;
        data["careerClass"] = this.careerClass ? this.careerClass.toJSON() : <any>undefined;
        if (Array.isArray(this.documentComplete)) {
            data["documentComplete"] = [];
            for (let item of this.documentComplete)
                data["documentComplete"].push(item);
        }
        if (Array.isArray(this.statusByTime)) {
            data["statusByTime"] = [];
            for (let item of this.statusByTime)
                data["statusByTime"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    studentCodeTemp?: string | undefined;
    studentCode?: string | undefined;
    profileCode?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    email?: string | undefined;
    isEmailGenerated?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    temporaryAddress?: string | undefined;
    admissionDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    motherStatus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    fatherStatus?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    personalEmail?: string | undefined;
    trainingType?: number;
    major?: number;
    department?: number;
    facility?: number;
    note?: string | undefined;
    schoolName?: string | undefined;
    schoolProvinceId?: number;
    provinceId?: number;
    placeOfBirth?: string | undefined;
    ethnic?: string | undefined;
    identityCardNumber?: string | undefined;
    studentObjectType?: number;
    academicYearId?: number;
    startAcademicYearId?: number;
    documentStatus?: StudentDocumentStatusEnum;
    step?: StudentStepEnum;
    status?: StudentProcessStatusEnum;
    sendBy?: number;
    sendDate?: Date | undefined;
    accountingBy?: number;
    accountingDate?: Date | undefined;
    affairBy?: number;
    affairDate?: Date | undefined;
    processNote?: string | undefined;
    scholarShipId?: number;
    index?: number;
    trainingFacility?: number;
    guidId?: string | undefined;
    deposit?: number | undefined;
    classUsers?: ClassUserEntity[] | undefined;
    receipts?: ReceiptEntity[] | undefined;
    userName?: string | undefined;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    documentCount?: number;
    statusInClass?: StudentStatusEnum;
    class?: ClassByUserDto;
    careerClass?: ClassByUserDto;
    documentComplete?: number[] | undefined;
    statusByTime?: StudentStatusEntity[] | undefined;
}

export class StudentPaymentTrackingDto implements IStudentPaymentTrackingDto {
    id?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    academicYearId?: number | undefined;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    paymentStatus?: string | undefined;
    completedPeriods?: number;
    totalPeriods?: number;
    completionPercentage?: number;
    lastPaymentDate?: Date | undefined;
    lastPaymentAmount?: string | undefined;

    constructor(data?: IStudentPaymentTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentCode = _data["studentCode"];
            this.fullName = _data["fullName"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.academicYearId = _data["academicYearId"];
            this.totalAmount = _data["totalAmount"];
            this.totalPaid = _data["totalPaid"];
            this.totalDebt = _data["totalDebt"];
            this.paymentStatus = _data["paymentStatus"];
            this.completedPeriods = _data["completedPeriods"];
            this.totalPeriods = _data["totalPeriods"];
            this.completionPercentage = _data["completionPercentage"];
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : <any>undefined;
            this.lastPaymentAmount = _data["lastPaymentAmount"];
        }
    }

    static fromJS(data: any): StudentPaymentTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPaymentTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentCode"] = this.studentCode;
        data["fullName"] = this.fullName;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["academicYearId"] = this.academicYearId;
        data["totalAmount"] = this.totalAmount;
        data["totalPaid"] = this.totalPaid;
        data["totalDebt"] = this.totalDebt;
        data["paymentStatus"] = this.paymentStatus;
        data["completedPeriods"] = this.completedPeriods;
        data["totalPeriods"] = this.totalPeriods;
        data["completionPercentage"] = this.completionPercentage;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : <any>undefined;
        data["lastPaymentAmount"] = this.lastPaymentAmount;
        return data;
    }
}

export interface IStudentPaymentTrackingDto {
    id?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    academicYearId?: number | undefined;
    totalAmount?: number;
    totalPaid?: number;
    totalDebt?: number;
    paymentStatus?: string | undefined;
    completedPeriods?: number;
    totalPeriods?: number;
    completionPercentage?: number;
    lastPaymentDate?: Date | undefined;
    lastPaymentAmount?: string | undefined;
}

export class StudentStatusStatisticsDto implements IStudentStatusStatisticsDto {
    studentId?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    classId?: number;
    className?: string | undefined;
    academicYearId?: number;
    trainingTypeId?: number;
    majorId?: number;
    note?: string | undefined;
    statusByTime?: StudentStatusEntity[] | undefined;

    constructor(data?: IStudentStatusStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"];
            this.studentCode = _data["studentCode"];
            this.fullName = _data["fullName"];
            this.classId = _data["classId"];
            this.className = _data["className"];
            this.academicYearId = _data["academicYearId"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.majorId = _data["majorId"];
            this.note = _data["note"];
            if (Array.isArray(_data["statusByTime"])) {
                this.statusByTime = [] as any;
                for (let item of _data["statusByTime"])
                    this.statusByTime!.push(StudentStatusEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentStatusStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId;
        data["studentCode"] = this.studentCode;
        data["fullName"] = this.fullName;
        data["classId"] = this.classId;
        data["className"] = this.className;
        data["academicYearId"] = this.academicYearId;
        data["trainingTypeId"] = this.trainingTypeId;
        data["majorId"] = this.majorId;
        data["note"] = this.note;
        if (Array.isArray(this.statusByTime)) {
            data["statusByTime"] = [];
            for (let item of this.statusByTime)
                data["statusByTime"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentStatusStatisticsDto {
    studentId?: number;
    studentCode?: string | undefined;
    fullName?: string | undefined;
    classId?: number;
    className?: string | undefined;
    academicYearId?: number;
    trainingTypeId?: number;
    majorId?: number;
    note?: string | undefined;
    statusByTime?: StudentStatusEntity[] | undefined;
}

export class StudentStatusStatisticsSummaryDto implements IStudentStatusStatisticsSummaryDto {
    academicYearId?: number | undefined;
    academicYearName?: string | undefined;
    trainingTypeId?: number | undefined;
    trainingTypeName?: string | undefined;
    majorId?: number | undefined;
    majorName?: string | undefined;
    statusByMonth?: { [key: string]: MonthStatistics; } | undefined;

    constructor(data?: IStudentStatusStatisticsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.academicYearId = _data["academicYearId"];
            this.academicYearName = _data["academicYearName"];
            this.trainingTypeId = _data["trainingTypeId"];
            this.trainingTypeName = _data["trainingTypeName"];
            this.majorId = _data["majorId"];
            this.majorName = _data["majorName"];
            if (_data["statusByMonth"]) {
                this.statusByMonth = {} as any;
                for (let key in _data["statusByMonth"]) {
                    if (_data["statusByMonth"].hasOwnProperty(key))
                        (<any>this.statusByMonth)![key] = _data["statusByMonth"][key] ? MonthStatistics.fromJS(_data["statusByMonth"][key]) : new MonthStatistics();
                }
            }
        }
    }

    static fromJS(data: any): StudentStatusStatisticsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusStatisticsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academicYearId"] = this.academicYearId;
        data["academicYearName"] = this.academicYearName;
        data["trainingTypeId"] = this.trainingTypeId;
        data["trainingTypeName"] = this.trainingTypeName;
        data["majorId"] = this.majorId;
        data["majorName"] = this.majorName;
        if (this.statusByMonth) {
            data["statusByMonth"] = {};
            for (let key in this.statusByMonth) {
                if (this.statusByMonth.hasOwnProperty(key))
                    (<any>data["statusByMonth"])[key] = this.statusByMonth[key] ? this.statusByMonth[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IStudentStatusStatisticsSummaryDto {
    academicYearId?: number | undefined;
    academicYearName?: string | undefined;
    trainingTypeId?: number | undefined;
    trainingTypeName?: string | undefined;
    majorId?: number | undefined;
    majorName?: string | undefined;
    statusByMonth?: { [key: string]: MonthStatistics; } | undefined;
}

export class SubjectGetListFilter implements ISubjectGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    semester?: number | undefined;
    status?: CommonStatusEnum;

    constructor(data?: ISubjectGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.academicYearId = _data["academicYearId"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.semester = _data["semester"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubjectGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["academicYearId"] = this.academicYearId;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["semester"] = this.semester;
        data["status"] = this.status;
        return data;
    }
}

export interface ISubjectGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    trainingType?: number | undefined;
    major?: number | undefined;
    semester?: number | undefined;
    status?: CommonStatusEnum;
}

export class SubjectListDto implements ISubjectListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    major?: number;
    trainingType?: number;
    academicYearId?: number;
    semester?: number;
    credits?: number;
    componentWeight?: number;
    examWeight?: number;
    minComponentScore?: number;
    description?: string | undefined;
    fileUrl?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: ISubjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.major = _data["major"];
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.credits = _data["credits"];
            this.componentWeight = _data["componentWeight"];
            this.examWeight = _data["examWeight"];
            this.minComponentScore = _data["minComponentScore"];
            this.description = _data["description"];
            this.fileUrl = _data["fileUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["major"] = this.major;
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["credits"] = this.credits;
        data["componentWeight"] = this.componentWeight;
        data["examWeight"] = this.examWeight;
        data["minComponentScore"] = this.minComponentScore;
        data["description"] = this.description;
        data["fileUrl"] = this.fileUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface ISubjectListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    major?: number;
    trainingType?: number;
    academicYearId?: number;
    semester?: number;
    credits?: number;
    componentWeight?: number;
    examWeight?: number;
    minComponentScore?: number;
    description?: string | undefined;
    fileUrl?: string | undefined;
    status?: CommonStatusEnum;
}

export class SubjectScoreBatchSaveDto implements ISubjectScoreBatchSaveDto {
    classId?: number;
    subjectId?: number;
    academicYearId?: number;
    semester?: number;
    items?: SubjectScoreItemDto[] | undefined;

    constructor(data?: ISubjectScoreBatchSaveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.subjectId = _data["subjectId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubjectScoreItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubjectScoreBatchSaveDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectScoreBatchSaveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["subjectId"] = this.subjectId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubjectScoreBatchSaveDto {
    classId?: number;
    subjectId?: number;
    academicYearId?: number;
    semester?: number;
    items?: SubjectScoreItemDto[] | undefined;
}

export class SubjectScoreGetListFilter implements ISubjectScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    subjectId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    status?: SubjectScoreStatusEnum;

    constructor(data?: ISubjectScoreGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.classId = _data["classId"];
            this.subjectId = _data["subjectId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.studentId = _data["studentId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubjectScoreGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectScoreGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["classId"] = this.classId;
        data["subjectId"] = this.subjectId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["studentId"] = this.studentId;
        data["status"] = this.status;
        return data;
    }
}

export interface ISubjectScoreGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    classId?: number | undefined;
    subjectId?: number | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    status?: SubjectScoreStatusEnum;
}

export class SubjectScoreItemDto implements ISubjectScoreItemDto {
    id?: number;
    studentId?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    note?: string | undefined;

    constructor(data?: ISubjectScoreItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.studentId = _data["studentId"];
            this.componentAverage = _data["componentAverage"];
            this.finalExamScore = _data["finalExamScore"];
            this.retakeScore = _data["retakeScore"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SubjectScoreItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectScoreItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["studentId"] = this.studentId;
        data["componentAverage"] = this.componentAverage;
        data["finalExamScore"] = this.finalExamScore;
        data["retakeScore"] = this.retakeScore;
        data["note"] = this.note;
        return data;
    }
}

export interface ISubjectScoreItemDto {
    id?: number;
    studentId?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    note?: string | undefined;
}

export class SubjectScoreListDto implements ISubjectScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    finalScore?: number | undefined;
    letterGrade?: string | undefined;
    gradePoint?: number | undefined;
    status?: SubjectScoreStatusEnum;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    subjectName?: string | undefined;
    subjectCode?: string | undefined;
    credits?: number | undefined;

    constructor(data?: ISubjectScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.subjectId = _data["subjectId"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.componentAverage = _data["componentAverage"];
            this.finalExamScore = _data["finalExamScore"];
            this.retakeScore = _data["retakeScore"];
            this.finalScore = _data["finalScore"];
            this.letterGrade = _data["letterGrade"];
            this.gradePoint = _data["gradePoint"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
            this.subjectName = _data["subjectName"];
            this.subjectCode = _data["subjectCode"];
            this.credits = _data["credits"];
        }
    }

    static fromJS(data: any): SubjectScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["subjectId"] = this.subjectId;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["componentAverage"] = this.componentAverage;
        data["finalExamScore"] = this.finalExamScore;
        data["retakeScore"] = this.retakeScore;
        data["finalScore"] = this.finalScore;
        data["letterGrade"] = this.letterGrade;
        data["gradePoint"] = this.gradePoint;
        data["status"] = this.status;
        data["note"] = this.note;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        data["subjectName"] = this.subjectName;
        data["subjectCode"] = this.subjectCode;
        data["credits"] = this.credits;
        return data;
    }
}

export interface ISubjectScoreListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    finalScore?: number | undefined;
    letterGrade?: string | undefined;
    gradePoint?: number | undefined;
    status?: SubjectScoreStatusEnum;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
    subjectName?: string | undefined;
    subjectCode?: string | undefined;
    credits?: number | undefined;
}

export class TagDto implements ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHotTag?: boolean;
    status?: number;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.unsignName = _data["unsignName"];
            this.url = _data["url"];
            this.isHotTag = _data["isHotTag"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["unsignName"] = this.unsignName;
        data["url"] = this.url;
        data["isHotTag"] = this.isHotTag;
        data["status"] = this.status;
        return data;
    }
}

export interface ITagDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    name?: string | undefined;
    unsignName?: string | undefined;
    url?: string | undefined;
    isHotTag?: boolean;
    status?: number;
}

export class TagGetListQuery implements ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;

    constructor(data?: ITagGetListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.zoneId = _data["zoneId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TagGetListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TagGetListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["zoneId"] = this.zoneId;
        data["type"] = this.type;
        return data;
    }
}

export interface ITagGetListQuery {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    zoneId?: number | undefined;
    type?: number;
}

export class TagListDto implements ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;

    constructor(data?: ITagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.isHotTag = _data["isHotTag"];
            this.newsCount = _data["newsCount"];
            this.zoneId = _data["zoneId"];
            this.zone = _data["zone"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): TagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["isHotTag"] = this.isHotTag;
        data["newsCount"] = this.newsCount;
        data["zoneId"] = this.zoneId;
        data["zone"] = this.zone;
        data["url"] = this.url;
        return data;
    }
}

export interface ITagListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    isHotTag?: boolean;
    newsCount?: number;
    zoneId?: number;
    zone?: string | undefined;
    url?: string | undefined;
}

export class TranscriptCalculateDto implements ITranscriptCalculateDto {
    classId?: number;
    academicYearId?: number;
    semester?: number;

    constructor(data?: ITranscriptCalculateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
        }
    }

    static fromJS(data: any): TranscriptCalculateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptCalculateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        return data;
    }
}

export interface ITranscriptCalculateDto {
    classId?: number;
    academicYearId?: number;
    semester?: number;
}

export class TranscriptGetListFilter implements ITranscriptGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    classId?: number | undefined;

    constructor(data?: ITranscriptGetListFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortExpression = _data["sortExpression"];
            this.pageSize = _data["pageSize"];
            this.pageIndex = _data["pageIndex"];
            this.skip = _data["skip"];
            this.notSkip = _data["notSkip"];
            if (Array.isArray(_data["propertyIncludes"])) {
                this.propertyIncludes = [] as any;
                for (let item of _data["propertyIncludes"])
                    this.propertyIncludes!.push(item);
            }
            this.keyword = _data["keyword"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.studentId = _data["studentId"];
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): TranscriptGetListFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptGetListFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortExpression"] = this.sortExpression;
        data["pageSize"] = this.pageSize;
        data["pageIndex"] = this.pageIndex;
        data["skip"] = this.skip;
        data["notSkip"] = this.notSkip;
        if (Array.isArray(this.propertyIncludes)) {
            data["propertyIncludes"] = [];
            for (let item of this.propertyIncludes)
                data["propertyIncludes"].push(item);
        }
        data["keyword"] = this.keyword;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["studentId"] = this.studentId;
        data["classId"] = this.classId;
        return data;
    }
}

export interface ITranscriptGetListFilter {
    sortExpression?: string | undefined;
    pageSize?: number;
    pageIndex?: number;
    skip?: number;
    notSkip?: number;
    propertyIncludes?: string[] | undefined;
    keyword?: string | undefined;
    academicYearId?: number | undefined;
    semester?: number | undefined;
    studentId?: number | undefined;
    classId?: number | undefined;
}

export class TranscriptListDto implements ITranscriptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    academicYearId?: number;
    semester?: number;
    totalCredits?: number;
    semesterGPA?: number;
    semesterAverage?: number;
    cumulativeCredits?: number;
    cumulativeGPA?: number;
    cumulativeAverage?: number;
    academicClassification?: string | undefined;
    conductScore?: number | undefined;
    conductClassification?: string | undefined;
    graduationClassification?: string | undefined;
    isGraduated?: boolean;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;

    constructor(data?: ITranscriptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.totalCredits = _data["totalCredits"];
            this.semesterGPA = _data["semesterGPA"];
            this.semesterAverage = _data["semesterAverage"];
            this.cumulativeCredits = _data["cumulativeCredits"];
            this.cumulativeGPA = _data["cumulativeGPA"];
            this.cumulativeAverage = _data["cumulativeAverage"];
            this.academicClassification = _data["academicClassification"];
            this.conductScore = _data["conductScore"];
            this.conductClassification = _data["conductClassification"];
            this.graduationClassification = _data["graduationClassification"];
            this.isGraduated = _data["isGraduated"];
            this.note = _data["note"];
            this.studentName = _data["studentName"];
            this.studentCode = _data["studentCode"];
        }
    }

    static fromJS(data: any): TranscriptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranscriptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["totalCredits"] = this.totalCredits;
        data["semesterGPA"] = this.semesterGPA;
        data["semesterAverage"] = this.semesterAverage;
        data["cumulativeCredits"] = this.cumulativeCredits;
        data["cumulativeGPA"] = this.cumulativeGPA;
        data["cumulativeAverage"] = this.cumulativeAverage;
        data["academicClassification"] = this.academicClassification;
        data["conductScore"] = this.conductScore;
        data["conductClassification"] = this.conductClassification;
        data["graduationClassification"] = this.graduationClassification;
        data["isGraduated"] = this.isGraduated;
        data["note"] = this.note;
        data["studentName"] = this.studentName;
        data["studentCode"] = this.studentCode;
        return data;
    }
}

export interface ITranscriptListDto {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    academicYearId?: number;
    semester?: number;
    totalCredits?: number;
    semesterGPA?: number;
    semesterAverage?: number;
    cumulativeCredits?: number;
    cumulativeGPA?: number;
    cumulativeAverage?: number;
    academicClassification?: string | undefined;
    conductScore?: number | undefined;
    conductClassification?: string | undefined;
    graduationClassification?: string | undefined;
    isGraduated?: boolean;
    note?: string | undefined;
    studentName?: string | undefined;
    studentCode?: string | undefined;
}

export class UserListDto implements IUserListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.roles = _data["roles"];
            this.type = _data["type"];
            this.objectId = _data["objectId"];
            this.objectName = _data["objectName"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["roles"] = this.roles;
        data["type"] = this.type;
        data["objectId"] = this.objectId;
        data["objectName"] = this.objectName;
        return data;
    }
}

export interface IUserListDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    status?: number;
    createdDate?: Date;
    roles?: string | undefined;
    type?: UserTypeEnum;
    objectId?: number;
    objectName?: string | undefined;
}

export class UserWithSimpleInfoDto implements IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;

    constructor(data?: IUserWithSimpleInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.avatar = _data["avatar"];
            this.fullName = _data["fullName"];
            this.type = _data["type"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): UserWithSimpleInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWithSimpleInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["avatar"] = this.avatar;
        data["fullName"] = this.fullName;
        data["type"] = this.type;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IUserWithSimpleInfoDto {
    id?: number;
    userName?: string | undefined;
    avatar?: string | undefined;
    fullName?: string | undefined;
    type?: UserTypeEnum;
    isOnline?: boolean;
}

export class ActivityLogEntity implements IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IActivityLogEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.title = _data["title"];
            this.data = _data["data"];
            this.objectType = _data["objectType"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): ActivityLogEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["title"] = this.title;
        data["data"] = this.data;
        data["objectType"] = this.objectType;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IActivityLogEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    title?: string | undefined;
    data?: string | undefined;
    objectType?: string | undefined;
    ip?: string | undefined;
}

export class FilterResult_1OfStudentListByStatusMonthDto implements IFilterResult_1OfStudentListByStatusMonthDto {
    totalRows?: number;
    data?: StudentListByStatusMonthDto[] | undefined;

    constructor(data?: IFilterResult_1OfStudentListByStatusMonthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentListByStatusMonthDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfStudentListByStatusMonthDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfStudentListByStatusMonthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfStudentListByStatusMonthDto {
    totalRows?: number;
    data?: StudentListByStatusMonthDto[] | undefined;
}

export class FilterResult_1OfCategoryListDto implements IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;

    constructor(data?: IFilterResult_1OfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfCategoryListDto {
    totalRows?: number;
    data?: CategoryListDto[] | undefined;
}

export class FilterResult_1OfClassListDto implements IFilterResult_1OfClassListDto {
    totalRows?: number;
    data?: ClassListDto[] | undefined;

    constructor(data?: IFilterResult_1OfClassListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfClassListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfClassListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfClassListDto {
    totalRows?: number;
    data?: ClassListDto[] | undefined;
}

export class FilterResult_1OfComponentScoreListDto implements IFilterResult_1OfComponentScoreListDto {
    totalRows?: number;
    data?: ComponentScoreListDto[] | undefined;

    constructor(data?: IFilterResult_1OfComponentScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ComponentScoreListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfComponentScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfComponentScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfComponentScoreListDto {
    totalRows?: number;
    data?: ComponentScoreListDto[] | undefined;
}

export class FilterResult_1OfConductScoreListDto implements IFilterResult_1OfConductScoreListDto {
    totalRows?: number;
    data?: ConductScoreListDto[] | undefined;

    constructor(data?: IFilterResult_1OfConductScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConductScoreListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfConductScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfConductScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfConductScoreListDto {
    totalRows?: number;
    data?: ConductScoreListDto[] | undefined;
}

export class FilterResult_1OfListActivityLogDto implements IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;

    constructor(data?: IFilterResult_1OfListActivityLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListActivityLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListActivityLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListActivityLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListActivityLogDto {
    totalRows?: number;
    data?: ListActivityLogDto[] | undefined;
}

export class FilterResult_1OfListChatGroupDto implements IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatGroupDto {
    totalRows?: number;
    data?: ListChatGroupDto[] | undefined;
}

export class FilterResult_1OfListChatMessageByGroupDto implements IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;

    constructor(data?: IFilterResult_1OfListChatMessageByGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ListChatMessageByGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfListChatMessageByGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfListChatMessageByGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfListChatMessageByGroupDto {
    totalRows?: number;
    data?: ListChatMessageByGroupDto[] | undefined;
}

export class FilterResult_1OfNotificationDto implements IFilterResult_1OfNotificationDto {
    totalRows?: number;
    data?: NotificationDto[] | undefined;

    constructor(data?: IFilterResult_1OfNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfNotificationDto {
    totalRows?: number;
    data?: NotificationDto[] | undefined;
}

export class FilterResult_1OfReceiptListDto implements IFilterResult_1OfReceiptListDto {
    totalRows?: number;
    data?: ReceiptListDto[] | undefined;

    constructor(data?: IFilterResult_1OfReceiptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReceiptListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfReceiptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfReceiptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfReceiptListDto {
    totalRows?: number;
    data?: ReceiptListDto[] | undefined;
}

export class FilterResult_1OfStudentListDto implements IFilterResult_1OfStudentListDto {
    totalRows?: number;
    data?: StudentListDto[] | undefined;

    constructor(data?: IFilterResult_1OfStudentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfStudentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfStudentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfStudentListDto {
    totalRows?: number;
    data?: StudentListDto[] | undefined;
}

export class FilterResult_1OfStudentPaymentTrackingDto implements IFilterResult_1OfStudentPaymentTrackingDto {
    totalRows?: number;
    data?: StudentPaymentTrackingDto[] | undefined;

    constructor(data?: IFilterResult_1OfStudentPaymentTrackingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentPaymentTrackingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfStudentPaymentTrackingDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfStudentPaymentTrackingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfStudentPaymentTrackingDto {
    totalRows?: number;
    data?: StudentPaymentTrackingDto[] | undefined;
}

export class FilterResult_1OfStudentStatusStatisticsDto implements IFilterResult_1OfStudentStatusStatisticsDto {
    totalRows?: number;
    data?: StudentStatusStatisticsDto[] | undefined;

    constructor(data?: IFilterResult_1OfStudentStatusStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(StudentStatusStatisticsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfStudentStatusStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfStudentStatusStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfStudentStatusStatisticsDto {
    totalRows?: number;
    data?: StudentStatusStatisticsDto[] | undefined;
}

export class FilterResult_1OfSubjectListDto implements IFilterResult_1OfSubjectListDto {
    totalRows?: number;
    data?: SubjectListDto[] | undefined;

    constructor(data?: IFilterResult_1OfSubjectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubjectListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfSubjectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfSubjectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfSubjectListDto {
    totalRows?: number;
    data?: SubjectListDto[] | undefined;
}

export class FilterResult_1OfSubjectScoreListDto implements IFilterResult_1OfSubjectScoreListDto {
    totalRows?: number;
    data?: SubjectScoreListDto[] | undefined;

    constructor(data?: IFilterResult_1OfSubjectScoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubjectScoreListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfSubjectScoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfSubjectScoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfSubjectScoreListDto {
    totalRows?: number;
    data?: SubjectScoreListDto[] | undefined;
}

export class FilterResult_1OfTagListDto implements IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTagListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TagListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTagListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTagListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfTagListDto {
    totalRows?: number;
    data?: TagListDto[] | undefined;
}

export class FilterResult_1OfTranscriptListDto implements IFilterResult_1OfTranscriptListDto {
    totalRows?: number;
    data?: TranscriptListDto[] | undefined;

    constructor(data?: IFilterResult_1OfTranscriptListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TranscriptListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfTranscriptListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfTranscriptListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfTranscriptListDto {
    totalRows?: number;
    data?: TranscriptListDto[] | undefined;
}

export class FilterResult_1OfUserListDto implements IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;

    constructor(data?: IFilterResult_1OfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfUserListDto {
    totalRows?: number;
    data?: UserListDto[] | undefined;
}

export class FilterResult_1OfConfigEntity implements IFilterResult_1OfConfigEntity {
    totalRows?: number;
    data?: ConfigEntity[] | undefined;

    constructor(data?: IFilterResult_1OfConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConfigEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfConfigEntity {
    totalRows?: number;
    data?: ConfigEntity[] | undefined;
}

export class FilterResult_1OfFileEntity implements IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;

    constructor(data?: IFilterResult_1OfFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FileEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfFileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfFileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfFileEntity {
    totalRows?: number;
    data?: FileEntity[] | undefined;
}

export class FilterResult_1OfLocalityEntity implements IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;

    constructor(data?: IFilterResult_1OfLocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LocalityEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfLocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfLocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfLocalityEntity {
    totalRows?: number;
    data?: LocalityEntity[] | undefined;
}

export class FilterResult_1OfScholarShipEntity implements IFilterResult_1OfScholarShipEntity {
    totalRows?: number;
    data?: ScholarShipEntity[] | undefined;

    constructor(data?: IFilterResult_1OfScholarShipEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRows = _data["totalRows"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ScholarShipEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResult_1OfScholarShipEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResult_1OfScholarShipEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRows"] = this.totalRows;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResult_1OfScholarShipEntity {
    totalRows?: number;
    data?: ScholarShipEntity[] | undefined;
}

export class CategoryEntity implements ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    type?: CategoryTypeEnum;
    trainingTypes?: number[] | undefined;

    constructor(data?: ICategoryEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.code = _data["code"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.path = _data["path"];
            this.icon = _data["icon"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): CategoryEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["code"] = this.code;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["path"] = this.path;
        data["icon"] = this.icon;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        return data;
    }
}

export interface ICategoryEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    code?: string | undefined;
    parentId?: number;
    level?: number;
    path?: string | undefined;
    icon?: string | undefined;
    status?: CommonStatusEnum;
    type?: CategoryTypeEnum;
    trainingTypes?: number[] | undefined;
}

export class ChatGroupEntity implements IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;

    constructor(data?: IChatGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.avatar = _data["avatar"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.documentId = _data["documentId"];
        }
    }

    static fromJS(data: any): ChatGroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ChatGroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["avatar"] = this.avatar;
        data["status"] = this.status;
        data["type"] = this.type;
        data["documentId"] = this.documentId;
        return data;
    }
}

export interface IChatGroupEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    avatar?: string | undefined;
    status?: number | undefined;
    type?: number | undefined;
    documentId?: number | undefined;
}

export class ConfigEntity implements IConfigEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;

    constructor(data?: IConfigEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.type = _data["type"];
            this.isSystem = _data["isSystem"];
            this.groupType = _data["groupType"];
        }
    }

    static fromJS(data: any): ConfigEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["key"] = this.key;
        data["name"] = this.name;
        data["value"] = this.value;
        data["type"] = this.type;
        data["isSystem"] = this.isSystem;
        data["groupType"] = this.groupType;
        return data;
    }
}

export interface IConfigEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    key?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    type?: ConfigTypeEnum;
    isSystem?: boolean;
    groupType?: string | undefined;
}

export enum ConfigTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class FeeScheduleEntity implements IFeeScheduleEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    majorId?: number;
    tuitionFee?: number;
    minus?: boolean;
    academicYearId?: number;
    trainingType?: number;
    periodNumber?: number;
    admissionFee?: number;
    extra?: number;
    extraDetail?: number[] | undefined;
    otherFee?: number;

    constructor(data?: IFeeScheduleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.majorId = _data["majorId"];
            this.tuitionFee = _data["tuitionFee"];
            this.minus = _data["minus"];
            this.academicYearId = _data["academicYearId"];
            this.trainingType = _data["trainingType"];
            this.periodNumber = _data["periodNumber"];
            this.admissionFee = _data["admissionFee"];
            this.extra = _data["extra"];
            if (Array.isArray(_data["extraDetail"])) {
                this.extraDetail = [] as any;
                for (let item of _data["extraDetail"])
                    this.extraDetail!.push(item);
            }
            this.otherFee = _data["otherFee"];
        }
    }

    static fromJS(data: any): FeeScheduleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FeeScheduleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["majorId"] = this.majorId;
        data["tuitionFee"] = this.tuitionFee;
        data["minus"] = this.minus;
        data["academicYearId"] = this.academicYearId;
        data["trainingType"] = this.trainingType;
        data["periodNumber"] = this.periodNumber;
        data["admissionFee"] = this.admissionFee;
        data["extra"] = this.extra;
        if (Array.isArray(this.extraDetail)) {
            data["extraDetail"] = [];
            for (let item of this.extraDetail)
                data["extraDetail"].push(item);
        }
        data["otherFee"] = this.otherFee;
        return data;
    }
}

export interface IFeeScheduleEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    majorId?: number;
    tuitionFee?: number;
    minus?: boolean;
    academicYearId?: number;
    trainingType?: number;
    periodNumber?: number;
    admissionFee?: number;
    extra?: number;
    extraDetail?: number[] | undefined;
    otherFee?: number;
}

export class FileEntity implements IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;

    constructor(data?: IFileEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.contentType = _data["contentType"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.size = _data["size"];
            this.extension = _data["extension"];
            this.folderId = _data["folderId"];
            this.status = _data["status"];
            this.avatar = _data["avatar"];
            this.thumbnails = _data["thumbnails"];
            this.streamUrl = _data["streamUrl"];
            this.duration = _data["duration"];
            this.fileType = _data["fileType"];
            this.objectType = _data["objectType"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["metaDatas"])) {
                this.metaDatas = [] as any;
                for (let item of _data["metaDatas"])
                    this.metaDatas!.push(FileMetaDataEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["path"] = this.path;
        data["contentType"] = this.contentType;
        data["width"] = this.width;
        data["height"] = this.height;
        data["size"] = this.size;
        data["extension"] = this.extension;
        data["folderId"] = this.folderId;
        data["status"] = this.status;
        data["avatar"] = this.avatar;
        data["thumbnails"] = this.thumbnails;
        data["streamUrl"] = this.streamUrl;
        data["duration"] = this.duration;
        data["fileType"] = this.fileType;
        data["objectType"] = this.objectType;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.metaDatas)) {
            data["metaDatas"] = [];
            for (let item of this.metaDatas)
                data["metaDatas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    path?: string | undefined;
    contentType?: string | undefined;
    width?: number;
    height?: number;
    size?: number;
    extension?: string | undefined;
    folderId?: number;
    status?: number;
    avatar?: string | undefined;
    thumbnails?: string | undefined;
    streamUrl?: string | undefined;
    duration?: number;
    fileType?: string | undefined;
    objectType?: number;
    parentId?: number | undefined;
    metaDatas?: FileMetaDataEntity[] | undefined;
}

export class FileMetaDataEntity implements IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;

    constructor(data?: IFileMetaDataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.fileId = _data["fileId"];
            this.metaDirectory = _data["metaDirectory"];
            this.metaKey = _data["metaKey"];
            this.metaValue = _data["metaValue"];
        }
    }

    static fromJS(data: any): FileMetaDataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FileMetaDataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["fileId"] = this.fileId;
        data["metaDirectory"] = this.metaDirectory;
        data["metaKey"] = this.metaKey;
        data["metaValue"] = this.metaValue;
        return data;
    }
}

export interface IFileMetaDataEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    fileId?: number;
    metaDirectory?: string | undefined;
    metaKey?: string | undefined;
    metaValue?: string | undefined;
}

export class FolderEntity implements IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;

    constructor(data?: IFolderEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): FolderEntity {
        data = typeof data === 'object' ? data : {};
        let result = new FolderEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IFolderEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    parentId?: number;
}

export class LocalityEntity implements ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;

    constructor(data?: ILocalityEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.otherName = _data["otherName"];
            this.url = _data["url"];
            this.unitType = _data["unitType"];
            this.parentId = _data["parentId"];
            this.priority = _data["priority"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LocalityEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LocalityEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["code"] = this.code;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["otherName"] = this.otherName;
        data["url"] = this.url;
        data["unitType"] = this.unitType;
        data["parentId"] = this.parentId;
        data["priority"] = this.priority;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface ILocalityEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    code?: string | undefined;
    name?: string | undefined;
    fullName?: string | undefined;
    otherName?: string | undefined;
    url?: string | undefined;
    unitType?: string | undefined;
    parentId?: number;
    priority?: number;
    type?: LocalityTypeEnum;
    status?: LocalityStatusEnum;
}

export enum LocalityTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class UserMobileTokenEntity implements IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;

    constructor(data?: IUserMobileTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.deviceToken = _data["deviceToken"];
            this.os = _data["os"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserMobileTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserMobileTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["deviceToken"] = this.deviceToken;
        data["os"] = this.os;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserMobileTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    deviceToken?: string | undefined;
    os?: string | undefined;
    appId?: number;
}

export class UserWebTokenEntity implements IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;

    constructor(data?: IUserWebTokenEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.pushEndPoint = _data["pushEndPoint"];
            this.pushP256DH = _data["pushP256DH"];
            this.pushAuth = _data["pushAuth"];
            this.appId = _data["appId"];
        }
    }

    static fromJS(data: any): UserWebTokenEntity {
        data = typeof data === 'object' ? data : {};
        let result = new UserWebTokenEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["pushEndPoint"] = this.pushEndPoint;
        data["pushP256DH"] = this.pushP256DH;
        data["pushAuth"] = this.pushAuth;
        data["appId"] = this.appId;
        return data;
    }
}

export interface IUserWebTokenEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    pushEndPoint?: string | undefined;
    pushP256DH?: string | undefined;
    pushAuth?: string | undefined;
    appId?: number;
}

export class ObjectPermissionDetailEntity implements IObjectPermissionDetailEntity {
    id?: number;
    objectPermissionId?: number;
    fullCategory?: boolean;
    categoryIds?: number[] | undefined;
    permission?: number;
    objectPermission?: ObjectPermissionEntity;

    constructor(data?: IObjectPermissionDetailEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectPermissionId = _data["objectPermissionId"];
            this.fullCategory = _data["fullCategory"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.permission = _data["permission"];
            this.objectPermission = _data["objectPermission"] ? ObjectPermissionEntity.fromJS(_data["objectPermission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ObjectPermissionDetailEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectPermissionDetailEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectPermissionId"] = this.objectPermissionId;
        data["fullCategory"] = this.fullCategory;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["permission"] = this.permission;
        data["objectPermission"] = this.objectPermission ? this.objectPermission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IObjectPermissionDetailEntity {
    id?: number;
    objectPermissionId?: number;
    fullCategory?: boolean;
    categoryIds?: number[] | undefined;
    permission?: number;
    objectPermission?: ObjectPermissionEntity;
}

export class ObjectPermissionEntity implements IObjectPermissionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectTypeEnum;
    module?: ModuleEnum;
    isCategory?: boolean;
    isFull?: boolean;
    permissions?: ObjectPermissionDetailEntity[] | undefined;

    constructor(data?: IObjectPermissionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.module = _data["module"];
            this.isCategory = _data["isCategory"];
            this.isFull = _data["isFull"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(ObjectPermissionDetailEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjectPermissionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectPermissionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["module"] = this.module;
        data["isCategory"] = this.isCategory;
        data["isFull"] = this.isFull;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IObjectPermissionEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    objectId?: number;
    objectType?: ObjectTypeEnum;
    module?: ModuleEnum;
    isCategory?: boolean;
    isFull?: boolean;
    permissions?: ObjectPermissionDetailEntity[] | undefined;
}

export class ScholarShipEntity implements IScholarShipEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    amount?: number;
    quantity?: number;
    objectType?: ScholarShipTypeEnum;
    academicYearId?: number;
    trainingTypes?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amountDetail?: number[] | undefined;
    usedCount?: number;

    constructor(data?: IScholarShipEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.objectType = _data["objectType"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["trainingTypes"])) {
                this.trainingTypes = [] as any;
                for (let item of _data["trainingTypes"])
                    this.trainingTypes!.push(item);
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["amountDetail"])) {
                this.amountDetail = [] as any;
                for (let item of _data["amountDetail"])
                    this.amountDetail!.push(item);
            }
            this.usedCount = _data["usedCount"];
        }
    }

    static fromJS(data: any): ScholarShipEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ScholarShipEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["objectType"] = this.objectType;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.trainingTypes)) {
            data["trainingTypes"] = [];
            for (let item of this.trainingTypes)
                data["trainingTypes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.amountDetail)) {
            data["amountDetail"] = [];
            for (let item of this.amountDetail)
                data["amountDetail"].push(item);
        }
        data["usedCount"] = this.usedCount;
        return data;
    }
}

export interface IScholarShipEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    amount?: number;
    quantity?: number;
    objectType?: ScholarShipTypeEnum;
    academicYearId?: number;
    trainingTypes?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amountDetail?: number[] | undefined;
    usedCount?: number;
}

export enum ScholarShipTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class AcademicYearEntity implements IAcademicYearEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    startPeriod1?: Date | undefined;
    startPeriod2?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;

    constructor(data?: IAcademicYearEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.startPeriod1 = _data["startPeriod1"] ? new Date(_data["startPeriod1"].toString()) : <any>undefined;
            this.startPeriod2 = _data["startPeriod2"] ? new Date(_data["startPeriod2"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AcademicYearEntity {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicYearEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["startPeriod1"] = this.startPeriod1 ? this.startPeriod1.toISOString() : <any>undefined;
        data["startPeriod2"] = this.startPeriod2 ? this.startPeriod2.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IAcademicYearEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    startPeriod1?: Date | undefined;
    startPeriod2?: Date | undefined;
    end?: Date | undefined;
    name?: string | undefined;
}

export class ClassEntity implements IClassEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;

    constructor(data?: IClassEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.academicYearId = _data["academicYearId"];
            if (Array.isArray(_data["academicYearIds"])) {
                this.academicYearIds = [] as any;
                for (let item of _data["academicYearIds"])
                    this.academicYearIds!.push(item);
            }
            this.trainingType = _data["trainingType"];
            this.classType = _data["classType"];
            this.major = _data["major"];
            this.maxStudent = _data["maxStudent"];
            this.status = _data["status"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["academicYearId"] = this.academicYearId;
        if (Array.isArray(this.academicYearIds)) {
            data["academicYearIds"] = [];
            for (let item of this.academicYearIds)
                data["academicYearIds"].push(item);
        }
        data["trainingType"] = this.trainingType;
        data["classType"] = this.classType;
        data["major"] = this.major;
        data["maxStudent"] = this.maxStudent;
        data["status"] = this.status;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClassEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    academicYearId?: number;
    academicYearIds?: number[] | undefined;
    trainingType?: number;
    classType?: ClassTypeEnum;
    major?: number;
    maxStudent?: number;
    status?: ClassStatusEnum;
    classUsers?: ClassUserEntity[] | undefined;
}

export class ClassUserEntity implements IClassUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    classId?: number;
    role?: ClassUserRoleEnum;
    status?: StudentStatusEnum;
    note?: string | undefined;
    isManager?: boolean;

    constructor(data?: IClassUserEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.classId = _data["classId"];
            this.role = _data["role"];
            this.status = _data["status"];
            this.note = _data["note"];
            this.isManager = _data["isManager"];
        }
    }

    static fromJS(data: any): ClassUserEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ClassUserEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["classId"] = this.classId;
        data["role"] = this.role;
        data["status"] = this.status;
        data["note"] = this.note;
        data["isManager"] = this.isManager;
        return data;
    }
}

export interface IClassUserEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    classId?: number;
    role?: ClassUserRoleEnum;
    status?: StudentStatusEnum;
    note?: string | undefined;
    isManager?: boolean;
}

export class ComponentScoreEntity implements IComponentScoreEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    averageScore?: number | undefined;
    isEligibleForExam?: boolean;
    note?: string | undefined;

    constructor(data?: IComponentScoreEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.subjectId = _data["subjectId"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.regularScores = _data["regularScores"];
            this.periodicScores = _data["periodicScores"];
            this.averageScore = _data["averageScore"];
            this.isEligibleForExam = _data["isEligibleForExam"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ComponentScoreEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentScoreEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["subjectId"] = this.subjectId;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["regularScores"] = this.regularScores;
        data["periodicScores"] = this.periodicScores;
        data["averageScore"] = this.averageScore;
        data["isEligibleForExam"] = this.isEligibleForExam;
        data["note"] = this.note;
        return data;
    }
}

export interface IComponentScoreEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    regularScores?: string | undefined;
    periodicScores?: string | undefined;
    averageScore?: number | undefined;
    isEligibleForExam?: boolean;
    note?: string | undefined;
}

export class SubjectEntity implements ISubjectEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    major?: number;
    trainingType?: number;
    academicYearId?: number;
    semester?: number;
    credits?: number;
    componentWeight?: number;
    examWeight?: number;
    minComponentScore?: number;
    description?: string | undefined;
    fileUrl?: string | undefined;
    status?: CommonStatusEnum;

    constructor(data?: ISubjectEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.major = _data["major"];
            this.trainingType = _data["trainingType"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.credits = _data["credits"];
            this.componentWeight = _data["componentWeight"];
            this.examWeight = _data["examWeight"];
            this.minComponentScore = _data["minComponentScore"];
            this.description = _data["description"];
            this.fileUrl = _data["fileUrl"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubjectEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["major"] = this.major;
        data["trainingType"] = this.trainingType;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["credits"] = this.credits;
        data["componentWeight"] = this.componentWeight;
        data["examWeight"] = this.examWeight;
        data["minComponentScore"] = this.minComponentScore;
        data["description"] = this.description;
        data["fileUrl"] = this.fileUrl;
        data["status"] = this.status;
        return data;
    }
}

export interface ISubjectEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    major?: number;
    trainingType?: number;
    academicYearId?: number;
    semester?: number;
    credits?: number;
    componentWeight?: number;
    examWeight?: number;
    minComponentScore?: number;
    description?: string | undefined;
    fileUrl?: string | undefined;
    status?: CommonStatusEnum;
}

export class SubjectScoreEntity implements ISubjectScoreEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    finalScore?: number | undefined;
    letterGrade?: string | undefined;
    gradePoint?: number | undefined;
    status?: SubjectScoreStatusEnum;
    note?: string | undefined;

    constructor(data?: ISubjectScoreEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.subjectId = _data["subjectId"];
            this.classId = _data["classId"];
            this.academicYearId = _data["academicYearId"];
            this.semester = _data["semester"];
            this.componentAverage = _data["componentAverage"];
            this.finalExamScore = _data["finalExamScore"];
            this.retakeScore = _data["retakeScore"];
            this.finalScore = _data["finalScore"];
            this.letterGrade = _data["letterGrade"];
            this.gradePoint = _data["gradePoint"];
            this.status = _data["status"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SubjectScoreEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SubjectScoreEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["subjectId"] = this.subjectId;
        data["classId"] = this.classId;
        data["academicYearId"] = this.academicYearId;
        data["semester"] = this.semester;
        data["componentAverage"] = this.componentAverage;
        data["finalExamScore"] = this.finalExamScore;
        data["retakeScore"] = this.retakeScore;
        data["finalScore"] = this.finalScore;
        data["letterGrade"] = this.letterGrade;
        data["gradePoint"] = this.gradePoint;
        data["status"] = this.status;
        data["note"] = this.note;
        return data;
    }
}

export interface ISubjectScoreEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    subjectId?: number;
    classId?: number;
    academicYearId?: number;
    semester?: number;
    componentAverage?: number | undefined;
    finalExamScore?: number | undefined;
    retakeScore?: number | undefined;
    finalScore?: number | undefined;
    letterGrade?: string | undefined;
    gradePoint?: number | undefined;
    status?: SubjectScoreStatusEnum;
    note?: string | undefined;
}

export class ReceiptDetailEntity implements IReceiptDetailEntity {
    id?: number;
    name?: string | undefined;
    receiptId?: number;
    feeScheduleId?: number;
    scholarShipId?: number;
    amount?: number;
    detailType?: ReceiptDetailTypeEnum;

    constructor(data?: IReceiptDetailEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.receiptId = _data["receiptId"];
            this.feeScheduleId = _data["feeScheduleId"];
            this.scholarShipId = _data["scholarShipId"];
            this.amount = _data["amount"];
            this.detailType = _data["detailType"];
        }
    }

    static fromJS(data: any): ReceiptDetailEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDetailEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["receiptId"] = this.receiptId;
        data["feeScheduleId"] = this.feeScheduleId;
        data["scholarShipId"] = this.scholarShipId;
        data["amount"] = this.amount;
        data["detailType"] = this.detailType;
        return data;
    }
}

export interface IReceiptDetailEntity {
    id?: number;
    name?: string | undefined;
    receiptId?: number;
    feeScheduleId?: number;
    scholarShipId?: number;
    amount?: number;
    detailType?: ReceiptDetailTypeEnum;
}

export enum ReceiptDetailTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ReceiptEntity implements IReceiptEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;

    constructor(data?: IReceiptEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.studentId = _data["studentId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.statusProcess = _data["statusProcess"];
            this.paymentMethod = _data["paymentMethod"];
            this.receiptType = _data["receiptType"];
            this.paid = _data["paid"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.period = _data["period"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ReceiptDetailEntity.fromJS(item));
            }
            this.qrContent = _data["qrContent"];
            this.bankAccountId = _data["bankAccountId"];
            this.isAuto = _data["isAuto"];
            this.isNofify = _data["isNofify"];
            this.transactionLog = _data["transactionLog"];
            this.image = _data["image"];
            this.deposit = _data["deposit"];
            this.previousBalance = _data["previousBalance"];
        }
    }

    static fromJS(data: any): ReceiptEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["studentId"] = this.studentId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["statusProcess"] = this.statusProcess;
        data["paymentMethod"] = this.paymentMethod;
        data["receiptType"] = this.receiptType;
        data["paid"] = this.paid;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["period"] = this.period;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["qrContent"] = this.qrContent;
        data["bankAccountId"] = this.bankAccountId;
        data["isAuto"] = this.isAuto;
        data["isNofify"] = this.isNofify;
        data["transactionLog"] = this.transactionLog;
        data["image"] = this.image;
        data["deposit"] = this.deposit;
        data["previousBalance"] = this.previousBalance;
        return data;
    }
}

export interface IReceiptEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    studentId?: number;
    code?: string | undefined;
    name?: string | undefined;
    amount?: number;
    status?: ReceiptStatusEnum;
    statusProcess?: ReceiptProcessStatusEnum;
    paymentMethod?: PaymentMethodEnum;
    receiptType?: ReceiptTypeEnum;
    paid?: number;
    paidDate?: Date | undefined;
    note?: string | undefined;
    period?: number;
    details?: ReceiptDetailEntity[] | undefined;
    qrContent?: string | undefined;
    bankAccountId?: number;
    isAuto?: boolean;
    isNofify?: boolean;
    transactionLog?: string | undefined;
    image?: string | undefined;
    deposit?: number | undefined;
    previousBalance?: number | undefined;
}

export enum ReceiptTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class StudentEntity implements IStudentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    userId?: number;
    studentCodeTemp?: string | undefined;
    studentCode?: string | undefined;
    profileCode?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    email?: string | undefined;
    isEmailGenerated?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    temporaryAddress?: string | undefined;
    admissionDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    motherStatus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    fatherStatus?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    personalEmail?: string | undefined;
    trainingType?: number;
    major?: number;
    department?: number;
    facility?: number;
    note?: string | undefined;
    schoolName?: string | undefined;
    schoolProvinceId?: number;
    provinceId?: number;
    placeOfBirth?: string | undefined;
    ethnic?: string | undefined;
    identityCardNumber?: string | undefined;
    studentObjectType?: number;
    academicYearId?: number;
    startAcademicYearId?: number;
    documentStatus?: StudentDocumentStatusEnum;
    step?: StudentStepEnum;
    status?: StudentProcessStatusEnum;
    sendBy?: number;
    sendDate?: Date | undefined;
    accountingBy?: number;
    accountingDate?: Date | undefined;
    affairBy?: number;
    affairDate?: Date | undefined;
    processNote?: string | undefined;
    scholarShipId?: number;
    index?: number;
    trainingFacility?: number;
    guidId?: string | undefined;
    deposit?: number | undefined;
    classUsers?: ClassUserEntity[] | undefined;
    receipts?: ReceiptEntity[] | undefined;

    constructor(data?: IStudentEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.studentCodeTemp = _data["studentCodeTemp"];
            this.studentCode = _data["studentCode"];
            this.profileCode = _data["profileCode"];
            this.fullName = _data["fullName"];
            this.avatar = _data["avatar"];
            this.birthDay = _data["birthDay"] ? new Date(_data["birthDay"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.email = _data["email"];
            this.isEmailGenerated = _data["isEmailGenerated"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.temporaryAddress = _data["temporaryAddress"];
            this.admissionDate = _data["admissionDate"] ? new Date(_data["admissionDate"].toString()) : <any>undefined;
            this.admissionsConsultantName = _data["admissionsConsultantName"];
            this.motherName = _data["motherName"];
            this.motherPhone = _data["motherPhone"];
            this.motherStatus = _data["motherStatus"];
            this.fatherName = _data["fatherName"];
            this.fatherPhone = _data["fatherPhone"];
            this.fatherStatus = _data["fatherStatus"];
            this.guardianName = _data["guardianName"];
            this.guardianPhone = _data["guardianPhone"];
            this.personalEmail = _data["personalEmail"];
            this.trainingType = _data["trainingType"];
            this.major = _data["major"];
            this.department = _data["department"];
            this.facility = _data["facility"];
            this.note = _data["note"];
            this.schoolName = _data["schoolName"];
            this.schoolProvinceId = _data["schoolProvinceId"];
            this.provinceId = _data["provinceId"];
            this.placeOfBirth = _data["placeOfBirth"];
            this.ethnic = _data["ethnic"];
            this.identityCardNumber = _data["identityCardNumber"];
            this.studentObjectType = _data["studentObjectType"];
            this.academicYearId = _data["academicYearId"];
            this.startAcademicYearId = _data["startAcademicYearId"];
            this.documentStatus = _data["documentStatus"];
            this.step = _data["step"];
            this.status = _data["status"];
            this.sendBy = _data["sendBy"];
            this.sendDate = _data["sendDate"] ? new Date(_data["sendDate"].toString()) : <any>undefined;
            this.accountingBy = _data["accountingBy"];
            this.accountingDate = _data["accountingDate"] ? new Date(_data["accountingDate"].toString()) : <any>undefined;
            this.affairBy = _data["affairBy"];
            this.affairDate = _data["affairDate"] ? new Date(_data["affairDate"].toString()) : <any>undefined;
            this.processNote = _data["processNote"];
            this.scholarShipId = _data["scholarShipId"];
            this.index = _data["index"];
            this.trainingFacility = _data["trainingFacility"];
            this.guidId = _data["guidId"];
            this.deposit = _data["deposit"];
            if (Array.isArray(_data["classUsers"])) {
                this.classUsers = [] as any;
                for (let item of _data["classUsers"])
                    this.classUsers!.push(ClassUserEntity.fromJS(item));
            }
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ReceiptEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StudentEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StudentEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["studentCodeTemp"] = this.studentCodeTemp;
        data["studentCode"] = this.studentCode;
        data["profileCode"] = this.profileCode;
        data["fullName"] = this.fullName;
        data["avatar"] = this.avatar;
        data["birthDay"] = this.birthDay ? this.birthDay.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["email"] = this.email;
        data["isEmailGenerated"] = this.isEmailGenerated;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["temporaryAddress"] = this.temporaryAddress;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data["admissionsConsultantName"] = this.admissionsConsultantName;
        data["motherName"] = this.motherName;
        data["motherPhone"] = this.motherPhone;
        data["motherStatus"] = this.motherStatus;
        data["fatherName"] = this.fatherName;
        data["fatherPhone"] = this.fatherPhone;
        data["fatherStatus"] = this.fatherStatus;
        data["guardianName"] = this.guardianName;
        data["guardianPhone"] = this.guardianPhone;
        data["personalEmail"] = this.personalEmail;
        data["trainingType"] = this.trainingType;
        data["major"] = this.major;
        data["department"] = this.department;
        data["facility"] = this.facility;
        data["note"] = this.note;
        data["schoolName"] = this.schoolName;
        data["schoolProvinceId"] = this.schoolProvinceId;
        data["provinceId"] = this.provinceId;
        data["placeOfBirth"] = this.placeOfBirth;
        data["ethnic"] = this.ethnic;
        data["identityCardNumber"] = this.identityCardNumber;
        data["studentObjectType"] = this.studentObjectType;
        data["academicYearId"] = this.academicYearId;
        data["startAcademicYearId"] = this.startAcademicYearId;
        data["documentStatus"] = this.documentStatus;
        data["step"] = this.step;
        data["status"] = this.status;
        data["sendBy"] = this.sendBy;
        data["sendDate"] = this.sendDate ? this.sendDate.toISOString() : <any>undefined;
        data["accountingBy"] = this.accountingBy;
        data["accountingDate"] = this.accountingDate ? this.accountingDate.toISOString() : <any>undefined;
        data["affairBy"] = this.affairBy;
        data["affairDate"] = this.affairDate ? this.affairDate.toISOString() : <any>undefined;
        data["processNote"] = this.processNote;
        data["scholarShipId"] = this.scholarShipId;
        data["index"] = this.index;
        data["trainingFacility"] = this.trainingFacility;
        data["guidId"] = this.guidId;
        data["deposit"] = this.deposit;
        if (Array.isArray(this.classUsers)) {
            data["classUsers"] = [];
            for (let item of this.classUsers)
                data["classUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStudentEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    userId?: number;
    studentCodeTemp?: string | undefined;
    studentCode?: string | undefined;
    profileCode?: string | undefined;
    fullName?: string | undefined;
    avatar?: string | undefined;
    birthDay?: Date | undefined;
    gender?: number | undefined;
    email?: string | undefined;
    isEmailGenerated?: boolean;
    phoneNumber?: string | undefined;
    address?: string | undefined;
    temporaryAddress?: string | undefined;
    admissionDate?: Date | undefined;
    admissionsConsultantName?: string | undefined;
    motherName?: string | undefined;
    motherPhone?: string | undefined;
    motherStatus?: string | undefined;
    fatherName?: string | undefined;
    fatherPhone?: string | undefined;
    fatherStatus?: string | undefined;
    guardianName?: string | undefined;
    guardianPhone?: string | undefined;
    personalEmail?: string | undefined;
    trainingType?: number;
    major?: number;
    department?: number;
    facility?: number;
    note?: string | undefined;
    schoolName?: string | undefined;
    schoolProvinceId?: number;
    provinceId?: number;
    placeOfBirth?: string | undefined;
    ethnic?: string | undefined;
    identityCardNumber?: string | undefined;
    studentObjectType?: number;
    academicYearId?: number;
    startAcademicYearId?: number;
    documentStatus?: StudentDocumentStatusEnum;
    step?: StudentStepEnum;
    status?: StudentProcessStatusEnum;
    sendBy?: number;
    sendDate?: Date | undefined;
    accountingBy?: number;
    accountingDate?: Date | undefined;
    affairBy?: number;
    affairDate?: Date | undefined;
    processNote?: string | undefined;
    scholarShipId?: number;
    index?: number;
    trainingFacility?: number;
    guidId?: string | undefined;
    deposit?: number | undefined;
    classUsers?: ClassUserEntity[] | undefined;
    receipts?: ReceiptEntity[] | undefined;
}

export class StudentStatusEntity implements IStudentStatusEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    readonly isDeleted?: boolean;
    status1?: StudentStatusEnum;
    status2?: StudentStatusEnum;
    studentId?: number;
    reason?: number;
    note?: string | undefined;
    statusDate?: Date;
    classId?: number;

    constructor(data?: IStudentStatusEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            (<any>this).isDeleted = _data["isDeleted"];
            this.status1 = _data["status1"];
            this.status2 = _data["status2"];
            this.studentId = _data["studentId"];
            this.reason = _data["reason"];
            this.note = _data["note"];
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : <any>undefined;
            this.classId = _data["classId"];
        }
    }

    static fromJS(data: any): StudentStatusEntity {
        data = typeof data === 'object' ? data : {};
        let result = new StudentStatusEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["status1"] = this.status1;
        data["status2"] = this.status2;
        data["studentId"] = this.studentId;
        data["reason"] = this.reason;
        data["note"] = this.note;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["classId"] = this.classId;
        return data;
    }
}

export interface IStudentStatusEntity {
    id?: number;
    createdBy?: number;
    createdDate?: Date;
    lastModifiedBy?: number;
    lastModifiedDate?: Date;
    isDeleted?: boolean;
    status1?: StudentStatusEnum;
    status2?: StudentStatusEnum;
    studentId?: number;
    reason?: number;
    note?: string | undefined;
    statusDate?: Date;
    classId?: number;
}

export enum FileStatusEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum ObjectTypeEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class QrGenerateResponseDto implements IQrGenerateResponseDto {
    qrContent?: string | undefined;
    bankAccount?: BankAccountDto;

    constructor(data?: IQrGenerateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrContent = _data["qrContent"];
            this.bankAccount = _data["bankAccount"] ? BankAccountDto.fromJS(_data["bankAccount"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QrGenerateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new QrGenerateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrContent"] = this.qrContent;
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQrGenerateResponseDto {
    qrContent?: string | undefined;
    bankAccount?: BankAccountDto;
}

export class SeedResult implements ISeedResult {
    message?: string | undefined;
    subjectsCreated?: number;
    componentScoresCreated?: number;
    subjectScoresCreated?: number;
    conductScoresCreated?: number;
    transcriptsCreated?: number;

    constructor(data?: ISeedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.subjectsCreated = _data["subjectsCreated"];
            this.componentScoresCreated = _data["componentScoresCreated"];
            this.subjectScoresCreated = _data["subjectScoresCreated"];
            this.conductScoresCreated = _data["conductScoresCreated"];
            this.transcriptsCreated = _data["transcriptsCreated"];
        }
    }

    static fromJS(data: any): SeedResult {
        data = typeof data === 'object' ? data : {};
        let result = new SeedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["subjectsCreated"] = this.subjectsCreated;
        data["componentScoresCreated"] = this.componentScoresCreated;
        data["subjectScoresCreated"] = this.subjectScoresCreated;
        data["conductScoresCreated"] = this.conductScoresCreated;
        data["transcriptsCreated"] = this.transcriptsCreated;
        return data;
    }
}

export interface ISeedResult {
    message?: string | undefined;
    subjectsCreated?: number;
    componentScoresCreated?: number;
    subjectScoresCreated?: number;
    conductScoresCreated?: number;
    transcriptsCreated?: number;
}

export class VapidDetails implements IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;

    constructor(data?: IVapidDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.publicKey = _data["publicKey"];
            this.privateKey = _data["privateKey"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any): VapidDetails {
        data = typeof data === 'object' ? data : {};
        let result = new VapidDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["publicKey"] = this.publicKey;
        data["privateKey"] = this.privateKey;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface IVapidDetails {
    subject?: string | undefined;
    publicKey?: string | undefined;
    privateKey?: string | undefined;
    expiration?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class BearException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isBearException = true;

    static isBearException(obj: any): obj is BearException {
        return obj.isBearException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new BearException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}